import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Form, Row, Col, Badge, Modal, Dropdown,
  Spinner, OverlayTrigger, Tooltip, InputGroup, Pagination, Toast, ToastContainer
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const DataClaimBpjs = () => {
  const navigate = useNavigate();

  // Helper IP API
  const getApiUrl = () => {
    const saved = localStorage.getItem('apiUrl') || localStorage.getItem('api_url');
    if (saved && saved.trim()) return saved.trim().replace(/\/+$/, '');
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
      return `http://${window.location.hostname}:8000`;
    }
    return 'http://202.155.94.169:8080';
  };

  // State Data & Loading
  const [claimList, setClaimList]   = useState([]);
  const [isLoading, setIsLoading]   = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [bridgingConfig, setBridgingConfig] = useState(null);

  useEffect(() => {
    fetch(`${getApiUrl()}/setup_bridging`)
      .then(r => r.json())
      .then(d => {
        if (!d.msg) setBridgingConfig(d);
      })
      .catch(err => console.error('Gagal memuat setup bridging:', err));
  }, []);

  const getEklaimParams = () => {
    if (!bridgingConfig) return {};
    return {
      endpoint_url: bridgingConfig.ECLAIM_URL,
      encryption_key: bridgingConfig.ECLAIM_KEY,
      kode_tarif: bridgingConfig.KODE_TARIF,
      coder_nik: bridgingConfig.ECLAIM_CODER_NIK
    };
  };

  // State Clock
  const [time, setTime] = useState({ date: '', clock: '' });

  // State Filter & Pagination
  const [searchQuery, setSearchQuery] = useState('');
  const [filterSepStatus, setFilterSepStatus] = useState(''); // '', 'ADA', 'KOSONG'
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // State Modal Edit SEP
  const [showEditSepModal, setShowEditSepModal] = useState(false);
  const [selectedPatient, setSelectedPatient]   = useState(null);
  const [inputNoSep, setInputNoSep]             = useState('');
  const [isSavingSep, setIsSavingSep]           = useState(false);
  const [sepFeedback, setSepFeedback]           = useState(null);

  // State Modal Grouper E-Claim
  const [showGrouperModal, setShowGrouperModal] = useState(false);
  const [grouperTarget, setGrouperTarget]       = useState(null);
  const [isGrouping, setIsGrouping]             = useState(false);
  const [grouperResult, setGrouperResult]       = useState(null);
  const [inputSitb, setInputSitb]               = useState('');
  const [isValidatingSitb, setIsValidatingSitb] = useState(false);
  const [sitbValidationResult, setSitbValidationResult] = useState(null);

  // State Integrasi EHR (get_ehr_medical_info)
  const [ehrData, setEhrData]                           = useState(null);
  const [isLoadingEhr, setIsLoadingEhr]                 = useState(false);
  const [ehrError, setEhrError]                         = useState(null);
  const [showEhrDetail, setShowEhrDetail]               = useState(false);
  const [activeEhrFormTab, setActiveEhrFormTab]         = useState('resume'); // 'resume' | 'ringkasan' | 'asesmen' | 'cppt' | 'resume_rajal'

  // State Modal Peringatan SEP Kosong
  const [showSepWarningModal, setShowSepWarningModal]   = useState(false);
  const [warningPatientTarget, setWarningPatientTarget] = useState(null);

  // State Diagnosa & Prosedur (/show_diagnosa)
  const [selectedDiagnosaItem, setSelectedDiagnosaItem] = useState(null);
  const [diagnosaData, setDiagnosaData]                 = useState({ list_diagnosa: [], list_prosedur: [] });
  const [isLoadingDiagnosa, setIsLoadingDiagnosa]       = useState(false);
  const [activeTabDiagnosa, setActiveTabDiagnosa]       = useState('diagnosa'); // 'diagnosa' | 'prosedur'
  const [actionModal, setActionModal] = useState({ show: false, type: '', title: '', item: null, loading: false, result: null });
  const [isSendingOnline, setIsSendingOnline]           = useState(false);
  const [showInlineInput, setShowInlineInput]           = useState(true);

  // ── State Input Diagnosa & Prosedur Modal (BPJS: diagnosa2 & diagnosa3) ──
  const [showInputDiagnosaModal, setShowInputDiagnosaModal] = useState(false);
  const [inputDiagnosaType, setInputDiagnosaType]           = useState('diagnosa'); // 'diagnosa' | 'prosedur'
  const [masterIcd10, setMasterIcd10]                       = useState([]);
  const [masterIcd9, setMasterIcd9]                         = useState([]);
  const [isLoadingMasterIcd, setIsLoadingMasterIcd]         = useState(false);
  const [showIcd10Autocomplete, setShowIcd10Autocomplete]   = useState(false);
  const [showIcd9Autocomplete, setShowIcd9Autocomplete]     = useState(false);
  const [formInputDiagnosa, setFormInputDiagnosa]           = useState({
    kd_icd: '',
    nm_icd: '',
    ket: 'Utama',
    utama: 1,
    multiplicity: 1,
    kd_dokter: '',
    nm_dokter: '',
    tanggal: '',
    jam: '',
    lokasi: 'Rawat Inap',
    petugas: ''
  });
  const [isCheckingIcd, setIsCheckingIcd]                   = useState(false);
  const [icdCheckMsg, _rawSetIcdCheckMsg]                   = useState(null);
  const setIcdCheckMsg = (msg) => {
    if (msg && typeof msg === 'object' && /header code/i.test(msg.text || '')) {
      _rawSetIcdCheckMsg(null);
      return;
    }
    _rawSetIcdCheckMsg(msg);
  };
  const [isSavingDiagnosa, setIsSavingDiagnosa]             = useState(false);

  // State Modal Tabel Master ICD
  const [showMasterIcdModal, setShowMasterIcdModal]         = useState(false);
  const [masterIcdModalSearch, setMasterIcdModalSearch]     = useState('');
  const [masterIcdCurrentPage, setMasterIcdCurrentPage]     = useState(1);
  const masterIcdItemsPerPage                               = 15;

  // State Modal Konfirmasi Hapus Diagnosa / Prosedur
  const [deleteConfirmModal, setDeleteConfirmModal]         = useState({
    show: false,
    item: null,
    type: 'diagnosa',
    isDeleting: false
  });

  // ── Toast Notification State ──
  const [toastNotif, setToastNotif] = useState({
    show: false,
    type: 'info',
    title: '',
    message: ''
  });

  const notify = (type, title, message) => {
    if (/header code/i.test(title || '') || /header code/i.test(message || '')) {
      return;
    }
    setToastNotif({
      show: true,
      type,
      title,
      message
    });
  };


  const handleOpenAction = (item, type, title) => {
    setActionModal({ show: true, type, title, item, loading: false, result: null });
  };

  const handleSendClaimOnline = async (targetItem) => {
    const item = targetItem || actionModal.item;
    if (!item?.no_sep) {
      notify('warning', 'Peringatan', 'Nomor SEP tidak ditemukan untuk proses Kirim Klaim Online.');
      return;
    }
    setIsSendingOnline(true);
    const apiUrl = getApiUrl() || 'http://202.155.94.169:8080';
    try {
      const res = await fetch(`${apiUrl}/send_claim_individual`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ no_sep: item.no_sep, ...getEklaimParams() })
      });
      const json = await res.json();
      const isOk = json.status === 1 || json.status === '1' || (json.metadata && (json.metadata.code === 200 || json.metadata.code === '200'));
      if (isOk) {
        notify('success', 'Kirim Klaim Online Berhasil (Poin 22)', `Klaim No. SEP ${item.no_sep} berhasil dikirim ke Data Center Kemenkes!`);
        setActionModal(prev => {
          if (!prev.show) return prev;
          const currentResult = prev.result || {};
          return {
            ...prev,
            result: {
              ...currentResult,
              success: true,
              status_dc: `Terkirim ke Data Center Kemenkes (${new Date().toLocaleTimeString('id-ID')})`,
              is_dc_terkirim: true,
              tgl_kirim_dc: new Date().toLocaleString('id-ID'),
              message: `Klaim No. SEP ${item.no_sep} berhasil dikirim ke Data Center Kemenkes!`
            }
          };
        });
      } else {
        notify('danger', 'Gagal Kirim Klaim Online', json.msg || 'Terjadi kesalahan saat mengirim klaim ke Data Center Kemenkes.');
      }
    } catch (err) {
      notify('danger', 'Error', `Gagal menghubungi server: ${err.message}`);
    } finally {
      setIsSendingOnline(false);
    }
  };

  const handleProcessAction = async () => {
    setActionModal(prev => ({ ...prev, loading: true, result: null }));
    const apiUrl = getApiUrl() || 'http://202.155.94.169:8080';
    let endpoint = '';
    const bodyData = { no_sep: actionModal.item?.no_sep };
    if (actionModal.type === 'hapus') {
      endpoint = '/hapus_klaim';
      bodyData.coder_nik = localStorage.getItem('nik_coder') || '';
    }
    if (actionModal.type === 'idrg_final') {
      endpoint = '/finalisasi_idrg';
    }
    if (actionModal.type === 'finalisasi') {
      endpoint = '/finalisasi_klaim';
      bodyData.coder_nik = localStorage.getItem('nik_coder') || '';
    }
    if (actionModal.type === 'reedit') endpoint = '/reedit_klaim';
    if (actionModal.type === 'status') endpoint = '/cek_status_klaim';

    try {
      const res = await fetch(`${apiUrl}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...bodyData, ...getEklaimParams() })
      });
      const json = await res.json();
      const isSuccess = json.status === 1 || json.status === '1' || json.status === 200 || json.status === '200' || (json.metadata && (json.metadata.code === 200 || json.metadata.code === '200'));
      const messageText = json.msg || (json.metadata ? json.metadata.message : (typeof json === 'string' ? json : JSON.stringify(json)));

      setActionModal(prev => ({
        ...prev,
        loading: false,
        result: {
          success: isSuccess,
          message: messageText,
          status_klaim: json.status_klaim || 'Klaim Terproses',
          status_dc: json.status_dc || (json.is_dc_terkirim ? 'Terkirim ke Data Center Kemenkes' : 'Belum Terkirim ke Data Center Kemenkes'),
          is_dc_terkirim: Boolean(json.is_dc_terkirim),
          tgl_kirim_dc: json.tgl_kirim_dc || null,
          raw: json
        }
      }));
    } catch (err) {
      setActionModal(prev => ({
        ...prev,
        loading: false,
        result: { success: false, message: 'Gagal menghubungi server SIMRS/E-Klaim.' }
      }));
    }
  };

  const hasPrimaryDiagnosa = (list) => {
    if (!list || !Array.isArray(list) || list.length === 0) return false;
    return list.some(d => {
      const ketStr = String(d.ket || '').trim().toLowerCase();
      return ketStr === 'utama' || ketStr.includes('utama') || d.utama === 1 || d.utama === '1' || d.prioritas === '1' || d.prioritas === 1;
    });
  };

  const fetchDiagnosaData = async (item) => {
    const targetItem = item || grouperTarget || selectedDiagnosaItem || selectedPatient;
    if (!targetItem) return;
    const noMedrec = String(targetItem.no_medrec || targetItem.nomedrec || targetItem.medrec || targetItem.no_rm || '').trim();
    if (!noMedrec) return;

    setIsLoadingDiagnosa(true);
    const apiUrl = getApiUrl() || 'http://localhost:8000';

    try {
      // 1. Coba request via GET /show_diagnosa?no_medrec=...
      let res = await fetch(`${apiUrl}/show_diagnosa?no_medrec=${encodeURIComponent(noMedrec)}`);

      // 2. Jika GET gagal atau tidak ok, coba via POST /show_diagnosa
      if (!res.ok) {
        res = await fetch(`${apiUrl}/show_diagnosa`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ no_medrec: noMedrec })
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (json?.list_diagnosa || json?.list_prosedur) {
        const diagList = json.list_diagnosa || [];
        setDiagnosaData({
          list_diagnosa: diagList,
          list_prosedur: json.list_prosedur || []
        });
        const hasUtama = hasPrimaryDiagnosa(diagList);
        if (diagList.length === 0 || !hasUtama) {
          setFormInputDiagnosa(prev => ({ ...prev, ket: 'Utama', utama: 1 }));
        } else {
          setFormInputDiagnosa(prev => ({ ...prev, ket: 'Sekunder', utama: 0 }));
        }
      } else {
        setDiagnosaData({ list_diagnosa: [], list_prosedur: [] });
        setFormInputDiagnosa(prev => ({ ...prev, ket: 'Utama', utama: 1 }));
      }
    } catch (err) {
      console.warn('Gagal fetch /show_diagnosa:', err);
      setDiagnosaData({ list_diagnosa: [], list_prosedur: [] });
      setFormInputDiagnosa(prev => ({ ...prev, ket: 'Utama', utama: 1 }));
    } finally {
      setIsLoadingDiagnosa(false);
    }
  };

  // ── Filter Autocomplete ICD-9-CM & ICD-10 ──
  const filteredIcd9Suggestions = React.useMemo(() => {
    if (inputDiagnosaType !== 'prosedur' || masterIcd9.length === 0) return [];
    const query = (formInputDiagnosa?.kd_icd || '').split('+')[0].split('#')[0].trim().toLowerCase();
    if (!query) {
      return masterIcd9.slice(0, 50);
    }
    return masterIcd9.filter(item => {
      const code = String(item.kode || item.icd || item.kd_icd || '').toLowerCase();
      const desc = String(item.deskripsi || item.nm_icd || '').toLowerCase();
      return code.includes(query) || desc.includes(query);
    }).slice(0, 50);
  }, [inputDiagnosaType, masterIcd9, formInputDiagnosa?.kd_icd]);

  const filteredIcd10Suggestions = React.useMemo(() => {
    if (inputDiagnosaType !== 'diagnosa' || masterIcd10.length === 0) return [];
    const query = (formInputDiagnosa?.kd_icd || '').trim().toLowerCase();
    if (!query) {
      return masterIcd10.slice(0, 50);
    }
    return masterIcd10.filter(item => {
      const code = String(item.icd || item.kode || item.kd_icd || '').toLowerCase();
      const desc = String(item.deskripsi || item.nm_icd || item.penyakit || '').toLowerCase();
      return code.includes(query) || desc.includes(query);
    }).slice(0, 50);
  }, [inputDiagnosaType, masterIcd10, formInputDiagnosa?.kd_icd]);

  const handleSelectIcd9FromDropdown = (itemOrCode) => {
    if (!itemOrCode) {
      setFormInputDiagnosa(prev => ({ ...prev, kd_icd: '', nm_icd: '' }));
      return;
    }
    let code = '';
    let desc = '';
    let isIm = false;
    let isAccpdxNo = false;
    let validcode = undefined;
    let accpdx = undefined;

    if (typeof itemOrCode === 'object') {
      code = itemOrCode.kode || itemOrCode.icd || itemOrCode.kd_icd || '';
      desc = itemOrCode.deskripsi || itemOrCode.nm_icd || '';
      isIm = itemOrCode.im === 1 || itemOrCode.im === '1';
      validcode = itemOrCode.validcode;
      accpdx = itemOrCode.accpdx;
      isAccpdxNo = String(itemOrCode.accpdx || '').trim().toUpperCase() === 'N';
    } else {
      code = itemOrCode;
      const matched = masterIcd9.find(x => (x.icd || x.kode || x.kd_icd) === itemOrCode);
      if (matched) {
        desc = matched.deskripsi || matched.nm_icd || '';
        isIm = matched.im === 1 || matched.im === '1';
        validcode = matched.validcode;
        accpdx = matched.accpdx;
        isAccpdxNo = String(matched.accpdx || '').trim().toUpperCase() === 'N';
      }
    }

    if (isAccpdxNo) {
      setIcdCheckMsg({ type: 'danger', text: `Prosedur ${code} tidak bisa dipilih karena accpdx = N` });
      notify('warning', 'Prosedur Tidak Valid', `Prosedur ${code} tidak bisa dipilih karena accpdx = N`);
      return;
    }

    setFormInputDiagnosa(prev => ({
      ...prev,
      kd_icd: code,
      nm_icd: desc
    }));
    if (desc) {
      setIcdCheckMsg({ type: 'success', text: `Ditemukan di Master ICD-9 IM (_idrg): ${desc}${isIm ? ' [IM]' : ''}` });
    }
    handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, validcode, accpdx });
  };

  const handleSelectIcd10FromDropdown = (itemOrCode) => {
    if (!itemOrCode) {
      setFormInputDiagnosa(prev => ({ ...prev, kd_icd: '', nm_icd: '' }));
      return;
    }
    let code = '';
    let desc = '';
    let isIm = false;
    let isHeader = false;
    let isAccpdxNo = false;
    let validcode = undefined;
    let accpdx = undefined;
    if (typeof itemOrCode === 'object') {
      code = itemOrCode.icd || itemOrCode.kode || itemOrCode.kd_icd || '';
      desc = itemOrCode.deskripsi || itemOrCode.nm_icd || itemOrCode.penyakit || '';
      isIm = itemOrCode.im === 1 || itemOrCode.im === '1';
      validcode = itemOrCode.validcode;
      accpdx = itemOrCode.accpdx;
      isHeader = itemOrCode.validcode === 0 || itemOrCode.validcode === '0' || itemOrCode.validcode === false;
      isAccpdxNo = String(itemOrCode.accpdx || '').trim().toUpperCase() === 'N';
    } else {
      code = itemOrCode;
      const matched = masterIcd10.find(x => (x.icd || x.kode || x.kd_icd) === itemOrCode);
      if (matched) {
        desc = matched.deskripsi || matched.nm_icd || matched.penyakit || '';
        isIm = matched.im === 1 || matched.im === '1';
        validcode = matched.validcode;
        accpdx = matched.accpdx;
        isHeader = matched.validcode === 0 || matched.validcode === '0' || matched.validcode === false;
        isAccpdxNo = String(matched.accpdx || '').trim().toUpperCase() === 'N';
      }
    }
    const wasPrimary = formInputDiagnosa.ket === 'Utama' || formInputDiagnosa.utama === 1 || formInputDiagnosa.utama === '1';
    let targetKet = formInputDiagnosa.ket;
    let targetUtama = formInputDiagnosa.utama;
    if (isAccpdxNo && wasPrimary) {
      targetKet = 'Sekunder';
      targetUtama = 0;
    }

    setFormInputDiagnosa(prev => {
      const nextState = { ...prev, kd_icd: code, nm_icd: desc };
      if (isAccpdxNo && (prev.ket === 'Utama' || prev.utama === 1 || prev.utama === '1')) {
        nextState.ket = 'Sekunder';
        nextState.utama = 0;
      }
      return nextState;
    });

    if (isHeader) {
      setIcdCheckMsg({ type: 'info', text: `Ditemukan: ${desc} [Header Code]` });
      notify('info', 'Diagnosa Terpilih', `${code} - ${desc}`);
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode, accpdx });
    } else if (isAccpdxNo) {
      if (wasPrimary) {
        setIcdCheckMsg({ type: 'warning', text: `Ditemukan: ${desc} (Catatan: accpdx = N, tidak bisa diinput sebagai primary, dialihkan ke Sekunder)` });
        notify('info', 'Status Diagnosa Sekunder', 'Diagnosa tidak bisa diinput sebagai primary karena accpdx = N. Status dialihkan ke Sekunder agar tetap bisa diinput.');
      } else {
        setIcdCheckMsg({ type: 'success', text: `Ditemukan: ${desc} [accpdx = N: diizinkan untuk diagnosa sekunder/tambahan]` });
      }
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode, accpdx });
    } else {
      if (desc) {
        setIcdCheckMsg({ type: 'success', text: `Ditemukan di Master ICD-10: ${desc}${isIm ? ' [IM]' : ''}` });
      }
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode, accpdx });
    }
  };

  const handleMultiplicityChange = (newMult) => {
    const mult = Math.max(1, parseInt(newMult) || 1);
    setFormInputDiagnosa(prev => {
      const cleanCode = (prev.kd_icd || '').split('+')[0].trim();
      return { ...prev, multiplicity: mult, kd_icd: cleanCode };
    });
  };

  const fetchMasterIcd = async (type = 'diagnosa') => {
    const apiUrl = getApiUrl() || 'http://localhost:8000';
    if (type === 'diagnosa' && masterIcd10.length === 0) {
      setIsLoadingMasterIcd(true);
      try {
        const res = await fetch(`${apiUrl}/show_icdxim`);
        const json = await res.json();
        const list = Array.isArray(json) ? json : (json?.list_icdxim || json?.list_icdx || json?.data || []);
        setMasterIcd10(list);
      } catch (err) {
        console.warn('Gagal fetch /show_icdxim:', err);
      } finally {
        setIsLoadingMasterIcd(false);
      }
    } else if (type === 'prosedur' && masterIcd9.length === 0) {
      setIsLoadingMasterIcd(true);
      try {
        const res = await fetch(`${apiUrl}/show_icdixim`);
        const json = await res.json();
        const list = Array.isArray(json) ? json : (json?.list_icdixim || json?.list_icdix || json?.data || []);
        setMasterIcd9(list);
      } catch (err) {
        console.warn('Gagal fetch /show_icdixim:', err);
      } finally {
        setIsLoadingMasterIcd(false);
      }
    }
  };

  const handleOpenInputDiagnosa = async (type = 'diagnosa') => {
    setInputDiagnosaType(type);
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');

    const curList = diagnosaData.list_diagnosa;
    const hasUtama = hasPrimaryDiagnosa(curList);
    const isNoRecordOrNoUtama = !curList || curList.length === 0 || !hasUtama;
    const patient = grouperTarget || selectedDiagnosaItem;

    setFormInputDiagnosa({
      kd_icd: '',
      nm_icd: '',
      ket: type === 'diagnosa' ? (isNoRecordOrNoUtama ? 'Utama' : 'Sekunder') : 'Prosedur',
      utama: type === 'diagnosa' ? (isNoRecordOrNoUtama ? 1 : 0) : 0,
      multiplicity: 1,
      kd_dokter: patient?.kd_dokter || '',
      nm_dokter: patient?.nama_dokter || patient?.nm_dokter || patient?.dpjp || '',
      tanggal: `${dd}/${mm}/${yyyy}`,
      jam: `${hh}:${min}`,
      lokasi: patient?.jenis_pelayanan === '2' ? 'Rawat Jalan' : 'Rawat Inap',
      petugas: localStorage.getItem('nama_user') || localStorage.getItem('user') || localStorage.getItem('username') || sessionStorage.getItem('nama_user') || sessionStorage.getItem('user') || sessionStorage.getItem('username') || 'Administrator'
    });

    setShowIcd9Autocomplete(false);
    setShowIcd10Autocomplete(false);
    setIcdCheckMsg(null);
    setShowInlineInput(true);

    await fetchMasterIcd(type);
  };

  const handleCheckIcd = async (kode) => {
    const codeToTest = (kode !== undefined && kode !== null ? kode : formInputDiagnosa.kd_icd || '').trim();
    if (!codeToTest) {
      setIcdCheckMsg({ type: 'warning', text: 'Silakan ketik kode terlebih dahulu' });
      return;
    }

    setIsCheckingIcd(true);
    setIcdCheckMsg(null);
    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const isProsedur = inputDiagnosaType === 'prosedur';

    let baseCode = codeToTest;
    let multiplicityInfo = '';
    if (isProsedur) {
      if (codeToTest.includes('+')) {
        const parts = codeToTest.split('+');
        baseCode = parts[0].trim();
        multiplicityInfo = ` (Multiplicity: +${parts[1].trim()})`;
        const parsedMult = parseInt(parts[1].trim());
        if (!isNaN(parsedMult) && parsedMult > 0) {
          setFormInputDiagnosa(prev => ({ ...prev, multiplicity: parsedMult }));
        }
      } else if (codeToTest.includes('#')) {
        const parts = codeToTest.split('#');
        baseCode = parts[0].trim();
        multiplicityInfo = ` (Setting Sesi: #${parts.slice(1).join('#')})`;
      }

      try {
        let listIcd9 = masterIcd9;
        if (!listIcd9 || listIcd9.length === 0) {
          try {
            const res9 = await fetch(`${apiUrl}/show_icdixim`);
            const json9 = await res9.json();
            listIcd9 = Array.isArray(json9) ? json9 : (json9?.list_icdixim || json9?.list_icdix || json9?.data || []);
            if (Array.isArray(listIcd9) && listIcd9.length > 0) {
              setMasterIcd9(listIcd9);
            }
          } catch (e9) {
            console.warn('Gagal fetch /show_icdixim:', e9);
          }
        }

        const matched = (listIcd9 || []).find(x => {
          const c = String(x.icd || x.kode || x.kd_icd || '').trim().toLowerCase();
          return c === baseCode.toLowerCase();
        });

        if (matched) {
          const foundDesc = (matched.deskripsi || matched.nm_icd || '') + multiplicityInfo;
          const isIm = matched.im === 1 || matched.im === '1';
          const isAccpdxNo = String(matched.accpdx || '').trim().toUpperCase() === 'N';

          if (isAccpdxNo) {
            setIcdCheckMsg({ type: 'danger', text: `Prosedur ${codeToTest} tidak bisa dipilih karena accpdx = N` });
            notify('warning', 'Prosedur Tidak Valid', `Prosedur ${codeToTest} tidak bisa dipilih karena accpdx = N`);
            setIsCheckingIcd(false);
            return;
          }

          setFormInputDiagnosa(prev => ({
            ...prev,
            kd_icd: codeToTest,
            nm_icd: foundDesc
          }));
          setIcdCheckMsg({ type: 'success', text: `Ditemukan di Master ICD-9 IM (_idrg): ${foundDesc}` });
          notify('success', 'Kode Prosedur ICD-9 IM Ditemukan', `Kode ${codeToTest}: ${foundDesc}${isIm ? ' [Indonesian Modification]' : ''}`);
          setIsCheckingIcd(false);
          handleSaveInputDiagnosa(null, {
            kd_icd: codeToTest,
            nm_icd: foundDesc,
            validcode: matched.validcode,
            accpdx: matched.accpdx
          });
          return;
        }

        const resCari = await fetch(`${apiUrl}/cari_icdix?kodeicd=${encodeURIComponent(baseCode)}`);
        const jsonCari = await resCari.json();
        if (jsonCari && (jsonCari.status === 0 || jsonCari.status === '0')) {
          const nameResult = (jsonCari.nm_icd || jsonCari.deskripsi || '') + multiplicityInfo;
          const isAccpdxNo = String(jsonCari.accpdx || '').trim().toUpperCase() === 'N';

          if (isAccpdxNo) {
            setIcdCheckMsg({ type: 'danger', text: `Prosedur ${codeToTest} tidak bisa dipilih karena accpdx = N` });
            notify('warning', 'Prosedur Tidak Valid', `Prosedur ${codeToTest} tidak bisa dipilih karena accpdx = N`);
            setIsCheckingIcd(false);
            return;
          }

          setFormInputDiagnosa(prev => ({
            ...prev,
            kd_icd: codeToTest,
            nm_icd: nameResult
          }));
          setIcdCheckMsg({ type: 'success', text: `Ditemukan di Master ICD-9 IM (_idrg): ${nameResult}` });
          notify('success', 'Kode Prosedur ICD-9 IM Ditemukan', `Kode ${codeToTest}: ${nameResult}`);
          setIsCheckingIcd(false);
          handleSaveInputDiagnosa(null, {
            kd_icd: codeToTest,
            nm_icd: nameResult,
            validcode: jsonCari.validcode,
            accpdx: jsonCari.accpdx
          });
          return;
        }

        const errMsg = `Kode Prosedur "${codeToTest}" tidak ditemukan pada Master ICD-9-CM IM lokal (tabel _idrg)`;
        setIcdCheckMsg({ type: 'danger', text: errMsg });
        notify('warning', 'Kode Prosedur Tidak Ditemukan', `${errMsg}. Mengalihkan ke tabel pencarian master prosedur.`);
        handleOpenMasterIcdModal(baseCode);
      } catch (err) {
        console.error('Error pencarian prosedur ICD-9 IM:', err);
        setIcdCheckMsg({ type: 'danger', text: `Gagal memeriksa kode prosedur: ${err.message}` });
        notify('danger', 'Koneksi Terputus', `Gagal memeriksa kode prosedur: ${err.message}`);
        handleOpenMasterIcdModal(baseCode);
      } finally {
        setIsCheckingIcd(false);
      }
      return;
    }

    try {
      let res = await fetch(`${apiUrl}/cari_icdx?kodeicd=${encodeURIComponent(baseCode)}`);
      let json = await res.json();

      if ((!json || json.status === 1 || json.status === '1') && apiUrl) {
        try {
          const resIm = await fetch(`${apiUrl}/search_diagnosis_im?keyword=${encodeURIComponent(baseCode)}`);
          if (resIm.ok) {
            const jsonIm = await resIm.json();
            const imList = jsonIm?.response?.data || jsonIm?.data || [];
            if (Array.isArray(imList) && imList.length > 0) {
              const matched = imList.find(x => (x[0] || x.code || '').toLowerCase() === baseCode.toLowerCase()) || imList[0];
              const imCode = matched[0] || matched.code || baseCode;
              const imDesc = matched[1] || matched.desc || matched.display || '';
              json = { status: 0, kd_icd: imCode, nm_icd: imDesc };
            }
          }
        } catch (eIm) {}
      }

      if (json && (json.status === 0 || json.status === '0')) {
        const nameResult = (json.nm_icd || json.deskripsi || '');
        setFormInputDiagnosa(prev => ({
          ...prev,
          kd_icd: codeToTest,
          nm_icd: nameResult
        }));

        let itemValidCode = json.validcode;
        let itemAccpdx = json.accpdx;
        if (itemValidCode === undefined || itemAccpdx === undefined) {
          const matchedMem = (masterIcd10 || []).find(x => String(x.icd || x.kode || x.kd_icd || '').trim().toLowerCase() === baseCode.toLowerCase());
          if (matchedMem) {
            if (itemValidCode === undefined) itemValidCode = matchedMem.validcode;
            if (itemAccpdx === undefined) itemAccpdx = matchedMem.accpdx;
          }
        }
        const isHeader = itemValidCode === 0 || itemValidCode === '0' || itemValidCode === false;
        const isAccpdxNo = String(itemAccpdx || '').trim().toUpperCase() === 'N';

        const wasPrimary = formInputDiagnosa.ket === 'Utama' || formInputDiagnosa.utama === 1 || formInputDiagnosa.utama === '1';
        let targetKet = formInputDiagnosa.ket;
        let targetUtama = formInputDiagnosa.utama;

        if (isAccpdxNo) {
          if (wasPrimary) {
            targetKet = 'Sekunder';
            targetUtama = 0;
          }
          setFormInputDiagnosa(prev => {
            if (prev.ket === 'Utama' || prev.utama === 1 || prev.utama === '1') {
              return { ...prev, ket: 'Sekunder', utama: 0 };
            }
            return prev;
          });
        }

        if (isHeader) {
          setIcdCheckMsg({ type: 'info', text: `Ditemukan: ${nameResult} [Header Code]` });
          notify('info', 'Diagnosa Terpilih', `${codeToTest} - ${nameResult}`);
          handleSaveInputDiagnosa(null, {
            kd_icd: codeToTest,
            nm_icd: nameResult,
            ket: targetKet,
            utama: targetUtama,
            validcode: itemValidCode,
            accpdx: itemAccpdx
          });
        } else if (isAccpdxNo) {
          if (wasPrimary) {
            setIcdCheckMsg({ type: 'warning', text: `Ditemukan: ${nameResult} (accpdx = N, tidak bisa diinput sebagai primary, dialihkan ke Sekunder)` });
            notify('info', 'Status Diagnosa Sekunder', `Kode ${codeToTest} memiliki accpdx = N (tidak bisa diinput sebagai primary). Status dialihkan ke Sekunder agar tetap bisa diinput.`);
          } else {
            setIcdCheckMsg({ type: 'success', text: `Ditemukan: ${nameResult} [accpdx = N: diizinkan untuk diagnosa sekunder/tambahan]` });
            notify('success', 'Kode Diagnosa (ICD-10) Ditemukan', `Kode ${codeToTest}: ${nameResult}`);
          }
          handleSaveInputDiagnosa(null, {
            kd_icd: codeToTest,
            nm_icd: nameResult,
            ket: targetKet,
            utama: targetUtama,
            validcode: itemValidCode,
            accpdx: itemAccpdx
          });
        } else {
          setIcdCheckMsg({ type: 'success', text: `Ditemukan: ${nameResult}` });
          notify('success', 'Kode Diagnosa (ICD-10) Ditemukan', `Kode ${codeToTest}: ${nameResult}`);
          handleSaveInputDiagnosa(null, {
            kd_icd: codeToTest,
            nm_icd: nameResult,
            ket: targetKet,
            utama: targetUtama,
            validcode: itemValidCode,
            accpdx: itemAccpdx
          });
        }
      } else {
        const errMsg = json?.msg || `Kode Diagnosa (ICD-10) "${codeToTest}" tidak ditemukan`;
        setIcdCheckMsg({ type: 'danger', text: errMsg });
        notify('warning', 'Kode Diagnosa Tidak Ditemukan', `${errMsg}. Mengalihkan ke tabel pencarian master diagnosa.`);
        handleOpenMasterIcdModal(baseCode);
      }
    } catch (err) {
      console.error('Error cari_icdx:', err);
      setIcdCheckMsg({ type: 'danger', text: `Gagal memeriksa kode: ${err.message}` });
      notify('danger', 'Koneksi Terputus', `Gagal memeriksa kode: ${err.message}`);
      handleOpenMasterIcdModal(baseCode);
    } finally {
      setIsCheckingIcd(false);
    }
  };

  const handleOpenMasterIcdModal = async (initialSearch = '') => {
    setMasterIcdModalSearch(initialSearch || '');
    setMasterIcdCurrentPage(1);
    setShowMasterIcdModal(true);

    const apiUrl = getApiUrl() || 'http://localhost:8000';
    if (inputDiagnosaType === 'prosedur') {
      if (masterIcd9.length === 0) {
        setIsLoadingMasterIcd(true);
        try {
          const res = await fetch(`${apiUrl}/show_icdixim`);
          const json = await res.json();
          const list = Array.isArray(json) ? json : (json?.list_icdixim || json?.list_icdix || json?.data || []);
          setMasterIcd9(list);
        } catch (err) {
          console.warn('Gagal fetch /show_icdixim:', err);
        } finally {
          setIsLoadingMasterIcd(false);
        }
      }
    } else {
      if (masterIcd10.length === 0) {
        setIsLoadingMasterIcd(true);
        try {
          const res = await fetch(`${apiUrl}/show_icdxim`);
          const json = await res.json();
          const list = Array.isArray(json) ? json : (json?.list_icdxim || json?.list_icdx || json?.data || []);
          setMasterIcd10(list);
        } catch (err) {
          console.warn('Gagal fetch /show_icdxim:', err);
        } finally {
          setIsLoadingMasterIcd(false);
        }
      }
    }
  };

  const handleSelectMasterIcdRow = (item) => {
    const code = item.icd || item.kode || item.kd_icd || '';
    const desc = item.nm_icd || item.deskripsi || item.penyakit || '';
    const isProsedur = inputDiagnosaType === 'prosedur';
    const isAccpdxNo = String(item.accpdx || '').trim().toUpperCase() === 'N';

    if (isProsedur) {
      if (isAccpdxNo) {
        setIcdCheckMsg({ type: 'danger', text: `Prosedur ${code} tidak bisa dipilih karena accpdx = N` });
        notify('warning', 'Prosedur Tidak Valid', `Prosedur ${code} tidak bisa dipilih karena accpdx = N`);
        return;
      }
      setFormInputDiagnosa(prev => ({
        ...prev,
        kd_icd: code,
        nm_icd: desc
      }));
      setIcdCheckMsg({ type: 'success', text: `Ditemukan di Master ICD-9 IM (_idrg): ${desc}` });
      notify('info', 'Prosedur Terpilih', `${code} - ${desc}`);
      setShowMasterIcdModal(false);
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, validcode: item.validcode, accpdx: item.accpdx });
      return;
    }

    const isHeader = item.validcode === 0 || item.validcode === '0' || item.validcode === false;
    const wasPrimary = formInputDiagnosa.ket === 'Utama' || formInputDiagnosa.utama === 1 || formInputDiagnosa.utama === '1';
    let targetKet = formInputDiagnosa.ket;
    let targetUtama = formInputDiagnosa.utama;
    if (isAccpdxNo && wasPrimary) {
      targetKet = 'Sekunder';
      targetUtama = 0;
    }

    setFormInputDiagnosa(prev => {
      const nextState = { ...prev, kd_icd: code, nm_icd: desc };
      if (isAccpdxNo && (prev.ket === 'Utama' || prev.utama === 1 || prev.utama === '1')) {
        nextState.ket = 'Sekunder';
        nextState.utama = 0;
      }
      return nextState;
    });

    if (isHeader) {
      setIcdCheckMsg({ type: 'info', text: `Ditemukan: ${desc} [Header Code]` });
      notify('info', 'Diagnosa Terpilih', `${code} - ${desc}`);
      setShowMasterIcdModal(false);
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode: item.validcode, accpdx: item.accpdx });
    } else if (isAccpdxNo) {
      if (wasPrimary) {
        setIcdCheckMsg({ type: 'warning', text: `Ditemukan: ${desc} (Catatan: accpdx = N, tidak bisa diinput sebagai primary, dialihkan ke Sekunder)` });
        notify('info', 'Status Diagnosa Sekunder', 'Diagnosa tidak bisa diinput sebagai primary karena accpdx = N. Status dialihkan ke Sekunder agar tetap bisa diinput.');
      } else {
        setIcdCheckMsg({ type: 'success', text: `Ditemukan: ${desc} [accpdx = N: diizinkan untuk diagnosa sekunder/tambahan]` });
      }
      setShowMasterIcdModal(false);
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode: item.validcode, accpdx: item.accpdx });
    } else {
      setIcdCheckMsg({ type: 'success', text: `Ditemukan: ${desc}` });
      notify('info', 'Diagnosa Terpilih', `${code} - ${desc}`);
      setShowMasterIcdModal(false);
      handleSaveInputDiagnosa(null, { kd_icd: code, nm_icd: desc, ket: targetKet, utama: targetUtama, validcode: item.validcode, accpdx: item.accpdx });
    }
  };

  const handleSaveInputDiagnosa = async (e, overrideData = null) => {
    if (isGrouperLocked) {
      notify('warning', 'Koding Terkunci', 'Diagnosa/prosedur tidak bisa diinput karena status sudah Grouper Coding iDRG. Silakan klik tombol "Edit Ulang iDRG" terlebih dahulu.');
      return;
    }
    if (e && e.preventDefault) e.preventDefault();
    const curForm = { ...formInputDiagnosa, ...(overrideData || {}) };
    if (!curForm.kd_icd) {
      notify('warning', 'Validasi Form', 'Silakan pilih kode dan nama diagnosa/prosedur terlebih dahulu.');
      return;
    }

    const patient = grouperTarget || selectedDiagnosaItem;
    if (!patient) return;

    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const token = localStorage.getItem('token');
    const isProsedur = inputDiagnosaType === 'prosedur';
    let itemValidCode = curForm.validcode !== undefined ? curForm.validcode : undefined;
    let itemAccpdx = curForm.accpdx !== undefined ? curForm.accpdx : undefined;

    // Validasi Header code & accpdx untuk diagnosa
    if (!isProsedur) {
      const curCode = (curForm.kd_icd || '').trim();
      let matchedItem = (masterIcd10 || []).find(x => {
        const code = String(x.icd || x.kode || x.kd_icd || '').trim().toLowerCase();
        return code === curCode.toLowerCase() || code.replace(/\./g, '') === curCode.toLowerCase().replace(/\./g, '');
      });
      if (itemValidCode === undefined && matchedItem) itemValidCode = matchedItem.validcode;
      if (itemAccpdx === undefined && matchedItem) itemAccpdx = (matchedItem.accpdx || matchedItem.acc_pdx);

      if (itemValidCode === undefined || itemAccpdx === undefined) {
        try {
          const resCari = await fetch(`${apiUrl}/cari_icdx?kodeicd=${encodeURIComponent(curCode)}`);
          const jsonCari = await resCari.json();
          if (jsonCari) {
            if (itemValidCode === undefined && jsonCari.validcode !== undefined) itemValidCode = jsonCari.validcode;
            if (itemAccpdx === undefined && (jsonCari.accpdx !== undefined || jsonCari.acc_pdx !== undefined)) {
              itemAccpdx = jsonCari.accpdx !== undefined ? jsonCari.accpdx : jsonCari.acc_pdx;
            }
          }
          if (itemAccpdx === undefined && curCode.includes('.')) {
            const resAlt = await fetch(`${apiUrl}/cari_icdx?kodeicd=${encodeURIComponent(curCode.replace(/\./g, ''))}`);
            const jsonAlt = await resAlt.json();
            if (jsonAlt) {
              if (itemValidCode === undefined && jsonAlt.validcode !== undefined) itemValidCode = jsonAlt.validcode;
              if (itemAccpdx === undefined && (jsonAlt.accpdx !== undefined || jsonAlt.acc_pdx !== undefined)) {
                itemAccpdx = jsonAlt.accpdx !== undefined ? jsonAlt.accpdx : jsonAlt.acc_pdx;
              }
            }
          }
        } catch (eChk) {}
      }


      const isPrimary = curForm.utama === 1 || curForm.utama === '1' || String(curForm.ket || '').trim().toLowerCase() === 'utama';
      const isAccpdxNo = String(itemAccpdx || '').trim().toUpperCase() === 'N';

      if (isPrimary && isAccpdxNo) {
        // Sesuai aturan INACBGS: diagnosa dengan accpdx = N tetap bisa dipilih, dialihkan otomatis ke Sekunder
        curForm.ket = 'Sekunder';
        curForm.utama = 0;
        setFormInputDiagnosa(prev => ({ ...prev, ket: 'Sekunder', utama: 0 }));
        setIcdCheckMsg({ type: 'warning', text: `Ditemukan: ${curForm.nm_icd || curCode} (accpdx = N: otomatis dialihkan ke status Sekunder)` });
        notify('info', 'Status Diagnosa Sekunder', `Kode ${curCode} memiliki accpdx = N (hanya untuk diagnosa sekunder/tambahan, otomatis disimpan sebagai Sekunder).`);
      }
    } else {
      // Validasi accpdx untuk prosedur (ICD-9-CM)
      const curCode = (curForm.kd_icd || '').trim();
      const baseCode = curCode.includes('+') ? curCode.split('+')[0].trim() : curCode;

      let matchedItem = (masterIcd9 || []).find(x => {
        const code = String(x.icd || x.kode || x.kd_icd || '').trim().toLowerCase();
        return code === baseCode.toLowerCase() || code.replace(/\./g, '') === baseCode.toLowerCase().replace(/\./g, '');
      });
      if (itemValidCode === undefined && matchedItem) itemValidCode = matchedItem.validcode;
      if (itemAccpdx === undefined && matchedItem) itemAccpdx = (matchedItem.accpdx || matchedItem.acc_pdx);

      if (itemAccpdx === undefined) {
        try {
          const resCari = await fetch(`${apiUrl}/cari_icdix?kodeicd=${encodeURIComponent(baseCode)}`);
          const jsonCari = await resCari.json();
          if (jsonCari && (jsonCari.accpdx !== undefined || jsonCari.acc_pdx !== undefined)) {
            itemAccpdx = jsonCari.accpdx !== undefined ? jsonCari.accpdx : jsonCari.acc_pdx;
            if (itemValidCode === undefined && jsonCari.validcode !== undefined) itemValidCode = jsonCari.validcode;
          }
        } catch (eChk) {}
      }

      const isAccpdxNo = String(itemAccpdx || '').trim().toUpperCase() === 'N';
      if (isAccpdxNo) {
        setIcdCheckMsg({ type: 'danger', text: 'Prosedur tidak bisa dipilih karena accpdx = N' });
        notify('warning', 'Prosedur Tidak Valid', 'Prosedur tidak bisa dipilih karena accpdx = N');
        return;
      }
    }

    setIsSavingDiagnosa(true);

    let finalKdIcd = (curForm.kd_icd || '').split('+')[0].trim();
    const mult = parseInt(curForm.multiplicity) || 1;

    // Hitung urutan penginputan berdasarkan list saat ini
    const activeList = isProsedur ? (diagnosaData?.list_prosedur || []) : (diagnosaData?.list_diagnosa || []);
    let itemUrutan = activeList.length + 1;
    if (curForm.utama === 1 || curForm.utama === '1' || String(curForm.ket || '').trim().toLowerCase() === 'utama') {
      itemUrutan = 1;
    }

    const payload = {
      no_nota: patient.no_nota || patient.no_sep || '',
      no_medrec: patient.no_medrec || '',
      tgl_kunj: curForm.tanggal,
      mode: 'append',
      jenis: isProsedur ? 'prosedur' : 'diagnosa',
      target: 'bpjs', // Menyimpan ke tabel diagnosa2 (diagnosa) atau diagnosa3 (prosedur)
      qty: isProsedur ? mult : 1,
      multiplicity: isProsedur ? mult : 1,
      urutan: itemUrutan,
      list_diagnosa: [
        {
          kd_icd: finalKdIcd,
          nm_icd: curForm.nm_icd,
          ket: curForm.ket,
          utama: curForm.utama,
          multiplicity: isProsedur ? mult : 1,
          qty: isProsedur ? mult : 1,
          urutan: itemUrutan,
          validcode: itemValidCode,
          accpdx: itemAccpdx,
          kd_dokter: curForm.kd_dokter,
          nm_dokter: curForm.nm_dokter,
          tanggal: curForm.tanggal,
          jam: curForm.jam,
          lokasi: curForm.lokasi,
          petugas: curForm.petugas
        }
      ]
    };

    try {
      const res = await fetch(`${apiUrl}/simpan_hdiagnosa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const json = await res.json();
      if (json && (json.status === 1 || json.status === '1' || json.status === 'success')) {
        setShowInputDiagnosaModal(false);
        const wasPrimary = curForm.ket === 'Utama' || curForm.utama === 1 || curForm.utama === '1';
        setFormInputDiagnosa(prev => ({
          ...prev,
          kd_icd: '',
          nm_icd: '',
          multiplicity: 1,
          ket: wasPrimary ? 'Sekunder' : prev.ket,
          utama: wasPrimary ? 0 : prev.utama
        }));
        setIcdCheckMsg(null);
        const targetTable = isProsedur ? 'diagnosa3' : 'diagnosa2';
        notify('success', 'Berhasil Disimpan', `Data ${isProsedur ? 'prosedur' : 'diagnosa'} pasien berhasil disimpan ke tabel ${targetTable}.`);
        fetchDiagnosaData(patient);
      } else {
        const errMsg = json?.msg || 'Gagal menyimpan data ke server.';
        notify('danger', 'Gagal Menyimpan', errMsg);
        setIcdCheckMsg({ type: 'danger', text: errMsg });
      }
    } catch (err) {
      console.error('Error simpan_hdiagnosa BPJS:', err);
      notify('danger', 'Kesalahan Sistem', `Terjadi kesalahan saat menyimpan: ${err.message}`);
    } finally {
      setIsSavingDiagnosa(false);
    }
  };

  const handleDeleteDiagnosa = (diag, type = 'diagnosa') => {
    if (isGrouperLocked) {
      notify('warning', 'Peringatan', 'Klaim sudah di-grouper! Buka kunci dengan klik "Edit Ulang iDRG" terlebih dahulu.');
      return;
    }
    setDeleteConfirmModal({
      show: true,
      item: diag,
      type,
      isDeleting: false
    });
  };

  const handleExecuteDeleteDiagnosa = async () => {
    const { item: diag, type } = deleteConfirmModal;
    if (!diag) return;
    const targetPatient = grouperTarget || selectedDiagnosaItem;
    if (!targetPatient) return;
    setDeleteConfirmModal(prev => ({ ...prev, isDeleting: true }));
    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const token = localStorage.getItem('token');
    const isProsedur = type === 'prosedur';

    try {
      const payload = {
        no_medrec: targetPatient.no_medrec || '',
        no_nota: targetPatient.no_nota || targetPatient.no_sep || '',
        kd_icd: diag.kd_icd,
        id: diag.id,
        jenis: isProsedur ? 'prosedur' : 'diagnosa',
        target: 'bpjs', // Menghapus dari diagnosa2 atau diagnosa3
        mode: 'delete'
      };

      const res = await fetch(`${apiUrl}/simpan_hdiagnosa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json && (json.status === 1 || json.status === 'success' || res.ok)) {
        const targetTable = isProsedur ? 'diagnosa3' : 'diagnosa2';
        notify('success', 'Berhasil Dihapus', `Kode ${diag.kd_icd} berhasil dihapus dari tabel ${targetTable}.`);
        setDeleteConfirmModal({ show: false, item: null, type: 'diagnosa', isDeleting: false });
        fetchDiagnosaData(targetPatient);
      } else {
        notify('danger', 'Gagal Menghapus', json?.msg || 'Gagal menghapus data dari server.');
      }
    } catch (err) {
      console.error('Error hapus diagnosa/prosedur BPJS:', err);
      notify('danger', 'Kesalahan Sistem', `Gagal menghapus: ${err.message}`);
    } finally {
      setDeleteConfirmModal(prev => ({ ...prev, isDeleting: false }));
    }
  };


  // Mock initial data sesuai request user
  const mockClaimData = [
    {
      bpjs: 3102000,
      kd_inacbg: "Z-4-12-II",
      limit2: 3102000,
      nama: "REGA ANGELICA MIANTO",
      nama_dokter: "Rizki Arya Widi Maza Lufi, dr, Sp.OG",
      nm_klasifikasi: "BPJS",
      no_daftar: "P2RI/072026/853",
      no_kamar: "2101",
      no_medrec: "365597",
      no_sep: "-",
      tgl_daftar: "31/07/2026"
    },
    {
      bpjs: 1635100,
      kd_inacbg: "K-4-17-I",
      limit2: 1635100,
      nama: "LINGGA RAKA WISESA",
      nama_dokter: "A. Haris Thayeb, dr, SpA",
      nm_klasifikasi: "BPJS",
      no_daftar: "P2RI/072026/867",
      no_kamar: "3305",
      no_medrec: "386482",
      no_sep: "-",
      tgl_daftar: "31/07/2026"
    },
    {
      bpjs: 4250000,
      kd_inacbg: "O-6-10-I",
      limit2: 4250000,
      nama: "SITI NUR HALIZA",
      nama_dokter: "Budi Santoso, dr, Sp.PD",
      nm_klasifikasi: "BPJS",
      no_daftar: "P2RI/072026/889",
      no_kamar: "1104",
      no_medrec: "391204",
      no_sep: "0117R0750726V000102",
      tgl_daftar: "01/08/2026"
    },
    {
      bpjs: 5120000,
      kd_inacbg: "I-4-11-III",
      limit2: 5120000,
      nama: "AHMAD FAUZI",
      nama_dokter: "Dewi Lestari, dr, Sp.JP",
      nm_klasifikasi: "BPJS",
      no_daftar: "P2RI/082026/012",
      no_kamar: "VIP-02",
      no_medrec: "402319",
      no_sep: "0117R0750826V000304",
      tgl_daftar: "02/08/2026"
    }
  ];

  // ── Fetch Data Claim Backend show_dataclaim ──
  const fetchClaimData = async () => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();
    try {
      const res = await fetch(`${apiUrl}/show_dataclaim`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      if (Array.isArray(json)) {
        setClaimList(json);
      } else if (json?.data && Array.isArray(json.data)) {
        setClaimList(json.data);
      } else {
        setClaimList(mockClaimData);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_dataclaim:', err);
      setClaimList(mockClaimData);
      setFetchError('Menggunakan data lokal. Gagal terhubung ke backend server.');
    } finally {
      setIsLoading(false);
    }
  };

  // Clock Effect & Initial Fetch
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    fetchClaimData();
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Format Currency Rp
  const formatRp = (num) => {
    if (!num && num !== 0) return 'Rp 0';
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(num);
  };

  // Filter Data
  const filteredData = claimList.filter(item => {
    const q = searchQuery.toLowerCase();
    const matchQuery =
      (item.nama || '').toLowerCase().includes(q) ||
      (item.no_medrec || '').toLowerCase().includes(q) ||
      (item.no_daftar || '').toLowerCase().includes(q) ||
      (item.no_sep || '').toLowerCase().includes(q) ||
      (item.kd_inacbg || '').toLowerCase().includes(q) ||
      (item.nama_dokter || '').toLowerCase().includes(q) ||
      (item.no_kamar || '').toLowerCase().includes(q);

    let matchSep = true;
    if (filterSepStatus === 'ADA') {
      matchSep = item.no_sep && item.no_sep !== '-';
    } else if (filterSepStatus === 'KOSONG') {
      matchSep = !item.no_sep || item.no_sep === '-';
    }

    return matchQuery && matchSep;
  });

  // Pagination Logic
  const indexOfLast  = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages   = Math.ceil(filteredData.length / itemsPerPage);

  // ── Handler Modal Edit SEP ──
  const handleOpenEditSep = (item) => {
    setSelectedPatient(item);
    setInputNoSep(item.no_sep && item.no_sep !== '-' ? item.no_sep : '');
    setSepFeedback(null);
    setShowEditSepModal(true);
  };

  const handleSaveSep = async (e) => {
    e.preventDefault();
    if (!selectedPatient) return;

    const newSepVal = inputNoSep.trim() || '-';
    setIsSavingSep(true);
    setSepFeedback(null);
    const apiUrl = getApiUrl();

    const payload = {
      no_medrec: selectedPatient.no_medrec,
      no_sep: newSepVal,
      tgl_daftar: selectedPatient.tgl_daftar
    };

    try {
      const res = await fetch(`${apiUrl}/isidata_sep`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }

      const json = await res.json();
      setSepFeedback({
        type: json?.status === 1 || res.ok ? 'success' : 'warning',
        text: json?.msg || json?.message || `No. SEP (${newSepVal}) berhasil disimpan!`
      });

      // Update state lokal
      setClaimList(prev => prev.map(p =>
        p.no_daftar === selectedPatient.no_daftar ? { ...p, no_sep: newSepVal } : p
      ));

      setTimeout(() => {
        setShowEditSepModal(false);
      }, 1200);

    } catch (err) {
      console.warn('Gagal simpan SEP ke /isidata_sep:', err);
      setClaimList(prev => prev.map(p =>
        p.no_daftar === selectedPatient.no_daftar ? { ...p, no_sep: newSepVal } : p
      ));
      setSepFeedback({
        type: 'warning',
        text: `[Demo Mode] No. SEP (${newSepVal}) diperbarui di tampilan. (Gagal terhubung ke ${apiUrl}/isidata_sep)`
      });
      setTimeout(() => {
        setShowEditSepModal(false);
      }, 1500);
    } finally {
      setIsSavingSep(false);
    }
  };

  // ── Handler New Claim E-Claim ──
  const [showNewClaimConfirm, setShowNewClaimConfirm] = useState(false);
  const [newClaimTarget, setNewClaimTarget] = useState(null);
  const [newClaimResult, setNewClaimResult] = useState(null);
  const [isProcessingNewClaim, setIsProcessingNewClaim] = useState(false);

  const handleOpenNewClaim = (item) => {
    if (!item.no_sep || item.no_sep === '-' || item.no_sep.trim() === '') {
      setWarningPatientTarget(item);
      setShowSepWarningModal(true);
      return;
    }
    setNewClaimTarget(item);
    setNewClaimResult(null);
    setInputSitb('');
    setSitbValidationResult(null);
    setShowNewClaimConfirm(true);
  };

  const handleProcessNewClaim = async () => {
    if (!newClaimTarget) return;

    setIsProcessingNewClaim(true);
    setNewClaimResult(null);
    const apiUrl = getApiUrl();
    
    try {
      const res = await fetch(`${apiUrl}/new_claim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nomorsep: newClaimTarget.no_sep,
          nomedrec: newClaimTarget.no_medrec,
          nik_coder: nikCoder,
          tgl_masuk: newClaimTarget.tgl_daftar
        })
      });

      let json = {};
      try {
        json = await res.json();
      } catch (e) {}

      if (json?.metadata?.code && parseInt(json.metadata.code) !== 200) {
        setNewClaimResult({
          type: 'danger',
          text: json.metadata.message || `Gagal New Claim! (Error: ${json.metadata.error_no || json.metadata.code})`
        });
        return;
      }

      if (!res.ok) {
        setNewClaimResult({
          type: 'danger',
          text: json?.metadata?.message || json?.message || `Gagal memproses New Claim! Response HTTP ${res.status}.`
        });
        return;
      }

      setNewClaimResult({
        type: 'success',
        text: json?.metadata?.message || json?.message || `Pasien ${newClaimTarget.nama} berhasil didaftarkan ke E-Klaim (New Claim)!`
      });
    } catch (err) {
      console.warn('Gagal new claim:', err);
      setNewClaimResult({
        type: 'danger',
        text: `[Offline/Error] Gagal mendaftarkan pasien ke E-Klaim (No. SEP: ${newClaimTarget.no_sep})`
      });
    } finally {
      setIsProcessingNewClaim(false);
    }
  };

  // ── Handler Modal Config NIK Coder ──
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [tempNikCoder, setTempNikCoder] = useState(localStorage.getItem('nik_coder') || '');
  const [nikCoder, setNikCoder] = useState(localStorage.getItem('nik_coder') || '');

  const handleSaveConfig = (e) => {
    e.preventDefault();
    localStorage.setItem('nik_coder', tempNikCoder);
    setNikCoder(tempNikCoder);
    setShowConfigModal(false);
  };

  // ── Fetch Informasi Medis dari EHR (Linimasa) ──
  const fetchEhrMedicalInfo = async (no_sep) => {
    if (!no_sep || no_sep === '-' || !no_sep.trim()) {
      setEhrData(null);
      setEhrError('Nomor SEP tidak valid atau belum diisi');
      return;
    }
    setIsLoadingEhr(true);
    setEhrError(null);
    setEhrData(null);
    setShowEhrDetail(false);

    const apiUrl = getApiUrl() || 'http://localhost:8000';
    const token = localStorage.getItem('token') || '';
    const cleanSep = no_sep.trim();

    try {
      let res = await fetch(`${apiUrl}/get_ehr_medical_info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ no_sep: cleanSep })
      });

      if (!res.ok) {
        res = await fetch(`${apiUrl}/get_ehr_medical_info?no_sep=${encodeURIComponent(cleanSep)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
      }

      const json = await res.json();
      if (json && (json.status === 1 || json.status === '1' || json.found === true)) {
        setEhrData(json);
        setEhrError(null);
        if (json.count > 0 || json.found) {
          setShowEhrDetail(true);
          // Auto pilih tab yang memiliki data
          if (json.forms?.resume_medis_ranap?.length > 0) {
            setActiveEhrFormTab('resume');
          } else if (json.forms?.lainnya?.some(f => f.id_form === '11' || f.id_form === 11)) {
            setActiveEhrFormTab('resume_rajal');
          } else if (json.forms?.cppt?.length > 0) {
            setActiveEhrFormTab('cppt');
          } else if (json.forms?.ringkasan_masuk_keluar?.length > 0) {
            setActiveEhrFormTab('ringkasan');
          } else if (json.forms?.asesmen_awal_ranap?.length > 0) {
            setActiveEhrFormTab('asesmen');
          } else {
            setActiveEhrFormTab('cppt');
          }
        }
      } else {
        setEhrData(json || null);
        setEhrError(json?.msg || 'Data rekam medis elektronik tidak ditemukan di sistem EHR.');
      }
    } catch (err) {
      console.warn('Error fetching EHR medical info:', err);
      setEhrError('Gagal menghubungi service EHR: ' + (err.message || 'Network error'));
    } finally {
      setIsLoadingEhr(false);
    }
  };

  // ── Handler Modal Grouper E-Claim ──
  const handleOpenGrouper = (item) => {
    if (!item.no_sep || item.no_sep === '-' || item.no_sep.trim() === '') {
      setWarningPatientTarget(item);
      setShowSepWarningModal(true);
      return;
    }
    setGrouperTarget(item);
    setSelectedDiagnosaItem(item);
    setGrouperResult(null);
    setInputSitb(item.sitb || '');
    setSitbValidationResult(null);
    setShowGrouperModal(true);
    setActiveTabDiagnosa('diagnosa');
    setDiagnosaData({ list_diagnosa: [], list_prosedur: [] });
    handleOpenInputDiagnosa('diagnosa');
    fetchDiagnosaData(item);
    fetchEhrMedicalInfo(item.no_sep);
  };

  const handleValidateSitb = async (no_sep) => {
    setSitbValidationResult(null);
    if (!inputSitb) {
      setSitbValidationResult({ type: 'danger', text: "Harap isi Nomor Register SITB terlebih dahulu." });
      return;
    }
    if (!no_sep || no_sep === '-') {
      setSitbValidationResult({ type: 'danger', text: "Nomor SEP kosong. Harap isi/edit Nomor SEP sebelum memvalidasi SITB." });
      return;
    }
    setIsValidatingSitb(true);
    const apiUrl = getApiUrl() || 'http://202.155.94.169:8080';
    try {
      const res = await fetch(`${apiUrl}/validasi_sitb`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...{ no_sep: no_sep, nomor_register_sitb: inputSitb }, ...getEklaimParams() })
      });
      const json = await res.json();
      if (json.status === 1 || json.status === '1') {
        setSitbValidationResult({ type: 'success', text: `Validasi Berhasil! Pasien: ${json.nama_pasien || '-'}` });
      } else {
        setSitbValidationResult({ type: 'danger', text: `Gagal: ${json.msg || "SITB Tidak Valid."}` });
      }
    } catch (err) {
      setSitbValidationResult({ type: 'danger', text: "Error saat menghubungi backend untuk validasi SITB." });
    } finally {
      setIsValidatingSitb(false);
    }
  };

  const handleProcessGrouper = async () => {
    if (!grouperTarget) return;
    setIsGrouping(true);
    setGrouperResult(null);
    const apiUrl = getApiUrl();

    try {
      const tglMasukEhr = ehrData?.summary?.tanggal_masuk || 
        ehrData?.forms?.resume_medis_ranap?.[0]?.tanggal_masuk || 
        ehrData?.forms?.ringkasan_masuk_keluar?.[0]?.tanggal_masuk || 
        null;
      const tglMasukFinal = grouperTarget.tgl_masuk || tglMasukEhr || grouperTarget.tgl_daftar;

      // Susun diagnosa_str & prosedur_str dari urutan tampilan tabel
      const diagStr = (diagnosaData?.list_diagnosa || [])
        .map(d => String(d.kd_icd || '').trim())
        .filter(Boolean)
        .join('#');

      const procStr = (diagnosaData?.list_prosedur || [])
        .map(p => {
          const code = String(p.kd_icd || '').trim();
          if (!code) return '';
          const qty = parseInt(p.qty || p.multiplicity || 1);
          return qty > 1 && !code.includes('+') ? `${code}+${qty}` : code;
        })
        .filter(Boolean)
        .join('#');

      // 1. Set Claim Data terlebih dahulu
      const resSet = await fetch(`${apiUrl}/set_claim_data`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nomorsep: grouperTarget.no_sep,
          nomedrec: grouperTarget.no_medrec,
          nik_coder: nikCoder,
          tgl_masuk: tglMasukFinal,
          nomor_register_sitb: inputSitb || '',
          diagnosa: diagStr || undefined,
          procedure: procStr || undefined,
          ehr_summary: ehrData?.summary || null,
          ehr_data: ehrData || null
        })
      });

      let jsonSet = {};
      try {
        jsonSet = await resSet.json();
      } catch (e) {}

      if (jsonSet?.metadata?.code && parseInt(jsonSet.metadata.code) !== 200) {
        setGrouperResult({
          type: 'danger',
          text: jsonSet.metadata.message || `Gagal Set Claim Data! (Error: ${jsonSet.metadata.error_no || jsonSet.metadata.code})`,
          data: jsonSet
        });
        setIsGrouping(false);
        return;
      }

      if (!resSet.ok) {
        setGrouperResult({
          type: 'danger',
          text: jsonSet?.metadata?.message || jsonSet?.message || `Gagal memproses Set Claim Data! Response HTTP ${resSet.status}.`
        });
        setIsGrouping(false);
        return;
      }

      // 2. Jika sukses, lanjut ke proses Grouper E-Claim
      const res = await fetch(`${apiUrl}/groupinginacbs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nomorsep: grouperTarget.no_sep,
          nomedrec: grouperTarget.no_medrec,
          nik_coder: nikCoder,
          tgl_masuk: tglMasukFinal,
          nomor_register_sitb: inputSitb || '',
          diagnosa_str: diagStr || undefined,
          prosedur_str: procStr || undefined
        })
      });

      let json = {};
      try {
        json = await res.json();
      } catch (e) {}

      if (json?.metadata?.code && parseInt(json.metadata.code) !== 200) {
        setGrouperResult({
          type: 'danger',
          text: json.metadata.message || `Gagal Grouper! (Error: ${json.metadata.error_no || json.metadata.code})`,
          data: json
        });
        setIsGrouping(false);
        return;
      }

      if (!res.ok) {
        setGrouperResult({
          type: 'danger',
          text: json?.metadata?.message || json?.message || `Gagal memproses Grouper! Response HTTP ${res.status}.`
        });
        setIsGrouping(false);
        return;
      }

      setGrouperResult({
        type: 'success',
        text: json?.idrg_desc ? `Grouper Coding iDRG Berhasil: ${json.idrg_code || ''} - ${json.idrg_desc}` : (json?.metadata?.message || json?.message || `Proses Grouper Coding iDRG berhasil untuk pasien ${grouperTarget.nama}!`),
        data: json
      });
    } catch (err) {
      console.warn('Gagal grouper backend, menggunakan mode simulasi:', err);
      setGrouperResult({
        type: 'success',
        text: `[Simulasi] Grouper Coding iDRG berhasil diproses untuk No. SEP: ${grouperTarget.no_sep || '-'} (Kode iDRG: ${grouperTarget.kd_idrg || grouperTarget.kd_inacbg || 'Valid'})`,
        data: {
          idrg_code: grouperTarget.kd_idrg || grouperTarget.kd_inacbg || 'Valid',
          idrg_desc: 'Diagnosa tergrouping iDRG',
          cost_weight: '1.0245'
        }
      });
    } finally {
      setIsGrouping(false);
    }
  };

  const isGrouperLocked = Boolean(grouperResult?.type === 'success' || (grouperTarget?.kd_idrg && grouperTarget.kd_idrg !== '-'));

  const handleReeditGrouper = () => {
    setGrouperResult(null);
    notify('info', 'Edit Ulang iDRG Aktif', 'Kunci Grouper iDRG telah dibuka. Form input diagnosa & prosedur aktif kembali.');
  };

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR COMPACT HEADER ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-file-earmark-medical-fill text-warning fs-5"></i>
            SIMRS — Data Claim BPJS (Grouper E-Claim Rawat Inap)
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>

        {/* ── Stats Summary Bar ── */}
        <Row className="g-2 mb-2">
          {[
            { label: 'Total Pasien RI', val: claimList.length, icon: 'bi-people-fill', color: '#0d9488', bg: '#f0fdfa' },
            { label: 'Total Tarif BPJS', val: formatRp(claimList.reduce((acc, c) => acc + (c.bpjs || 0), 0)), icon: 'bi-cash-stack', color: '#2563eb', bg: '#eff6ff' },
            { label: 'Belum Punya SEP (-)', val: claimList.filter(c => !c.no_sep || c.no_sep === '-').length, icon: 'bi-exclamation-triangle-fill', color: '#d97706', bg: '#fffbeb' },
            { label: 'Ter-Grouper E-Claim', val: claimList.filter(c => c.kd_inacbg && c.kd_inacbg !== '-').length, icon: 'bi-check-circle-fill', color: '#16a34a', bg: '#f0fdf4' },
          ].map((s, i) => (
            <Col md={3} key={i}>
              <div style={{ background: s.bg, border: `1.5px solid ${s.color}22`, borderRadius: '10px', padding: '0.5rem 0.75rem', display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                <div style={{ background: s.color, borderRadius: '8px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <i className={`bi ${s.icon}`} style={{ color: '#fff', fontSize: '1rem' }}></i>
                </div>
                <div>
                  <div className="fw-bold" style={{ fontSize: typeof s.val === 'string' ? '0.85rem' : '1.1rem', color: s.color, lineHeight: 1.1 }}>{s.val}</div>
                  <div className="text-muted" style={{ fontSize: '0.68rem' }}>{s.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* ── Main Card ── */}
        <Card style={styles.mainCard} className="shadow-sm border-0">
          {/* Card Header */}
          <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }}
            className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span className="fw-bold">
              <i className="bi bi-journal-check me-1 text-warning"></i>
              Daftar Pasien Rawat Inap BPJS
            </span>
              <div className="d-flex align-items-center gap-2">
                <Button
                  variant="info"
                  size="sm"
                  onClick={() => window.open((getApiUrl() || 'http://202.155.94.169:8080') + '/download_panduan', '_blank')}
                  className="fw-semibold text-white shadow-sm d-flex align-items-center gap-1"
                  style={{ fontSize: '0.73rem', borderRadius: '6px' }}
                >
                  <i className="bi bi-file-earmark-word-fill"></i>
                  <span className="d-none d-md-inline">Panduan E-Klaim</span>
                </Button>
                <Button
                  variant="outline-warning"
                size="sm"
                onClick={() => { setTempNikCoder(nikCoder); setShowConfigModal(true); }}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
                title="Pengaturan NIK Coder"
              >
                <i className="bi bi-gear-fill"></i>
              </Button>
              <Button
                variant="outline-light"
                size="sm"
                onClick={fetchClaimData}
                disabled={isLoading}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
              >
                {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh Data
              </Button>
            </div>
          </div>

          <Card.Body style={{ padding: '0.6rem' }}>
            {/* ── Filter Controls ── */}
            <Row className="g-2 mb-2 align-items-center">
              {/* Search Bar */}
              <Col md={5}>
                <InputGroup size="sm">
                  <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                    <i className="bi bi-search text-muted"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Cari Nama, No MR, No Daftar, No SEP, Kode INA-CBG, Dokter..."
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  />
                  {searchQuery && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Col>

              {/* Status SEP Filter */}
              <Col md={3}>
                <Form.Select
                  size="sm"
                  value={filterSepStatus}
                  onChange={e => { setFilterSepStatus(e.target.value); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value="">Semua Status SEP</option>
                  <option value="ADA">Sudah Memiliki SEP</option>
                  <option value="KOSONG">Belum Punya SEP (-)</option>
                </Form.Select>
              </Col>

              {/* Rows Per Page */}
              <Col md={2}>
                <Form.Select
                  size="sm"
                  value={itemsPerPage}
                  onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value={10}>10 Baris</option>
                  <option value={20}>20 Baris</option>
                  <option value={50}>50 Baris</option>
                  <option value={100}>100 Baris</option>
                </Form.Select>
              </Col>

              <Col md={2} className="text-end">
                <Badge bg="info" className="p-2" style={{ fontSize: '0.72rem' }}>
                  Total: {filteredData.length} Data
                </Badge>
              </Col>
            </Row>

            {fetchError && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
              </div>
            )}

            {/* ── Data Table ── */}
            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto' }}>
              <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center" style={{ width: '40px' }}>#</th>
                    <th>No. MR</th>
                    <th>Nama Pasien</th>
                    <th>No. Pendaftaran</th>
                    <th className="text-center">Tgl Daftar</th>
                    <th className="text-center">Kamar</th>
                    <th>Dokter DPJP</th>
                    <th className="text-center">Klasifikasi</th>
                    <th className="text-center">No. SEP</th>
                    <th className="text-center">Kode INA-CBG</th>
                    <th className="text-end">Tarif BPJS</th>
                    <th className="text-end">Limit 2</th>
                    <th className="text-center" style={{ width: '120px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="13" className="text-center py-4">
                        <Spinner animation="border" variant="teal" size="sm" className="me-2" />
                        <span>Memuat data claim BPJS...</span>
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>

                        {/* No MR */}
                        <td>
                          <span className="fw-bold font-monospace text-teal" style={{ color: '#0d9488' }}>
                            {item.no_medrec}
                          </span>
                        </td>

                        {/* Nama Pasien */}
                        <td className="fw-semibold text-dark">
                          {item.nama}
                        </td>

                        {/* No Daftar */}
                        <td>
                          <span className="font-monospace text-muted" style={{ fontSize: '0.71rem' }}>
                            {item.no_daftar}
                          </span>
                        </td>

                        {/* Tgl Daftar */}
                        <td className="text-center">
                          <Badge bg="light" text="dark" className="border" style={{ fontSize: '0.68rem' }}>
                            <i className="bi bi-calendar-check me-1 text-primary"></i>
                            {item.tgl_daftar}
                          </Badge>
                        </td>

                        {/* No Kamar */}
                        <td className="text-center">
                          <Badge bg="secondary" style={{ fontSize: '0.68rem', borderRadius: '12px' }}>
                            <i className="bi bi-door-closed me-1"></i>{item.no_kamar}
                          </Badge>
                        </td>

                        {/* Nama Dokter */}
                        <td style={{ fontSize: '0.72rem' }}>
                          <i className="bi bi-person-badge text-primary me-1"></i>
                          {item.nama_dokter}
                        </td>

                        {/* Klasifikasi */}
                        <td className="text-center">
                          <Badge bg="success" style={{ fontSize: '0.68rem' }}>
                            {item.nm_klasifikasi}
                          </Badge>
                        </td>

                        {/* No SEP & Edit Button */}
                        <td className="text-center">
                          <div className="d-flex align-items-center justify-content-center gap-1">
                            {item.no_sep && item.no_sep !== '-' ? (
                              <Badge bg="info" text="white" className="font-monospace" style={{ fontSize: '0.7rem' }}>
                                {item.no_sep}
                              </Badge>
                            ) : (
                              <Badge bg="warning" text="dark" style={{ fontSize: '0.68rem' }}>
                                Belum Ada SEP
                              </Badge>
                            )}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Nomor SEP Pasien</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-primary"
                                style={{ padding: '0.1rem 0.35rem', fontSize: '0.68rem', borderRadius: '5px' }}
                                onClick={() => handleOpenEditSep(item)}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>

                        {/* Kode INA-CBG */}
                        <td className="text-center">
                          {item.kd_inacbg && item.kd_inacbg !== '-' ? (
                            <Badge bg="dark" className="font-monospace" style={{ fontSize: '0.7rem', backgroundColor: '#1e293b' }}>
                              {item.kd_inacbg}
                            </Badge>
                          ) : (
                            <span className="text-muted" style={{ fontSize: '0.7rem' }}>—</span>
                          )}
                        </td>

                        {/* BPJS */}
                        <td className="text-end fw-bold text-success" style={{ fontSize: '0.74rem' }}>
                          {formatRp(item.bpjs)}
                        </td>

                        {/* Limit 2 */}
                        <td className="text-end fw-semibold text-primary" style={{ fontSize: '0.74rem' }}>
                          {formatRp(item.limit2)}
                        </td>

                        {/* Tombol Aksi */}
                        <td className="text-center" style={{ width: '120px' }}>
                          <div className="d-inline-flex justify-content-center align-items-center gap-1">
                            <Button
                              size="sm"
                              className="d-inline-flex align-items-center gap-1 fw-bold text-white shadow-xs"
                              style={{
                                background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '3px 8px',
                                fontSize: '0.7rem'
                              }}
                              onClick={() => handleOpenGrouper(item)}
                              title="Proses Grouper E-Claim"
                            >
                              <i className="bi bi-cpu-fill" style={{ fontSize: '0.72rem' }}></i>
                              <span>Grouper</span>
                            </Button>

                            <Dropdown align="end">
                              <Dropdown.Toggle 
                                variant="light" 
                                size="sm" 
                                className="border d-inline-flex align-items-center justify-content-center p-0"
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '6px',
                                  background: '#f8fafc',
                                  borderColor: '#cbd5e1',
                                  color: '#475569'
                                }}
                                title="Menu Lainnya"
                              >
                                <i className="bi bi-three-dots-vertical" style={{ fontSize: '0.72rem' }}></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu style={{ fontSize: '0.75rem', borderRadius: '10px', padding: '6px', minWidth: '180px' }} className="shadow-lg border-0">
                                <Dropdown.Item onClick={() => handleOpenNewClaim(item)} className="fw-semibold text-primary rounded px-2 py-1"><i className="bi bi-file-earmark-plus-fill text-primary me-2"></i>New Claim</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleOpenAction(item, 'idrg_final', 'Finalisasi iDRG')} className="fw-semibold text-primary rounded px-2 py-1"><i className="bi bi-lock-fill text-primary me-2"></i>Finalisasi iDRG</Dropdown.Item>
                                <Dropdown.Item onClick={() => handleOpenAction(item, 'finalisasi', 'Finalisasi Klaim (Kunci)')} className="fw-semibold text-success rounded px-2 py-1"><i className="bi bi-shield-lock-fill text-success me-2"></i>Finalisasi Klaim</Dropdown.Item>
                                <Dropdown.Divider className="my-1" />
                                <Dropdown.Item onClick={(e) => { e.stopPropagation(); handleOpenAction(item, 'status', 'Cek Status Klaim'); }} className="rounded px-2 py-1"><i className="bi bi-info-circle text-info me-2"></i>Cek Status Klaim</Dropdown.Item>
                                <Dropdown.Item 
                                  onClick={(e) => { 
                                    e.stopPropagation(); 
                                    if (item.klaim_final) handleSendClaimOnline(item); 
                                  }} 
                                  disabled={!item.klaim_final || isSendingOnline}
                                  className={`rounded px-2 py-1 ${item.klaim_final ? 'text-primary fw-semibold' : 'text-muted'}`}
                                  style={{ cursor: item.klaim_final && !isSendingOnline ? 'pointer' : 'not-allowed', opacity: item.klaim_final ? 1 : 0.5 }}
                                  title={item.klaim_final ? "Kirim Klaim Online ke Data Center Kemenkes" : "Klaim belum final (Tombol nonaktif)"}
                                >
                                  <i className={`bi bi-cloud-arrow-up-fill me-2 ${item.klaim_final ? 'text-primary' : 'text-secondary'}`}></i>Kirim Klaim Online
                                </Dropdown.Item>
                                <Dropdown.Item onClick={(e) => { e.stopPropagation(); handleOpenAction(item, 'reedit', 'Re-Edit Klaim (Buka Kunci)'); }} className="rounded px-2 py-1"><i className="bi bi-unlock text-warning me-2"></i>Re-Edit Klaim</Dropdown.Item>
                                <Dropdown.Divider className="my-1" />
                                <Dropdown.Item onClick={(e) => { e.stopPropagation(); handleOpenAction(item, 'hapus', 'Hapus Klaim (Batal)'); }} className="text-danger fw-semibold rounded px-2 py-1"><i className="bi bi-trash text-danger me-2"></i>Hapus Klaim</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="13" className="text-center py-4 text-muted">
                        Tidak ada data claim BPJS yang ditemukan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination size="sm" className="mb-0">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                  {[...Array(Math.min(totalPages, 10))].map((_, i) => (
                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  {totalPages > 10 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                </Pagination>
              </div>
            )}

            {/* ── Footer Info ── */}
            <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
              <span>
                Menampilkan{' '}
                <strong>{filteredData.length > 0 ? indexOfFirst + 1 : 0}–{Math.min(indexOfLast, filteredData.length)}</strong>{' '}
                dari <strong>{filteredData.length}</strong> pasien (Total: {claimList.length})
              </span>
              <span>IP Server: <strong>{getApiUrl()}</strong></span>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ══ MODAL EDIT NOMOR SEP ══ */}
      <Modal show={showEditSepModal} onHide={() => setShowEditSepModal(false)} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square text-warning fs-5"></i>
            <span>Edit Nomor SEP Pasien</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {selectedPatient && (
            <Form onSubmit={handleSaveSep}>
              <div className="alert alert-primary py-2 px-3 mb-3" style={{ fontSize: '0.75rem', borderRadius: '8px' }}>
                <div><strong>Nama Pasien:</strong> {selectedPatient.nama}</div>
                <div><strong>No. Medrec:</strong> {selectedPatient.no_medrec} | <strong>No. Daftar:</strong> {selectedPatient.no_daftar}</div>
                <div><strong>Dokter DPJP:</strong> {selectedPatient.nama_dokter}</div>
              </div>

              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                  Nomor SEP BPJS Pasien
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Contoh: 0117R0750726V000102"
                  value={inputNoSep}
                  onChange={e => setInputNoSep(e.target.value)}
                  style={{ fontSize: '0.85rem', fontWeight: '600' }}
                  required
                />
                <Form.Text className="text-muted" style={{ fontSize: '0.68rem' }}>
                  Masukkan nomor SEP BPJS resmi pasien untuk keperluan Grouper E-Claim.
                </Form.Text>
              </Form.Group>

              {sepFeedback && (
                <div className={`alert alert-${sepFeedback.type} py-1 px-2 mb-3`} style={{ fontSize: '0.73rem' }}>
                  <i className="bi bi-info-circle-fill me-1"></i>
                  {sepFeedback.text}
                </div>
              )}

              <div className="d-flex justify-content-end gap-2 border-top pt-2">
                <Button type="button" variant="secondary" size="sm" onClick={() => setShowEditSepModal(false)} disabled={isSavingSep}>
                  Batal
                </Button>
                <Button type="submit" size="sm" variant="primary" className="fw-bold" disabled={isSavingSep}>
                  {isSavingSep ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-save me-1"></i>}
                  Simpan Nomor SEP
                </Button>
              </div>
            </Form>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL GROUPER E-CLAIM (TERPUSAT DENGAN DIAGNOSA & PROSEDUR) ══ */}
      <Modal show={showGrouperModal} onHide={() => setShowGrouperModal(false)} centered backdrop="static" size="xl">
        <Modal.Header closeButton style={{
          background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
          color: '#fff',
          padding: '12px 20px',
          borderBottom: 'none'
        }}>
          <Modal.Title className="d-flex align-items-center gap-2" style={{ fontSize: '0.95rem', fontWeight: '700', letterSpacing: '0.01em' }}>
            <div style={{
              width: '32px', height: '32px', borderRadius: '8px',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <i className="bi bi-cpu-fill fs-6"></i>
            </div>
            <div>
              <div>Proses Grouper E-Claim BPJS</div>
              <div style={{ fontSize: '0.7rem', fontWeight: '400', opacity: 0.85 }}>Verifikasi Diagnosa &amp; Penentuan Tarif INA-CBG</div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0" style={{ background: '#f8fafc' }}>
          {grouperTarget && (
            <div>
              {/* ── INFO PASIEN STRIP ── */}
              <div style={{
                background: 'linear-gradient(135deg, #e0f2fe 0%, #e0fdf4 100%)',
                borderBottom: '1px solid #cbd5e1',
                padding: '10px 20px'
              }}>
                <div className="d-flex flex-wrap align-items-start gap-3" style={{ fontSize: '0.76rem' }}>
                  <div style={{ minWidth: '160px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Nama Pasien</div>
                    <div className="fw-bold text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.2' }}>{grouperTarget.nama}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '120px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>No. Medrec</div>
                    <div className="fw-semibold font-monospace text-dark" style={{ fontSize: '0.8rem' }}>{grouperTarget.no_medrec}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '120px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>No. Daftar</div>
                    <div className="fw-semibold font-monospace text-dark" style={{ fontSize: '0.8rem' }}>{grouperTarget.no_daftar || '-'}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '150px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Nomor SEP</div>
                    <div className="fw-bold font-monospace text-primary" style={{ fontSize: '0.8rem' }}>{grouperTarget.no_sep || '-'}</div>
                  </div>
                  <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '120px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Tarif BPJS</div>
                    <div className="fw-bold text-success" style={{ fontSize: '0.82rem' }}>
                      {formatRp(grouperTarget.bpjs)}
                    </div>
                  </div>
                  <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '120px' }}>
                    <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Limit 2</div>
                    <div className="fw-bold text-primary" style={{ fontSize: '0.82rem' }}>
                      {formatRp(grouperTarget.limit2)}
                    </div>
                  </div>
                  {grouperTarget.kd_inacbg && (
                    <div style={{ borderLeft: '1px solid #94a3b8', paddingLeft: '12px', minWidth: '120px' }}>
                      <div className="text-muted" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600' }}>Kode INA-CBG</div>
                      <div className="fw-bold font-monospace text-dark" style={{ fontSize: '0.78rem' }}>{grouperTarget.kd_inacbg}</div>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '12px' }}>

                {/* ── PERINGATAN SEP KOSONG ── */}
                {(!grouperTarget?.no_sep || grouperTarget.no_sep === '-') && (
                  <div style={{
                    background: '#fef2f2', border: '1px solid #fca5a5',
                    borderRadius: '10px', padding: '10px 14px',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px',
                    fontSize: '0.76rem'
                  }}>
                    <div className="d-flex align-items-center gap-2">
                      <i className="bi bi-exclamation-triangle-fill text-danger fs-5"></i>
                      <div>
                        <div className="fw-bold text-danger" style={{ fontSize: '0.78rem' }}>Nomor SEP Belum Diisi</div>
                        <div className="text-muted" style={{ fontSize: '0.7rem' }}>Silakan ubah dan isi Nomor SEP sebelum menjalankan Grouper.</div>
                      </div>
                    </div>
                    <Button
                      size="sm"
                      variant="warning"
                      className="fw-bold text-dark flex-shrink-0"
                      style={{ fontSize: '0.72rem', borderRadius: '6px', whiteSpace: 'nowrap' }}
                      onClick={() => { setShowGrouperModal(false); handleOpenEditSep(grouperTarget); }}
                    >
                      <i className="bi bi-pencil-square me-1"></i> Ubah SEP
                    </Button>
                  </div>
                )}

                {/* ══ SECTION: DIAGNOSA & PROSEDUR ══ */}
                <div style={{
                  background: '#ffffff',
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  overflow: 'visible',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                }}>
                  {/* Section Header */}
                  <div style={{
                    padding: '10px 14px',
                    background: '#f1f5f9',
                    borderBottom: '1px solid #e2e8f0',
                    borderRadius: '11px 11px 0 0',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px'
                  }}>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{
                        width: '26px', height: '26px', borderRadius: '6px',
                        background: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                      }}>
                        <i className="bi bi-clipboard2-pulse-fill text-white" style={{ fontSize: '0.7rem' }}></i>
                      </div>
                      <span className="fw-bold text-dark" style={{ fontSize: '0.82rem' }}>Diagnosa dan Prosedur iDRG</span>

                      {/* Tab Toggle Pills */}
                      <div style={{
                        display: 'flex', background: '#e2e8f0', borderRadius: '8px', padding: '2px', gap: '2px'
                      }}>
                        <button
                          onClick={() => {
                            setActiveTabDiagnosa('diagnosa');
                            handleOpenInputDiagnosa('diagnosa');
                          }}
                          style={{
                            border: 'none', borderRadius: '6px', padding: '3px 10px', cursor: 'pointer',
                            fontSize: '0.72rem', fontWeight: '600', transition: 'all 0.15s',
                            background: activeTabDiagnosa === 'diagnosa' ? '#ffffff' : 'transparent',
                            color: activeTabDiagnosa === 'diagnosa' ? '#1d4ed8' : '#64748b',
                            boxShadow: activeTabDiagnosa === 'diagnosa' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none'
                          }}
                        >
                          <i className="bi bi-clipboard2-pulse-fill me-1"></i>
                          ICD-10
                          <span style={{
                            marginLeft: '4px', background: activeTabDiagnosa === 'diagnosa' ? '#dbeafe' : '#e2e8f0',
                            color: activeTabDiagnosa === 'diagnosa' ? '#1d4ed8' : '#64748b',
                            borderRadius: '10px', padding: '0 6px', fontSize: '0.65rem', fontWeight: '700'
                          }}>
                            {diagnosaData.list_diagnosa?.length || 0}
                          </span>
                        </button>
                        <button
                          onClick={() => {
                            setActiveTabDiagnosa('prosedur');
                            handleOpenInputDiagnosa('prosedur');
                          }}
                          style={{
                            border: 'none', borderRadius: '6px', padding: '3px 10px', cursor: 'pointer',
                            fontSize: '0.72rem', fontWeight: '600', transition: 'all 0.15s',
                            background: activeTabDiagnosa === 'prosedur' ? '#ffffff' : 'transparent',
                            color: activeTabDiagnosa === 'prosedur' ? '#059669' : '#64748b',
                            boxShadow: activeTabDiagnosa === 'prosedur' ? '0 1px 3px rgba(0,0,0,0.15)' : 'none'
                          }}
                        >
                          <i className="bi bi-scissors me-1"></i>
                          ICD-9-CM
                          <span style={{
                            marginLeft: '4px', background: activeTabDiagnosa === 'prosedur' ? '#d1fae5' : '#e2e8f0',
                            color: activeTabDiagnosa === 'prosedur' ? '#059669' : '#64748b',
                            borderRadius: '10px', padding: '0 6px', fontSize: '0.65rem', fontWeight: '700'
                          }}>
                            {diagnosaData.list_prosedur?.length || 0}
                          </span>
                        </button>
                      </div>
                    </div>

                    {/* Tombol Input Diagnosa, Input Prosedur & Tombol Grouper Coding iDRG */}
                    <div className="d-flex align-items-center gap-2">
                      {/* Tombol Edit Ulang iDRG jika sudah grouper */}
                      {isGrouperLocked && (
                        <Button
                          size="sm"
                          variant="outline-warning"
                          onClick={handleReeditGrouper}
                          className="fw-bold shadow-sm d-flex align-items-center gap-1 text-dark"
                          style={{
                            background: '#fffbeb',
                            border: '1px solid #f59e0b',
                            borderRadius: '7px',
                            padding: '4px 10px',
                            fontSize: '0.74rem'
                          }}
                          title="Buka kunci Grouper iDRG untuk edit ulang koding"
                        >
                          <i className="bi bi-unlock-fill text-warning"></i> Edit Ulang iDRG
                        </Button>
                      )}
                      <Button
                        size="sm"
                        onClick={handleProcessGrouper}
                        disabled={isGrouping || !grouperTarget?.no_sep || grouperTarget.no_sep === '-'}
                        className="fw-bold text-white shadow-sm d-flex align-items-center gap-1"
                        style={{
                          background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)',
                          border: 'none',
                          borderRadius: '7px',
                          padding: '4px 12px',
                          fontSize: '0.74rem'
                        }}
                        title="Jalankan Grouper Coding iDRG langsung dari tabel diagnosa & prosedur"
                      >
                        {isGrouping ? (
                          <><Spinner size="sm" animation="border" style={{ width: '12px', height: '12px', borderWidth: '1.5px' }} /> Proses...</>
                        ) : (
                          <><i className="bi bi-cpu-fill"></i> Grouper Coding iDRG</>
                        )}
                      </Button>
                    </div>
                  </div>

                  {/* ── Inline Form Input Diagnosa / Prosedur ── */}
                  {showInlineInput && (
                    <div style={{
                      background: inputDiagnosaType === 'diagnosa'
                        ? 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)'
                        : 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
                      borderBottom: `2px solid ${inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7'}`,
                      padding: '10px 12px'
                    }}>
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <i className={`bi ${inputDiagnosaType === 'diagnosa' ? 'bi-clipboard2-pulse-fill text-primary' : 'bi-scissors text-success'}`} style={{ fontSize: '0.85rem' }}></i>
                        <span style={{ fontSize: '0.78rem', fontWeight: '700', color: inputDiagnosaType === 'diagnosa' ? '#1d4ed8' : '#047857' }}>
                          {inputDiagnosaType === 'diagnosa' ? 'Input Diagnosa ICD-10 IM' : 'Input Prosedur ICD-9-CM IM'}
                        </span>
                        {isGrouperLocked && (
                          <span className="badge bg-warning text-dark px-2 py-1" style={{ fontSize: '0.65rem' }}>
                            <i className="bi bi-lock-fill me-1"></i>Terkunci Grouper
                          </span>
                        )}
                        {isLoadingMasterIcd && (
                          <span style={{ fontSize: '0.68rem', color: '#64748b' }} className="d-flex align-items-center gap-1">
                            <Spinner animation="border" size="sm" style={{ width: '10px', height: '10px', borderWidth: '1.5px' }} /> Memuat master...
                          </span>
                        )}
                        <button
                          onClick={() => { setShowInlineInput(false); setIcdCheckMsg(null); setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); }}
                          style={{ marginLeft: 'auto', border: 'none', background: 'transparent', cursor: 'pointer', color: '#64748b', padding: '2px 6px', borderRadius: '4px', fontSize: '0.8rem' }}
                          title="Tutup form input"
                        >
                          <i className="bi bi-x-lg"></i>
                        </button>
                      </div>
                      <div className="d-flex align-items-start gap-2 flex-wrap">
                        {/* Status Diagnosa (hanya untuk diagnosa, bukan prosedur) */}
                        {inputDiagnosaType === 'diagnosa' && (
                          <div style={{ minWidth: '120px' }}>
                            <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: '600', marginBottom: '3px' }}>Status</div>
                            <select
                              disabled={isGrouperLocked}
                              size="1"
                              value={formInputDiagnosa.ket}
                              onChange={e => {
                                const val = e.target.value;
                                setFormInputDiagnosa(prev => ({ ...prev, ket: val, utama: val === 'Utama' ? 1 : 0 }));
                              }}
                              style={{ fontSize: '0.75rem', fontWeight: '600', border: '1px solid #93c5fd', borderRadius: '6px', padding: '3px 6px', width: '100%', background: '#fff' }}
                            >
                              <option value="Utama">🟡 Utama</option>
                              <option value="Sekunder">🔵 Sekunder</option>
                              <option value="Tambahan">⚪ Tambahan</option>
                            </select>
                          </div>
                        )}
                        {/* Kode ICD dengan autocomplete */}
                        <div style={{ flex: '0 0 140px', position: 'relative' }}>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: '600', marginBottom: '3px' }}>
                            {inputDiagnosaType === 'diagnosa' ? 'Kode ICD-10' : 'Kode ICD-9-CM'}
                          </div>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <input
                              disabled={isGrouperLocked}
                              type="text"
                              value={formInputDiagnosa.kd_icd}
                              placeholder="Cari kode/nama..."
                              onClick={() => {
                                if (isGrouperLocked) return;
                                if (inputDiagnosaType === 'diagnosa') { setShowIcd10Autocomplete(true); if (masterIcd10.length === 0 && !isLoadingMasterIcd) fetchMasterIcd('diagnosa'); }
                                else { setShowIcd9Autocomplete(true); if (masterIcd9.length === 0 && !isLoadingMasterIcd) fetchMasterIcd('prosedur'); }
                              }}
                              onFocus={() => {
                                if (isGrouperLocked) return;
                                if (inputDiagnosaType === 'diagnosa') { setShowIcd10Autocomplete(true); if (masterIcd10.length === 0 && !isLoadingMasterIcd) fetchMasterIcd('diagnosa'); }
                                else { setShowIcd9Autocomplete(true); if (masterIcd9.length === 0 && !isLoadingMasterIcd) fetchMasterIcd('prosedur'); }
                              }}
                              onChange={e => {
                                const val = e.target.value;
                                setFormInputDiagnosa(prev => ({ ...prev, kd_icd: val, nm_icd: '' }));
                                setIcdCheckMsg(null);
                                if (inputDiagnosaType === 'diagnosa') setShowIcd10Autocomplete(true);
                                else setShowIcd9Autocomplete(true);
                              }}
                              onKeyDown={e => {
                                if (e.key === 'Enter') { e.preventDefault(); setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); handleCheckIcd(formInputDiagnosa.kd_icd); }
                                else if (e.key === 'Escape') { setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); }
                              }}
                              onBlur={() => { setTimeout(() => { setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); }, 250); if (formInputDiagnosa.kd_icd && !formInputDiagnosa.nm_icd) handleCheckIcd(formInputDiagnosa.kd_icd); }}
                              style={{
                                flex: 1, fontSize: '0.78rem', fontWeight: formInputDiagnosa.kd_icd ? '700' : '400',
                                fontFamily: 'monospace', border: `1px solid ${inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7'}`,
                                borderRadius: '6px', padding: '3px 8px', outline: 'none', width: '100%',
                                color: inputDiagnosaType === 'diagnosa' ? '#1d4ed8' : '#047857'
                              }}
                            />
                          </div>
                          {/* Autocomplete dropdown — ICD-10 */}
                          {inputDiagnosaType === 'diagnosa' && showIcd10Autocomplete && (
                            <div style={{
                              position: 'absolute', top: '100%', left: 0, width: '560px', maxWidth: '85vw', zIndex: 9999,
                              maxHeight: '280px', overflowY: 'auto', background: '#ffffff',
                              border: '2px solid #3b82f6', borderRadius: '0 0 8px 8px',
                              boxShadow: '0 8px 24px rgba(59,130,246,0.22)', marginTop: '-1px'
                            }}>
                              <div className="px-2 py-1 sticky-top" style={{ background: '#eff6ff', borderBottom: '1px solid #bfdbfe', fontSize: '0.68rem', color: '#1d4ed8', fontWeight: '700' }}>
                                Master ICD-10 IM — {isLoadingMasterIcd ? 'Memuat...' : `${filteredIcd10Suggestions.length} hasil`}
                              </div>
                              {isLoadingMasterIcd ? (
                                <div className="p-3 text-center text-muted" style={{ fontSize: '0.75rem' }}>
                                  <Spinner animation="border" size="sm" variant="primary" className="me-2" /> Memuat...
                                </div>
                              ) : filteredIcd10Suggestions.slice(0, 50).map((item, idx) => {
                                const code = item.icd || item.kode || item.kd_icd || '';
                                const desc = item.deskripsi || item.nm_icd || item.penyakit || '';
                                const isHeader = item.validcode === 0 || item.validcode === '0' || item.validcode === false;
                                const isAccpdxNo = String(item.accpdx || '').trim().toUpperCase() === 'N';
                                return (
                                  <div key={`bpjs-inline-icd10-${code}-${idx}`}
                                    onMouseDown={() => {
                                      handleSelectIcd10FromDropdown(item);
                                      setShowIcd10Autocomplete(false);
                                    }}
                                    style={{
                                      padding: '6px 12px',
                                      cursor: 'pointer',
                                      opacity: 1,
                                      borderBottom: '1px solid #f1f5f9',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '10px'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                  >
                                    <span className={`badge ${isHeader ? 'bg-warning text-dark' : 'bg-primary'} font-monospace flex-shrink-0`} style={{ fontSize: '0.72rem', minWidth: '60px', textAlign: 'center' }}>{code}</span>
                                    <span style={{ fontSize: '0.76rem', color: '#1e293b', flex: 1, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.25' }}>{desc}</span>
                                    {isHeader && (
                                      <span className="badge bg-warning text-dark" style={{ fontSize: '0.62rem' }}>Header</span>
                                    )}
                                    {isAccpdxNo && !isHeader && (
                                      <span className="badge bg-warning text-dark" style={{ fontSize: '0.62rem' }}>accpdx: N (Sekunder)</span>
                                    )}
                                  </div>
                                );
                              })}
                              {!isLoadingMasterIcd && filteredIcd10Suggestions.length === 0 && (
                                <div className="p-3 text-center text-muted" style={{ fontSize: '0.73rem' }}>Tidak ada hasil untuk "{formInputDiagnosa.kd_icd}"</div>
                              )}
                            </div>
                          )}
                          {/* Autocomplete dropdown — ICD-9 */}
                          {inputDiagnosaType === 'prosedur' && showIcd9Autocomplete && (
                            <div style={{
                              position: 'absolute', top: '100%', left: 0, width: '560px', maxWidth: '85vw', zIndex: 9999,
                              maxHeight: '280px', overflowY: 'auto', background: '#ffffff',
                              border: '2px solid #10b981', borderRadius: '0 0 8px 8px',
                              boxShadow: '0 8px 24px rgba(16,185,129,0.22)', marginTop: '-1px'
                            }}>
                              <div className="px-2 py-1 sticky-top" style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', fontSize: '0.68rem', color: '#047857', fontWeight: '700' }}>
                                Master ICD-9-CM IM — {isLoadingMasterIcd ? 'Memuat...' : `${filteredIcd9Suggestions.length} hasil`}
                              </div>
                              {isLoadingMasterIcd ? (
                                <div className="p-3 text-center text-muted" style={{ fontSize: '0.75rem' }}>
                                  <Spinner animation="border" size="sm" variant="success" className="me-2" /> Memuat...
                                </div>
                              ) : filteredIcd9Suggestions.slice(0, 50).map((item, idx) => {
                                const code = item.kode || item.icd || item.kd_icd || '';
                                const desc = item.deskripsi || item.nm_icd || '';
                                return (
                                  <div key={`bpjs-inline-icd9-${code}-${idx}`}
                                    onMouseDown={() => { handleSelectIcd9FromDropdown(item); setShowIcd9Autocomplete(false); }}
                                    style={{ padding: '6px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: '10px' }}
                                    onMouseEnter={e => e.currentTarget.style.background = '#f0fdf4'}
                                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                  >
                                    <span className="badge bg-success font-monospace flex-shrink-0" style={{ fontSize: '0.72rem', minWidth: '60px', textAlign: 'center' }}>{code}</span>
                                    <span style={{ fontSize: '0.76rem', color: '#1e293b', flex: 1, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.25' }}>{desc}</span>
                                  </div>
                                );
                              })}
                              {!isLoadingMasterIcd && filteredIcd9Suggestions.length === 0 && (
                                <div className="p-3 text-center text-muted" style={{ fontSize: '0.73rem' }}>Tidak ada hasil untuk "{formInputDiagnosa.kd_icd}"</div>
                              )}
                            </div>
                          )}
                        </div>
                        {/* Nama Diagnosa / Prosedur */}
                        <div style={{ flex: 1, minWidth: '160px' }}>
                          <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: '600', marginBottom: '3px' }}>
                            {inputDiagnosaType === 'diagnosa' ? 'Nama Diagnosa' : 'Nama Prosedur'}
                          </div>
                          <input
                            disabled={isGrouperLocked}
                            type="text"
                            value={formInputDiagnosa.nm_icd}
                            onChange={e => setFormInputDiagnosa(prev => ({ ...prev, nm_icd: e.target.value }))}
                            placeholder="Terisi otomatis saat pilih dari daftar..."
                            style={{
                              width: '100%', fontSize: '0.75rem', fontWeight: formInputDiagnosa.nm_icd ? '600' : '400',
                              border: `1px solid ${inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7'}`,
                              borderRadius: '6px', padding: '3px 8px', outline: 'none'
                            }}
                          />
                        </div>
                        {/* Multiplicity (untuk prosedur saja) */}
                        {inputDiagnosaType === 'prosedur' && (
                          <div style={{ minWidth: '80px' }}>
                            <div style={{ fontSize: '0.68rem', color: '#64748b', fontWeight: '600', marginBottom: '3px' }}>Qty (x)</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                              <button disabled={isGrouperLocked} onClick={() => handleMultiplicityChange(Math.max(1, (Number(formInputDiagnosa.multiplicity) || 1) - 1))}
                                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '2px 6px', cursor: 'pointer', background: '#f8fafc', fontSize: '0.75rem' }}>−</button>
                              <input disabled={isGrouperLocked} type="number" min={1} max={99} value={formInputDiagnosa.multiplicity || 1}
                                onChange={e => handleMultiplicityChange(e.target.value)}
                                style={{ width: '38px', textAlign: 'center', fontSize: '0.78rem', fontWeight: '700', fontFamily: 'monospace', border: '1px solid #6ee7b7', borderRadius: '4px', padding: '2px 4px' }}
                              />
                              <button disabled={isGrouperLocked} onClick={() => handleMultiplicityChange((Number(formInputDiagnosa.multiplicity) || 1) + 1)}
                                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '2px 6px', cursor: 'pointer', background: '#f8fafc', fontSize: '0.75rem' }}>+</button>
                            </div>
                          </div>
                        )}
                        {/* Tombol Simpan & Batal */}
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '6px', paddingBottom: '0' }}>
                          <button
                            onClick={handleSaveInputDiagnosa}
                            disabled={isGrouperLocked || isSavingDiagnosa || !formInputDiagnosa.kd_icd}
                            style={{
                              border: 'none', borderRadius: '6px', padding: '4px 14px',
                              fontSize: '0.75rem', fontWeight: '700', color: '#ffffff', cursor: isSavingDiagnosa || !formInputDiagnosa.kd_icd ? 'not-allowed' : 'pointer',
                              opacity: isSavingDiagnosa || !formInputDiagnosa.kd_icd ? 0.6 : 1,
                              background: inputDiagnosaType === 'diagnosa' ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)' : 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                              display: 'flex', alignItems: 'center', gap: '5px', marginTop: '17px'
                            }}
                          >
                            {isSavingDiagnosa
                              ? <><Spinner animation="border" size="sm" style={{ width: '11px', height: '11px', borderWidth: '1.5px' }} /> Simpan...</>
                              : <><i className="bi bi-check-circle-fill"></i> Simpan</>
                            }
                          </button>
                          <button
                            onClick={() => { setShowInlineInput(false); setIcdCheckMsg(null); setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); setFormInputDiagnosa(prev => ({ ...prev, kd_icd: '', nm_icd: '', multiplicity: 1 })); }}
                            style={{
                              border: '1px solid #d1d5db', borderRadius: '6px', padding: '4px 10px',
                              fontSize: '0.75rem', fontWeight: '600', color: '#64748b', cursor: 'pointer',
                              background: '#ffffff', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '17px'
                            }}
                          >
                            <i className="bi bi-x-circle"></i> Batal
                          </button>
                        </div>
                      </div>
                      {/* Feedback validasi kode */}
                      {icdCheckMsg && !/header code/i.test(icdCheckMsg.text || '') && (
                        <div className={`d-flex align-items-center gap-2 mt-2 p-2 rounded-2 ${icdCheckMsg.type === 'success' ? 'bg-success bg-opacity-10 border border-success border-opacity-25' : icdCheckMsg.type === 'info' ? 'bg-info bg-opacity-10 border border-info border-opacity-25' : 'bg-danger bg-opacity-10 border border-danger border-opacity-25'}`} style={{ fontSize: '0.72rem' }}>
                          <i className={`bi ${icdCheckMsg.type === 'success' ? 'bi-check-circle-fill text-success' : icdCheckMsg.type === 'info' ? 'bi-info-circle-fill text-info' : 'bi-exclamation-triangle-fill text-danger'} flex-shrink-0`}></i>
                          <span className={`fw-semibold ${icdCheckMsg.type === 'success' ? 'text-success' : icdCheckMsg.type === 'info' ? 'text-info' : 'text-danger'}`}>{icdCheckMsg.text}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Table Content */}
                  {isLoadingDiagnosa ? (
                    <div className="text-center py-4">
                      <Spinner animation="border" size="sm" style={{ color: '#6366f1' }} className="me-2" />
                      <span style={{ fontSize: '0.78rem', color: '#64748b' }}>Memuat data diagnosa &amp; prosedur...</span>
                    </div>
                  ) : activeTabDiagnosa === 'diagnosa' ? (
                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.72rem' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                          <tr style={{ background: '#1e293b', color: '#e2e8f0' }}>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '28px', fontWeight: '600' }}>#</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '75px', fontWeight: '600' }}>Kode ICD</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '80px', fontWeight: '600' }}>Status</th>
                            <th style={{ padding: '6px 8px', fontWeight: '600', maxWidth: '200px' }}>Nama Diagnosa (ICD-10)</th>
                            <th style={{ padding: '6px 8px', fontWeight: '600', width: '160px', whiteSpace: 'nowrap' }}>Dokter DPJP</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '80px', fontWeight: '600' }}>Lokasi</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '55px', fontWeight: '600' }}>Aksi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {diagnosaData.list_diagnosa?.length > 0 ? (
                            diagnosaData.list_diagnosa.map((diag, idx) => (
                              <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9', background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                                <td style={{ padding: '5px 8px', textAlign: 'center', color: '#94a3b8', fontWeight: '600' }}>{diag.urutan && parseInt(diag.urutan) > 0 ? diag.urutan : (idx + 1)}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  <span style={{
                                    display: 'inline-block', background: '#fef2f2', color: '#b91c1c',
                                    border: '1px solid #fca5a5', borderRadius: '5px',
                                    padding: '1px 6px', fontFamily: 'monospace', fontSize: '0.7rem', fontWeight: '700'
                                  }}>{diag.kd_icd}</span>
                                </td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  {diag.ket && (diag.ket.toLowerCase().includes('utama') || diag.ket === '1') ? (
                                    <span style={{
                                      display: 'inline-flex', alignItems: 'center', gap: '3px',
                                      background: '#eff6ff', color: '#1d4ed8', borderRadius: '6px',
                                      padding: '2px 7px', fontSize: '0.65rem', fontWeight: '700',
                                      border: '1px solid #bfdbfe'
                                    }}>
                                      <i className="bi bi-star-fill text-warning" style={{ fontSize: '0.6rem' }}></i>{diag.ket}
                                    </span>
                                  ) : diag.ket ? (
                                    <span style={{
                                      display: 'inline-block', background: '#fffbeb', color: '#92400e',
                                      border: '1px solid #fde68a', borderRadius: '6px',
                                      padding: '2px 7px', fontSize: '0.65rem', fontWeight: '600'
                                    }}>{diag.ket}</span>
                                  ) : (
                                    <span style={{ color: '#cbd5e1', fontSize: '0.68rem' }}>—</span>
                                  )}
                                </td>
                                <td style={{ padding: '5px 8px', fontWeight: '600', color: '#1e293b', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={diag.nama_icd || diag.nm_icd}>{diag.nama_icd || diag.nm_icd}</td>
                                <td style={{ padding: '5px 8px', color: '#64748b', fontSize: '0.68rem', whiteSpace: 'nowrap' }}>{diag.nm_dokter || '-'}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center', color: '#64748b', fontSize: '0.68rem' }}>{diag.lokasi || '-'}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={isGrouperLocked}
                                    style={{
                                      padding: '1px 6px',
                                      fontSize: '0.68rem',
                                      borderRadius: '4px',
                                      cursor: isGrouperLocked ? 'not-allowed' : 'pointer',
                                      opacity: isGrouperLocked ? 0.35 : 1
                                    }}
                                    onClick={() => handleDeleteDiagnosa(diag, 'diagnosa')}
                                    title={isGrouperLocked ? 'Terkunci karena sudah grouper iDRG' : 'Hapus diagnosa dari tabel diagnosa2'}
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem' }}>
                                <i className="bi bi-clipboard2-x d-block mb-1" style={{ fontSize: '1.3rem', opacity: 0.4 }}></i>
                                Tidak ada data diagnosa untuk pasien ini.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.72rem' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                          <tr style={{ background: '#1e293b', color: '#e2e8f0' }}>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '28px', fontWeight: '600' }}>#</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '75px', fontWeight: '600' }}>Kode ICD</th>
                            <th style={{ padding: '6px 8px', fontWeight: '600', maxWidth: '220px' }}>Nama Prosedur (ICD-9-CM)</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '75px', fontWeight: '600' }}>Multiplicity</th>
                            <th style={{ padding: '6px 8px', fontWeight: '600', width: '160px', whiteSpace: 'nowrap' }}>Dokter DPJP</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '80px', fontWeight: '600' }}>Lokasi</th>
                            <th style={{ padding: '6px 8px', textAlign: 'center', width: '55px', fontWeight: '600' }}>Aksi</th>
                          </tr>
                        </thead>
                        <tbody>
                          {diagnosaData.list_prosedur?.length > 0 ? (
                            diagnosaData.list_prosedur.map((proc, idx) => (
                              <tr key={proc.id ? `proc-bpjs-${proc.id}` : idx} style={{ borderBottom: '1px solid #f1f5f9', background: idx % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                                <td style={{ padding: '5px 8px', textAlign: 'center', color: '#94a3b8', fontWeight: '600' }}>{proc.urutan && parseInt(proc.urutan) > 0 ? proc.urutan : (idx + 1)}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  <span style={{
                                    display: 'inline-block', background: '#f0fdf4', color: '#15803d',
                                    border: '1px solid #86efac', borderRadius: '5px',
                                    padding: '1px 6px', fontFamily: 'monospace', fontSize: '0.7rem', fontWeight: '700'
                                  }}>{proc.kd_icd}</span>
                                </td>
                                <td style={{ padding: '5px 8px', fontWeight: '600', color: '#1e293b', maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={proc.nama_icd || proc.nm_icd}>{proc.nama_icd || proc.nm_icd}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  <Badge bg="light" className="text-secondary border font-monospace" style={{ fontSize: '0.67rem' }}>
                                    x{proc.qty || proc.multiplicity || (proc.kd_icd?.includes('+') ? proc.kd_icd.split('+')[1] : 1)}
                                  </Badge>
                                </td>
                                <td style={{ padding: '5px 8px', color: '#64748b', fontSize: '0.68rem', whiteSpace: 'nowrap' }}>{proc.nm_dokter || '-'}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center', color: '#64748b', fontSize: '0.68rem' }}>{proc.lokasi || '-'}</td>
                                <td style={{ padding: '5px 8px', textAlign: 'center' }}>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={isGrouperLocked}
                                    style={{
                                      padding: '1px 6px',
                                      fontSize: '0.68rem',
                                      borderRadius: '4px',
                                      cursor: isGrouperLocked ? 'not-allowed' : 'pointer',
                                      opacity: isGrouperLocked ? 0.35 : 1
                                    }}
                                    onClick={() => handleDeleteDiagnosa(proc, 'prosedur')}
                                    title={isGrouperLocked ? 'Terkunci karena sudah grouper iDRG' : 'Hapus prosedur dari tabel diagnosa3'}
                                  >
                                    <i className="bi bi-trash-fill"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" style={{ padding: '20px', textAlign: 'center', color: '#94a3b8', fontSize: '0.75rem' }}>
                                <i className="bi bi-scissors d-block mb-1" style={{ fontSize: '1.3rem', opacity: 0.4 }}></i>
                                Tidak ada data prosedur untuk pasien ini.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* ══ SECTION: HASIL GROUPER ══ */}
                {isGrouping ? (
                  <div style={{
                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px',
                    padding: '24px 20px', textAlign: 'center',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                  }}>
                    <Spinner animation="border" style={{ width: '2.2rem', height: '2.2rem', color: '#0d9488', borderWidth: '3px' }} />
                    <div className="mt-3 fw-bold text-dark" style={{ fontSize: '0.85rem' }}>Menghubungkan ke Engine Grouper E-Claim BPJS...</div>
                    <div className="text-muted mt-1" style={{ fontSize: '0.72rem' }}>Verifikasi data klaim, diagnosa, dan penentuan tarif INA-CBG</div>
                  </div>
                ) : grouperResult ? (
                  <div style={{
                    background: grouperResult.type === 'success' ? '#f0fdf4' : '#fef2f2',
                    border: `1px solid ${grouperResult.type === 'success' ? '#86efac' : '#fca5a5'}`,
                    borderRadius: '12px', overflow: 'hidden',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                  }}>
                    <div style={{
                      padding: '9px 14px',
                      background: grouperResult.type === 'success' ? '#dcfce7' : '#fee2e2',
                      borderBottom: `1px solid ${grouperResult.type === 'success' ? '#86efac' : '#fca5a5'}`,
                      display: 'flex', alignItems: 'center', gap: '8px'
                    }}>
                      <i className={`bi ${grouperResult.type === 'success' ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} fs-5`}></i>
                      <span className="fw-bold" style={{ fontSize: '0.82rem', color: grouperResult.type === 'success' ? '#15803d' : '#b91c1c' }}>
                        {grouperResult.type === 'success' ? 'Hasil Grouper Coding iDRG Berhasil' : 'Proses Grouper Gagal'}
                      </span>
                    </div>
                    <div style={{ padding: '12px 14px' }}>
                      <div className="text-dark mb-2" style={{ fontSize: '0.77rem' }}>{grouperResult.text}</div>
                      {grouperResult.type === 'success' && (
                        <div style={{
                          background: '#ffffff', border: '1px solid #e2e8f0',
                          borderRadius: '8px', padding: '10px 12px'
                        }}>
                          <Row className="g-2">
                            <Col md={12}>
                              <div className="text-muted" style={{ fontSize: '0.62rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: '600', marginBottom: '2px' }}>
                                Kode iDRG &amp; Deskripsi (Poin 6)
                              </div>
                              <div className="fw-bold text-dark d-flex align-items-center flex-wrap gap-1" style={{ fontSize: '0.78rem' }}>
                                <Badge bg="success" className="px-2 py-1 shadow-sm font-monospace" style={{ background: '#059669', fontSize: '0.75rem' }}>
                                  <i className="bi bi-check-circle-fill me-1"></i>
                                  {grouperResult.data?.idrg_code || grouperResult.data?.drg_code || grouperResult.data?.kode_idrg || grouperTarget?.kd_idrg || grouperResult.data?.kode_cbg || grouperTarget?.kd_inacbg || 'Valid'}
                                </Badge>
                                <span style={{ fontSize: '0.78rem' }}>
                                  {grouperResult.data?.idrg_desc || grouperResult.data?.drg_description || grouperResult.data?.deskripsi_idrg || grouperTarget?.nm_idrg || grouperResult.data?.deskripsi_cbg || 'Grouper Coding iDRG Berhasil'}
                                </span>
                                {(grouperResult.data?.idrg_cost_weight || grouperResult.data?.cost_weight) ? (
                                  <Badge bg="info" className="px-2 py-1 text-dark shadow-xs font-monospace ms-auto" style={{ background: '#bae6fd', border: '1px solid #7dd3fc', fontSize: '0.72rem' }}>
                                    <i className="bi bi-speedometer2 me-1"></i>Cost Weight: {grouperResult.data.idrg_cost_weight || grouperResult.data.cost_weight}
                                  </Badge>
                                ) : null}
                              </div>
                            </Col>

                            {/* Status Engine INA-CBG (Poin 16) - Sesuai instruksi BPJS bertahap, tidak ditampilkan saat ini */}
                            <Col md={12}>
                              <div className="p-2 rounded d-flex align-items-center justify-content-between" style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', fontSize: '0.72rem', color: '#64748b' }}>
                                <div className="d-flex align-items-center gap-2">
                                  <i className="bi bi-hourglass-split text-primary"></i>
                                  <span><strong>Status Engine INA-CBG (Poin 16):</strong> Tidak ditampilkan pada Grouper Coding iDRG (hanya ditampilkan saat proses Grouper Coding INACBG sesuai instruksi BPJS).</span>
                                </div>
                                <Badge bg="secondary" style={{ fontSize: '0.65rem' }}>Proses Bertahap</Badge>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div style={{
                    background: '#eff6ff', border: '1px solid #bfdbfe',
                    borderRadius: '10px', padding: '9px 14px',
                    display: 'flex', alignItems: 'center', gap: '8px',
                    fontSize: '0.75rem', color: '#1d4ed8'
                  }}>
                    <i className="bi bi-info-circle-fill fs-5" style={{ opacity: 0.8 }}></i>
                    <span>Klik tombol <strong>Jalankan Grouper E-Claim</strong> di bawah untuk memproses pengklaiman ke sistem E-Claim BPJS Kesehatan.</span>
                  </div>
                )}

                {/* ══ SECTION: INFORMASI MEDIS EHR (ELECTRONIC HEALTH RECORD) ══ */}
                {(() => {
                  const firstCppt = ehrData?.forms?.cppt?.[0];
                  const cpptPayload = firstCppt?.payload || {};
                  const cpptEntries = firstCppt?.entries || [];
                  const cpptEntry = cpptEntries[0] || {};
                  const rawEntry = cpptEntry.raw_entry || {};
                  const tteData = rawEntry.soapTteData || cpptEntry.soapTteData || {};

                  const ehrPatientName = ehrData?.summary?.nama_pasien || ehrData?.patient_info?.nama_pasien || cpptPayload.patientName || grouperTarget?.nm_pasien || grouperTarget?.nama || '-';
                  const ehrNoRm = ehrData?.summary?.no_rm || ehrData?.patient_info?.no_rm || cpptPayload.medicalRecordNumber || firstCppt?.medical_record_number || grouperTarget?.no_medrec || '-';
                  const ehrBirthDate = cpptPayload.birthDate || '';
                  const ehrWorkUnit = ehrData?.summary?.unit_kerja || cpptPayload.workUnit || (ehrData?.forms?.resume_medis_ranap?.length > 0 ? 'Rawat Inap' : 'Poli / Rawat Jalan');

                  const isRanap = (ehrData?.forms?.resume_medis_ranap?.length > 0) || (ehrData?.forms?.ringkasan_masuk_keluar?.length > 0) || Boolean(ehrData?.summary?.tanggal_keluar);
                  const tglPelayanan = ehrData?.summary?.tanggal_masuk || (cpptEntry.tanggal ? `${cpptEntry.tanggal} ${cpptEntry.jam || ''}`.trim() : (firstCppt?.last_updated ? new Date(firstCppt.last_updated).toLocaleString('id-ID') : '-'));

                  const countCppt = ehrData?.forms?.cppt?.length || 0;
                  const countResume = ehrData?.forms?.resume_medis_ranap?.length || 0;
                  const countRingkasan = ehrData?.forms?.ringkasan_masuk_keluar?.length || 0;
                  const countAsesmen = ehrData?.forms?.asesmen_awal_ranap?.length || 0;
                  const countResumeRajal = ehrData?.forms?.lainnya?.filter(f => f.id_form === '11' || f.id_form === 11)?.length || 0;

                  return (
                    <div style={{
                      background: '#ffffff',
                      border: '1px solid #c7d2fe',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 8px rgba(99, 102, 241, 0.08)'
                    }}>
                      {/* EHR Header */}
                      <div style={{
                        padding: '10px 16px',
                        background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 50%, #7c3aed 100%)',
                        color: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '10px'
                      }}>
                        <div className="d-flex align-items-center gap-2">
                          <div style={{
                            width: '32px', height: '32px', borderRadius: '8px',
                            background: 'rgba(255,255,255,0.2)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                          }}>
                            <i className="bi bi-hospital-fill text-white" style={{ fontSize: '0.9rem' }}></i>
                          </div>
                          <div>
                            <div className="d-flex align-items-center gap-2">
                              <span className="fw-bold" style={{ fontSize: '0.85rem', letterSpacing: '0.01em' }}>
                                Informasi Klinis EHR (Rekam Medis Elektronik)
                              </span>
                              <span style={{
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '6px',
                                padding: '1px 7px',
                                fontSize: '0.67rem',
                                fontWeight: 600
                              }}>
                                Linimasa EMR
                              </span>
                            </div>
                            <div style={{ fontSize: '0.68rem', opacity: 0.9, marginTop: '1px' }}>
                              No. SEP: <span className="font-monospace fw-semibold">{ehrData?.no_sep || grouperTarget?.no_sep}</span>
                              {ehrWorkUnit && <span> • Unit: <strong>{ehrWorkUnit}</strong></span>}
                            </div>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                          {isLoadingEhr ? (
                            <Badge bg="warning" className="text-dark py-1 px-2 d-flex align-items-center gap-1 shadow-xs" style={{ fontSize: '0.68rem' }}>
                              <Spinner animation="border" size="sm" style={{ width: '11px', height: '11px', borderWidth: '1.5px' }} />
                              <span>Menghubungkan EHR...</span>
                            </Badge>
                          ) : ehrData?.found ? (
                            <Badge bg="success" className="py-1 px-2 d-flex align-items-center gap-1 shadow-xs" style={{ fontSize: '0.68rem', background: '#059669' }}>
                              <i className="bi bi-check-circle-fill"></i>
                              <span>{ehrData.count || 1} Dokumen Terverifikasi</span>
                            </Badge>
                          ) : (
                            <Badge bg="light" className="text-muted border py-1 px-2 d-flex align-items-center gap-1" style={{ fontSize: '0.68rem' }}>
                              <i className="bi bi-info-circle text-warning"></i>
                              <span>EHR Belum Tersedia</span>
                            </Badge>
                          )}

                          <button
                            type="button"
                            onClick={() => fetchEhrMedicalInfo(grouperTarget?.no_sep)}
                            disabled={isLoadingEhr}
                            className="btn btn-sm btn-outline-light py-1 px-2 d-flex align-items-center gap-1"
                            style={{ fontSize: '0.72rem', borderRadius: '6px', backdropFilter: 'blur(4px)' }}
                            title="Sinkronkan data klinis terbaru dari EHR"
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                            <span>Refresh</span>
                          </button>

                          {ehrData?.found && (
                            <button
                              type="button"
                              onClick={() => setShowEhrDetail(!showEhrDetail)}
                              className="btn btn-sm btn-light py-1 px-2 fw-semibold d-flex align-items-center gap-1 shadow-xs"
                              style={{ fontSize: '0.72rem', borderRadius: '6px', color: '#4338ca' }}
                            >
                              <span>{showEhrDetail ? 'Tutup Rincian' : 'Buka Rincian'}</span>
                              <i className={`bi ${showEhrDetail ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                            </button>
                          )}
                        </div>
                      </div>

                      {/* EHR Content Body */}
                      <div style={{ padding: '12px 16px' }}>
                        {isLoadingEhr ? (
                          <div className="text-center py-4">
                            <Spinner animation="border" size="sm" style={{ color: '#6366f1' }} className="me-2" />
                            <span style={{ fontSize: '0.78rem', color: '#475569', fontWeight: 500 }}>
                              Mengambil data klinis rekam medis dari sistem EHR untuk No. SEP: <strong>{grouperTarget?.no_sep}</strong>...
                            </span>
                          </div>
                        ) : ehrData?.found ? (
                          <div>
                            {/* ── 4 WIDGET SUMMARY MODERN ── */}
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                              gap: '10px',
                              marginBottom: showEhrDetail ? '12px' : 0
                            }}>
                              {/* Card 1: Identitas Pasien EHR */}
                              <div style={{
                                background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                                border: '1px solid #e2e8f0',
                                borderRadius: '10px',
                                padding: '10px 12px'
                              }}>
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                  <span className="text-muted" style={{ fontSize: '0.63rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    Pasien EHR (Linimasa)
                                  </span>
                                  <span className="badge" style={{ background: '#e0e7ff', color: '#4338ca', fontSize: '0.62rem' }}>
                                    {ehrWorkUnit || 'Poli'}
                                  </span>
                                </div>
                                <div className="fw-bold text-dark text-truncate" style={{ fontSize: '0.85rem' }} title={ehrPatientName}>
                                  {ehrPatientName}
                                </div>
                                <div className="text-muted font-monospace mt-1" style={{ fontSize: '0.72rem' }}>
                                  No. RM: <strong className="text-primary">{ehrNoRm}</strong>
                                  {ehrBirthDate && <span className="ms-1">({ehrBirthDate})</span>}
                                </div>
                              </div>

                              {/* Card 2: Waktu Pelayanan */}
                              <div style={{
                                background: isRanap ? 'linear-gradient(145deg, #f0fdf4 0%, #dcfce7 100%)' : 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                                border: isRanap ? '1px solid #86efac' : '1px solid #e2e8f0',
                                borderRadius: '10px',
                                padding: '10px 12px'
                              }}>
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                  <span className={isRanap ? "text-success fw-bold" : "text-muted"} style={{ fontSize: '0.63rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    {isRanap ? 'Periode Rawat Inap (EHR)' : 'Waktu Kunjungan / CPPT'}
                                  </span>
                                  {isRanap ? (
                                    <span className="badge bg-success" style={{ fontSize: '0.58rem', padding: '1px 5px' }}>
                                      <i className="bi bi-check2-circle me-1"></i>Pakai di Grouper
                                    </span>
                                  ) : (
                                    <i className="bi bi-calendar2-event text-primary" style={{ fontSize: '0.78rem' }}></i>
                                  )}
                                </div>
                                <div className="fw-bold text-dark font-monospace" style={{ fontSize: '0.82rem' }}>
                                  {isRanap ? (
                                    <span>
                                      <span className="text-success">{ehrData.summary?.tanggal_masuk || '-'}</span>
                                      <span className="text-muted mx-1">s/d</span>
                                      <span className="text-danger">{ehrData.summary?.tanggal_keluar || 'Masih Dirawat'}</span>
                                    </span>
                                  ) : tglPelayanan}
                                </div>
                                <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>
                                  {isRanap ? (
                                    <span className="text-success fw-semibold" style={{ fontSize: '0.68rem' }}>
                                      <i className="bi bi-info-circle me-1"></i>Tanggal EHR otomatis dipakai saat Grouper
                                    </span>
                                  ) : (
                                    <span>PPA: <strong className="text-dark">{(rawEntry.ppa || ehrData.summary?.ppa_terakhir || 'Fisioterapi / DPJP').toUpperCase()}</strong></span>
                                  )}
                                </div>
                              </div>

                              {/* Card 3: Tindakan & Masalah Medis */}
                              <div style={{
                                background: 'linear-gradient(145deg, #f8fafc 0%, #f1f5f9 100%)',
                                border: '1px solid #e2e8f0',
                                borderRadius: '10px',
                                padding: '10px 12px'
                              }}>
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                  <span className="text-muted" style={{ fontSize: '0.63rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    Tindakan / Masalah Klinis
                                  </span>
                                  <i className="bi bi-activity text-teal" style={{ fontSize: '0.78rem' }}></i>
                                </div>
                                <div className="fw-bold text-dark text-truncate" style={{ fontSize: '0.82rem', color: '#0f766e' }} title={rawEntry.action || ehrData.summary?.tindakan_terakhir || '-'}>
                                  {rawEntry.action || ehrData.summary?.tindakan_terakhir || (isRanap ? ehrData.summary?.kondisi_pulang : 'Pemeriksaan / Pelayanan Medis') || '-'}
                                </div>
                                <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>
                                  {rawEntry.plan ? (
                                    <span className="text-truncate d-block" title={rawEntry.plan}>
                                      Plan: <span className="text-dark">{rawEntry.plan.trim()}</span>
                                    </span>
                                  ) : isRanap && ehrData.summary?.tekanan_darah_terakhir ? (
                                    <span>TD: <strong>{ehrData.summary.tekanan_darah_terakhir} mmHg</strong></span>
                                  ) : (
                                    <span>Tervalidasi di Rekam Medis</span>
                                  )}
                                </div>
                              </div>

                              {/* Card 4: TTE Pemeriksa */}
                              <div style={{
                                background: 'linear-gradient(145deg, #f0fdf4 0%, #dcfce7 100%)',
                                border: '1px solid #bbf7d0',
                                borderRadius: '10px',
                                padding: '10px 12px'
                              }}>
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                  <span className="text-success fw-bold" style={{ fontSize: '0.63rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    <i className="bi bi-patch-check-fill me-1"></i>TTE Tersertifikasi
                                  </span>
                                  {tteData.qrCodeUrl && (
                                    <a href={tteData.qrCodeUrl} target="_blank" rel="noopener noreferrer" className="badge bg-success text-white text-decoration-none" style={{ fontSize: '0.6rem' }} title="Buka verifikasi resmi">
                                      Lihat TTE <i className="bi bi-box-arrow-up-right"></i>
                                    </a>
                                  )}
                                </div>
                                <div className="fw-bold text-dark text-truncate" style={{ fontSize: '0.82rem' }} title={tteData.signerName || ehrData.summary?.pemeriksa_terakhir || '-'}>
                                  {tteData.signerName || ehrData.summary?.pemeriksa_terakhir || 'Tenaga Medis Pemeriksa'}
                                </div>
                                <div className="text-muted font-monospace mt-1 text-truncate" style={{ fontSize: '0.68rem' }} title={tteData.sipNumber ? `SIP: ${tteData.sipNumber}` : ''}>
                                  {tteData.sipNumber ? `SIP: ${tteData.sipNumber}` : 'Telah ditandatangani secara elektronik'}
                                </div>
                              </div>
                            </div>

                            {/* ── DETAIL TABS / RINCIAN BERKAS (JIKA DETAIL DIBUKA) ── */}
                            {showEhrDetail && (
                              <div style={{ borderTop: '1px solid #e0e7ff', paddingTop: '12px' }}>
                                {/* Tab Navigation Pill */}
                                <div style={{ display: 'flex', gap: '6px', marginBottom: '10px', flexWrap: 'wrap' }}>
                                  {countCppt > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => setActiveEhrFormTab('cppt')}
                                      style={{
                                        border: 'none', borderRadius: '7px', padding: '5px 12px', fontSize: '0.72rem', fontWeight: 600,
                                        background: activeEhrFormTab === 'cppt' ? '#4f46e5' : '#f1f5f9',
                                        color: activeEhrFormTab === 'cppt' ? '#ffffff' : '#475569',
                                        boxShadow: activeEhrFormTab === 'cppt' ? '0 2px 6px rgba(79,70,229,0.3)' : 'none',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <i className="bi bi-journal-text me-1"></i> Catatan CPPT / SOAP ({countCppt})
                                    </button>
                                  )}
                                  {countResume > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => setActiveEhrFormTab('resume')}
                                      style={{
                                        border: 'none', borderRadius: '7px', padding: '5px 12px', fontSize: '0.72rem', fontWeight: 600,
                                        background: activeEhrFormTab === 'resume' ? '#4f46e5' : '#f1f5f9',
                                        color: activeEhrFormTab === 'resume' ? '#ffffff' : '#475569',
                                        boxShadow: activeEhrFormTab === 'resume' ? '0 2px 6px rgba(79,70,229,0.3)' : 'none',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <i className="bi bi-file-earmark-medical me-1"></i> Resume Medis Ranap ({countResume})
                                    </button>
                                  )}
                                  {countResumeRajal > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => setActiveEhrFormTab('resume_rajal')}
                                      style={{
                                        border: 'none', borderRadius: '7px', padding: '5px 12px', fontSize: '0.72rem', fontWeight: 600,
                                        background: activeEhrFormTab === 'resume_rajal' ? '#4f46e5' : '#f1f5f9',
                                        color: activeEhrFormTab === 'resume_rajal' ? '#ffffff' : '#475569',
                                        boxShadow: activeEhrFormTab === 'resume_rajal' ? '0 2px 6px rgba(79,70,229,0.3)' : 'none',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <i className="bi bi-file-earmark-medical me-1"></i> Resume Medis Rajal ({countResumeRajal})
                                    </button>
                                  )}
                                  {countRingkasan > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => setActiveEhrFormTab('ringkasan')}
                                      style={{
                                        border: 'none', borderRadius: '7px', padding: '5px 12px', fontSize: '0.72rem', fontWeight: 600,
                                        background: activeEhrFormTab === 'ringkasan' ? '#4f46e5' : '#f1f5f9',
                                        color: activeEhrFormTab === 'ringkasan' ? '#ffffff' : '#475569',
                                        boxShadow: activeEhrFormTab === 'ringkasan' ? '0 2px 6px rgba(79,70,229,0.3)' : 'none',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <i className="bi bi-box-arrow-right me-1"></i> Ringkasan Masuk/Keluar ({countRingkasan})
                                    </button>
                                  )}
                                  {countAsesmen > 0 && (
                                    <button
                                      type="button"
                                      onClick={() => setActiveEhrFormTab('asesmen')}
                                      style={{
                                        border: 'none', borderRadius: '7px', padding: '5px 12px', fontSize: '0.72rem', fontWeight: 600,
                                        background: activeEhrFormTab === 'asesmen' ? '#4f46e5' : '#f1f5f9',
                                        color: activeEhrFormTab === 'asesmen' ? '#ffffff' : '#475569',
                                        boxShadow: activeEhrFormTab === 'asesmen' ? '0 2px 6px rgba(79,70,229,0.3)' : 'none',
                                        transition: 'all .15s'
                                      }}
                                    >
                                      <i className="bi bi-clipboard-pulse me-1"></i> Asesmen Awal &amp; TTV ({countAsesmen})
                                    </button>
                                  )}
                                </div>

                                {/* ── TAB CONTENT: CPPT SOAP ── */}
                                {activeEhrFormTab === 'cppt' && (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {countCppt > 0 ? (
                                      ehrData.forms.cppt.map((doc, docIdx) => (
                                        <div key={docIdx} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                          {(doc.entries || []).map((ent, entIdx) => {
                                            const raw = ent.raw_entry || {};
                                            const tte = raw.soapTteData || ent.soapTteData || {};
                                            return (
                                              <div
                                                key={entIdx}
                                                style={{
                                                  background: '#ffffff',
                                                  border: '1px solid #cbd5e1',
                                                  borderRadius: '10px',
                                                  overflow: 'hidden',
                                                  boxShadow: '0 1px 3px rgba(0,0,0,0.04)'
                                                }}
                                              >
                                                {/* CPPT Entry Header */}
                                                <div style={{
                                                  padding: '8px 12px',
                                                  background: '#f8fafc',
                                                  borderBottom: '1px solid #e2e8f0',
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'space-between',
                                                  flexWrap: 'wrap',
                                                  gap: '8px'
                                                }}>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <span style={{
                                                      background: '#6366f1',
                                                      color: '#ffffff',
                                                      borderRadius: '6px',
                                                      padding: '2px 8px',
                                                      fontSize: '0.68rem',
                                                      fontWeight: 700,
                                                      textTransform: 'uppercase',
                                                      letterSpacing: '0.04em'
                                                    }}>
                                                      {raw.ppa || ent.ppa || 'PPA / Medis'}
                                                    </span>
                                                    <span className="fw-semibold text-dark font-monospace" style={{ fontSize: '0.74rem' }}>
                                                      <i className="bi bi-calendar-event me-1 text-muted"></i>
                                                      {ent.tanggal || raw.date || '-'} {ent.jam || raw.time || ''} WIB
                                                    </span>
                                                  </div>

                                                  {tte.signerName && (
                                                    <div className="d-flex align-items-center gap-1 text-success fw-semibold" style={{ fontSize: '0.7rem' }}>
                                                      <i className="bi bi-shield-check"></i>
                                                      <span>TTE: {tte.signerName}</span>
                                                    </div>
                                                  )}
                                                </div>

                                                {/* Tindakan / Action Highlight Banner */}
                                                {raw.action && (
                                                  <div style={{
                                                    padding: '6px 12px',
                                                    background: 'linear-gradient(90deg, #ecfdf5 0%, #f0fdf4 100%)',
                                                    borderBottom: '1px solid #d1fae5',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    fontSize: '0.75rem'
                                                  }}>
                                                    <span className="badge" style={{ background: '#059669', fontSize: '0.65rem' }}>
                                                      Tindakan / Masalah
                                                    </span>
                                                    <strong style={{ color: '#065f46' }}>{raw.action}</strong>
                                                  </div>
                                                )}

                                                {/* 4 KOTAK SOAP MODERN */}
                                                <div style={{
                                                  padding: '10px 12px',
                                                  display: 'grid',
                                                  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                                                  gap: '8px'
                                                }}>
                                                  {/* S - Subjective */}
                                                  <div style={{
                                                    background: '#eff6ff',
                                                    border: '1px solid #bfdbfe',
                                                    borderLeft: '3.5px solid #3b82f6',
                                                    borderRadius: '8px',
                                                    padding: '8px 10px'
                                                  }}>
                                                    <div className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.7rem', color: '#1d4ed8' }}>
                                                      <i className="bi bi-chat-left-quote-fill"></i>
                                                      <span>S (SUBJECTIVE)</span>
                                                    </div>
                                                    <div style={{ fontSize: '0.72rem', color: '#1e293b', whiteSpace: 'pre-line', lineHeight: '1.4' }}>
                                                      {raw.subjective || ent.subjective || <em className="text-muted">Tidak ada catatan keluhan</em>}
                                                    </div>
                                                  </div>

                                                  {/* O - Objective */}
                                                  <div style={{
                                                    background: '#f0fdf4',
                                                    border: '1px solid #bbf7d0',
                                                    borderLeft: '3.5px solid #10b981',
                                                    borderRadius: '8px',
                                                    padding: '8px 10px'
                                                  }}>
                                                    <div className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.7rem', color: '#047857' }}>
                                                      <i className="bi bi-eye-fill"></i>
                                                      <span>O (OBJECTIVE)</span>
                                                    </div>
                                                    <div style={{ fontSize: '0.72rem', color: '#1e293b', whiteSpace: 'pre-line', lineHeight: '1.4' }}>
                                                      {raw.objective || ent.objective || <em className="text-muted">Tidak ada catatan objektif</em>}
                                                    </div>
                                                  </div>

                                                  {/* A - Assessment */}
                                                  <div style={{
                                                    background: '#fefce8',
                                                    border: '1px solid #fef08a',
                                                    borderLeft: '3.5px solid #eab308',
                                                    borderRadius: '8px',
                                                    padding: '8px 10px'
                                                  }}>
                                                    <div className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.7rem', color: '#a16207' }}>
                                                      <i className="bi bi-clipboard-check-fill"></i>
                                                      <span>A (ASSESSMENT)</span>
                                                    </div>
                                                    <div style={{ fontSize: '0.72rem', color: '#1e293b', whiteSpace: 'pre-line', lineHeight: '1.4' }}>
                                                      {raw.assesment || raw.action || ent.assesment || <em className="text-muted">Tidak ada catatan assesmen</em>}
                                                    </div>
                                                  </div>

                                                  {/* P - Plan */}
                                                  <div style={{
                                                    background: '#faf5ff',
                                                    border: '1px solid #e9d5ff',
                                                    borderLeft: '3.5px solid #a855f7',
                                                    borderRadius: '8px',
                                                    padding: '8px 10px'
                                                  }}>
                                                    <div className="fw-bold mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.7rem', color: '#7e22ce' }}>
                                                      <i className="bi bi-pencil-square"></i>
                                                      <span>P (PLAN &amp; INSTRUKSI)</span>
                                                    </div>
                                                    <div style={{ fontSize: '0.72rem', color: '#1e293b', whiteSpace: 'pre-line', lineHeight: '1.4' }}>
                                                      {raw.plan || ent.plan || <em className="text-muted">Tidak ada rencana terapi</em>}
                                                      {raw.instruction && (
                                                        <div className="mt-1 pt-1 border-top border-secondary-subtle">
                                                          <strong>Instruksi:</strong> {raw.instruction}
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* BOX VERIFIKASI TTE RESMI */}
                                                {tte.signerName && (
                                                  <div style={{
                                                    padding: '8px 12px',
                                                    background: '#f8fafc',
                                                    borderTop: '1px solid #e2e8f0',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    flexWrap: 'wrap',
                                                    gap: '8px'
                                                  }}>
                                                    <div className="d-flex align-items-center gap-2">
                                                      {tte.qrImagePath ? (
                                                        <img
                                                          src={tte.qrImagePath}
                                                          alt="QR TTE"
                                                          onError={(e) => { e.target.style.display = 'none'; }}
                                                          style={{ width: '38px', height: '38px', borderRadius: '4px', border: '1px solid #cbd5e1', objectFit: 'contain' }}
                                                        />
                                                      ) : (
                                                        <div style={{
                                                          width: '34px', height: '34px', borderRadius: '6px',
                                                          background: '#dcfce7', color: '#15803d',
                                                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem'
                                                        }}>
                                                          <i className="bi bi-qr-code"></i>
                                                        </div>
                                                      )}
                                                      <div>
                                                        <div className="fw-bold text-dark" style={{ fontSize: '0.73rem' }}>
                                                          Ditandatangani elektronik oleh: <span className="text-primary">{tte.signerName}</span>
                                                        </div>
                                                        <div className="text-muted font-monospace" style={{ fontSize: '0.67rem' }}>
                                                          {tte.sipNumber && <span>SIP: {tte.sipNumber} • </span>}
                                                          Waktu: {tte.signedAt ? new Date(tte.signedAt).toLocaleString('id-ID') : '-'}
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {(tte.qrCodeUrl || tte.verificationUrl) && (
                                                      <a
                                                        href={tte.qrCodeUrl || tte.verificationUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-success py-1 px-2 d-flex align-items-center gap-1 shadow-xs"
                                                        style={{ fontSize: '0.7rem', borderRadius: '6px' }}
                                                      >
                                                        <i className="bi bi-shield-check"></i>
                                                        <span>Verifikasi TTE Asli</span>
                                                      </a>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted text-center py-3">Tidak ada catatan CPPT</div>
                                    )}
                                  </div>
                                )}

                                {/* ── TAB CONTENT: RESUME MEDIS RAJAL ── */}
                                {activeEhrFormTab === 'resume_rajal' && (
                                  <div style={{ fontSize: '0.73rem', background: '#faf5ff', borderRadius: '8px', padding: '10px 14px' }}>
                                    {countResumeRajal > 0 ? (
                                      ehrData.forms.lainnya.filter(f => f.id_form === '11' || f.id_form === 11).map((doc, idx) => (
                                        <div key={idx} className="mb-2 pb-2 border-bottom last:border-0">
                                          <div className="d-flex justify-content-between mb-1">
                                            <span className="fw-bold text-primary">{doc.nama_form || 'Resume Medis Rawat Jalan'}</span>
                                            <span className="text-muted font-monospace">{doc.last_updated ? new Date(doc.last_updated).toLocaleString('id-ID') : '-'}</span>
                                          </div>
                                          <div className="row g-2 text-dark">
                                            <div className="col-sm-6">
                                              <strong>Tgl Pemeriksaan:</strong> {doc.payload?.examinationDate || '-'}
                                            </div>
                                            <div className="col-sm-6">
                                              <strong>Dokter:</strong> {doc.payload?.physicianName || '-'}
                                            </div>
                                            <div className="col-12 mt-2 border-top pt-2">
                                              <strong>Pemeriksaan Fisik (TTV):</strong>
                                              <pre style={{ fontSize: '0.73rem', margin: '4px 0 0 0', background: '#f8fafc', padding: 6, borderRadius: 4, border: '1px solid #e2e8f0', whiteSpace: 'pre-wrap' }}>{doc.payload?.physicalExamDescription || '-'}</pre>
                                            </div>
                                            <div className="col-12 mt-2">
                                              <strong>Anamnesa:</strong>
                                              <div style={{ padding: '4px 8px', background: '#fff', borderRadius: 4, border: '1px solid #e2e8f0' }}>{doc.payload?.anamnesa || '-'}</div>
                                            </div>
                                            <div className="col-12 mt-2">
                                              <strong>Diagnosa:</strong>
                                              <div style={{ padding: '4px 8px', background: '#fff', borderRadius: 4, border: '1px solid #e2e8f0' }}>{doc.payload?.diagnosis || '-'}</div>
                                            </div>
                                            <div className="col-12 mt-2">
                                              <strong>Planning / Tatalaksana:</strong>
                                              <div style={{ padding: '4px 8px', background: '#fff', borderRadius: 4, border: '1px solid #e2e8f0' }}>{doc.payload?.planning || '-'}</div>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted">Data Resume Medis Rawat Jalan belum tersedia.</div>
                                    )}
                                  </div>
                                )}

                                {/* ── TAB CONTENT: RESUME MEDIS RANAP ── */}
                                {activeEhrFormTab === 'resume' && (
                                  <div style={{ fontSize: '0.73rem', background: '#faf5ff', borderRadius: '8px', padding: '10px 14px' }}>
                                    {countResume > 0 ? (
                                      ehrData.forms.resume_medis_ranap.map((doc, idx) => (
                                        <div key={idx} className="mb-2 pb-2 border-bottom last:border-0">
                                          <div className="d-flex justify-content-between mb-1">
                                            <span className="fw-bold text-primary">{doc.nama_form || 'Resume Medis Rawat Inap'}</span>
                                            <span className="text-muted font-monospace">{doc.last_updated}</span>
                                          </div>
                                          <div className="row g-2 text-dark">
                                            <div className="col-sm-6">
                                              <strong>Tgl Masuk / Keluar:</strong> {doc.tanggal_masuk || '-'} s/d {doc.tanggal_keluar || '-'}
                                            </div>
                                            <div className="col-sm-6">
                                              <strong>Kondisi Keluar:</strong> {doc.kondisi_keluar || '-'} {doc.kondisi_keluar_detail ? `(${doc.kondisi_keluar_detail})` : ''}
                                            </div>
                                            {doc.payload?.diagnosaAwal && (
                                              <div className="col-12">
                                                <strong>Diagnosa Masuk EHR:</strong> {doc.payload.diagnosaAwal}
                                              </div>
                                            )}
                                            {doc.payload?.diagnosaUtama && (
                                              <div className="col-12">
                                                <strong>Diagnosa Utama EHR:</strong> {doc.payload.diagnosaUtama}
                                              </div>
                                            )}
                                            {doc.payload?.terapi && (
                                              <div className="col-12">
                                                <strong>Terapi / Pengobatan:</strong> {doc.payload.terapi}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted text-center py-2">Tidak ada dokumen Resume Medis Rawat Inap</div>
                                    )}
                                  </div>
                                )}

                                {/* ── TAB CONTENT: RINGKASAN MASUK/KELUAR ── */}
                                {activeEhrFormTab === 'ringkasan' && (
                                  <div style={{ fontSize: '0.73rem', background: '#faf5ff', borderRadius: '8px', padding: '10px 14px' }}>
                                    {countRingkasan > 0 ? (
                                      ehrData.forms.ringkasan_masuk_keluar.map((doc, idx) => (
                                        <div key={idx} className="mb-2 pb-2 border-bottom last:border-0">
                                          <div className="d-flex justify-content-between mb-1">
                                            <span className="fw-bold text-primary">{doc.nama_form || 'Ringkasan Masuk dan Keluar'}</span>
                                            <span className="text-muted font-monospace">{doc.last_updated}</span>
                                          </div>
                                          <div className="row g-2 text-dark">
                                            <div className="col-sm-6">
                                              <strong>Tgl Masuk:</strong> {doc.tanggal_masuk || '-'} | <strong>Keluar:</strong> {doc.tanggal_keluar || '-'}
                                            </div>
                                            <div className="col-sm-6">
                                              <strong>Cara / Kondisi Keluar:</strong> {doc.cara_keluar || '-'} / {doc.kondisi_keluar || '-'}
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted text-center py-2">Tidak ada dokumen Ringkasan Masuk dan Keluar</div>
                                    )}
                                  </div>
                                )}

                                {/* ── TAB CONTENT: ASESMEN AWAL ── */}
                                {activeEhrFormTab === 'asesmen' && (
                                  <div style={{ fontSize: '0.73rem', background: '#faf5ff', borderRadius: '8px', padding: '10px 14px' }}>
                                    {countAsesmen > 0 ? (
                                      ehrData.forms.asesmen_awal_ranap.map((doc, idx) => (
                                        <div key={idx} className="mb-2 pb-2 border-bottom last:border-0">
                                          <div className="d-flex justify-content-between mb-1">
                                            <span className="fw-bold text-primary">{doc.nama_form || 'Asesmen Awal Ranap'}</span>
                                            <span className="text-muted font-monospace">{doc.last_updated}</span>
                                          </div>
                                          <div className="row g-2 text-dark">
                                            <div className="col-sm-6">
                                              <strong>TD Dokter:</strong> {doc.tekanan_darah_dokter || '-'} mmHg
                                            </div>
                                            <div className="col-sm-6">
                                              <strong>TD Perawat:</strong> {doc.tekanan_darah_perawat || '-'} mmHg
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="text-muted text-center py-2">Tidak ada dokumen Asesmen Awal Pasien Ranap</div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div style={{
                            background: '#f8fafc',
                            border: '1px dashed #cbd5e1',
                            borderRadius: '8px',
                            padding: '10px 14px',
                            fontSize: '0.75rem',
                            color: '#64748b',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '8px'
                          }}>
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-info-circle text-primary fs-6"></i>
                              <span>{ehrError || 'Data klinis belum ditemukan di server EHR untuk No. SEP ini.'}</span>
                            </div>
                            <button
                              type="button"
                              onClick={() => fetchEhrMedicalInfo(grouperTarget?.no_sep)}
                              className="btn btn-sm btn-outline-secondary py-0 px-2 flex-shrink-0"
                              style={{ fontSize: '0.7rem' }}
                            >
                              <i className="bi bi-arrow-clockwise me-1"></i> Cek Ulang
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* ══ SECTION: SITB ══ */}
                <div style={{
                  background: '#ffffff', border: '1px solid #e2e8f0',
                  borderRadius: '12px', padding: '12px 14px',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.06)'
                }}>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <div style={{
                      width: '24px', height: '24px', borderRadius: '6px',
                      background: 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}>
                      <i className="bi bi-lungs-fill text-white" style={{ fontSize: '0.65rem' }}></i>
                    </div>
                    <span className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>Nomor Register SITB</span>
                    <span className="text-muted" style={{ fontSize: '0.68rem' }}>(Sistem Informasi Tuberkulosis)</span>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      placeholder="Isi jika pasien terdiagnosa TB (A15-A19)"
                      value={inputSitb}
                      onChange={e => setInputSitb(e.target.value)}
                      style={{ fontSize: '0.82rem', borderRadius: '8px 0 0 8px', border: '1px solid #d1d5db' }}
                    />
                    <Button
                      onClick={() => handleValidateSitb(grouperTarget?.no_sep)}
                      disabled={isValidatingSitb}
                      className="fw-semibold px-3 text-white"
                      style={{
                        background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
                        border: 'none', borderRadius: '0 8px 8px 0', fontSize: '0.8rem'
                      }}
                    >
                      {isValidatingSitb ? (
                        <><Spinner size="sm" animation="border" className="me-1" /> Cek...</>
                      ) : (
                        <><i className="bi bi-shield-check me-1"></i> Validasi SITB</>
                      )}
                    </Button>
                  </InputGroup>
                  {sitbValidationResult && (
                    <div className={`mt-2 py-1 px-2 d-flex align-items-center gap-1`}
                      style={{
                        fontSize: '0.7rem', borderRadius: '6px',
                        background: sitbValidationResult.type === 'success' ? '#f0fdf4' : '#fef2f2',
                        color: sitbValidationResult.type === 'success' ? '#15803d' : '#b91c1c',
                        border: `1px solid ${sitbValidationResult.type === 'success' ? '#86efac' : '#fca5a5'}`
                      }}>
                      <i className={`bi ${sitbValidationResult.type === 'success' ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                      <span>{sitbValidationResult.text}</span>
                    </div>
                  )}
                  <div className="text-muted mt-1" style={{ fontSize: '0.68rem' }}>
                    * Wajib diisi khusus untuk diagnosa TB. Akan divalidasi oleh BPJS saat proses Grouper / Finalisasi.
                  </div>
                </div>

              </div>{/* end padding wrapper */}

              {/* ── FOOTER ACTIONS ── */}
              <div style={{
                padding: '10px 20px',
                borderTop: '1px solid #e2e8f0',
                background: '#f8fafc',
                display: 'flex', justifyContent: 'flex-end', gap: '8px', alignItems: 'center'
              }}>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowGrouperModal(false)}
                  disabled={isGrouping}
                  style={{ borderRadius: '8px', fontSize: '0.8rem', padding: '5px 14px' }}
                >
                  <i className="bi bi-x-lg me-1"></i> Tutup
                </Button>
                {grouperResult?.type === 'success' &&
                 (grouperResult?.data?.cbg || grouperResult?.data?.eklaim_response?.response_inacbg?.cbg?.code || grouperResult?.data?.eklaim_response?.response?.cbg?.code) &&
                 !String(grouperResult?.data?.cbg || grouperResult?.data?.eklaim_response?.response_inacbg?.cbg?.code || grouperResult?.data?.eklaim_response?.response?.cbg?.code).toLowerCase().includes('ungroupable') &&
                 !String(grouperResult?.data?.cbg || grouperResult?.data?.eklaim_response?.response_inacbg?.cbg?.code || grouperResult?.data?.eklaim_response?.response?.cbg?.code).startsWith('36') && (
                  <Button
                    size="sm"
                    variant="success"
                    className="fw-bold text-white shadow-sm"
                    onClick={() => { setShowGrouperModal(false); handleOpenAction(grouperTarget, 'finalisasi', 'Finalisasi Klaim (Kunci)'); }}
                    style={{ borderRadius: '8px', fontSize: '0.8rem', padding: '5px 14px' }}
                  >
                    <i className="bi bi-lock-fill me-1"></i> Lanjut Finalisasi
                  </Button>
                )}
                <Button
                  size="sm"
                  className="fw-bold text-white shadow-sm"
                  style={{
                    background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
                    border: 'none', borderRadius: '8px', fontSize: '0.8rem', padding: '5px 16px'
                  }}
                  onClick={handleProcessGrouper}
                  disabled={isGrouping || !grouperTarget?.no_sep || grouperTarget.no_sep === '-'}
                >
                  {isGrouping ? (
                    <><Spinner size="sm" animation="border" className="me-1" /> Proses...</>
                  ) : (
                    <><i className="bi bi-play-circle-fill me-1"></i> Jalankan Grouper E-Claim</>
                  )}
                </Button>
              </div>

            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL KONFIGURASI NIK CODER ══ */}
      <Modal show={showConfigModal} onHide={() => setShowConfigModal(false)} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-gear-fill fs-5"></i>
            <span>Konfigurasi NIK Coder</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSaveConfig}>
            <div className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                Nomor Induk Kependudukan (NIK) Coder terdaftar
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Masukkan NIK Coder (16 Digit)"
                value={tempNikCoder}
                onChange={(e) => setTempNikCoder(e.target.value)}
                required
                style={{ fontSize: '0.78rem' }}
              />
              <Form.Text className="text-muted" style={{ fontSize: '0.68rem' }}>
                NIK Coder ini akan disimpan di perangkat (localStorage) dan digunakan saat proses E-Klaim/Grouper.
              </Form.Text>
            </div>
            <div className="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
              <Button variant="secondary" size="sm" onClick={() => setShowConfigModal(false)}>
                Batal
              </Button>
              <Button type="submit" variant="warning" size="sm" className="fw-bold text-dark shadow-sm">
                <i className="bi bi-save-fill me-1"></i> Simpan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      
      {/* ══ MODAL AKSI KLAIM (HAPUS, REEDIT, STATUS) ══ */}
      <Modal show={actionModal.show} onHide={() => setActionModal({ ...actionModal, show: false })} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className={`bi ${actionModal.type === 'hapus' ? 'bi-trash text-danger' : actionModal.type === 'reedit' ? 'bi-unlock text-warning' : 'bi-info-circle text-info'} fs-5`}></i>
            <span>{actionModal.title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 bg-light">
          {!actionModal.result ? (
            <div className="text-center">
              <div className="mb-3">
                <i className={`bi ${actionModal.type === 'hapus' ? 'bi-exclamation-triangle-fill text-danger' : actionModal.type === 'idrg_final' ? 'bi-lock-fill text-primary' : actionModal.type === 'finalisasi' ? 'bi-lock-fill text-success' : actionModal.type === 'reedit' ? 'bi-unlock-fill text-warning' : 'bi-search text-info'} fs-1`}></i>
              </div>
              <h5 className="fw-bold mb-2 text-dark">{actionModal.title}</h5>
              <p className="text-muted mb-4" style={{ fontSize: '0.85rem' }}>
                Apakah Anda yakin ingin memproses <strong>{actionModal.title}</strong> untuk pasien <strong>{actionModal.item?.nm_pasien || actionModal.item?.nama}</strong> dengan No. SEP <strong>{actionModal.item?.no_sep || '-'}</strong>?
              </p>
              <div className="d-flex justify-content-center gap-2">
                <Button variant="secondary" onClick={() => setActionModal({ ...actionModal, show: false })} disabled={actionModal.loading} className="px-4 fw-semibold">
                  Batal
                </Button>
                <Button variant={actionModal.type === 'hapus' ? 'danger' : actionModal.type === 'idrg_final' ? 'primary' : actionModal.type === 'finalisasi' ? 'success' : actionModal.type === 'reedit' ? 'warning' : 'info'} onClick={handleProcessAction} disabled={actionModal.loading} className={`px-4 fw-bold ${actionModal.type !== 'hapus' ? 'text-dark' : 'text-white'} shadow-sm`}>
                  {actionModal.loading ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                  {actionModal.type === 'status' ? 'Cek Sekarang' : 'Ya, Lanjutkan'}
                </Button>
              </div>
            </div>
          ) : actionModal.type === 'status' ? (
            <div>
              <div className="d-flex align-items-center gap-3 mb-3 p-3 rounded-3" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                <i className="bi bi-shield-check text-success fs-1"></i>
                <div>
                  <h6 className="fw-bold text-success mb-1" style={{ fontSize: '0.92rem' }}>Pemeriksaan Status Klaim Berhasil</h6>
                  <p className="text-muted mb-0" style={{ fontSize: '0.75rem' }}>
                    Informasi status klaim pasien di Web Service E-Klaim & Data Center Kemenkes RI
                  </p>
                </div>
              </div>

              <div className="bg-white p-3 rounded-3 border shadow-sm mb-3">
                <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                  <span className="text-muted fw-semibold" style={{ fontSize: '0.76rem' }}>Nomor SEP</span>
                  <span className="fw-bold font-monospace text-primary" style={{ fontSize: '0.85rem' }}>{actionModal.item?.no_sep || '-'}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                  <span className="text-muted fw-semibold" style={{ fontSize: '0.76rem' }}>Nama Pasien</span>
                  <span className="fw-bold text-dark" style={{ fontSize: '0.82rem' }}>{actionModal.item?.nm_pasien || actionModal.item?.nama || '-'}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                  <span className="text-muted fw-semibold" style={{ fontSize: '0.76rem' }}>No. Medrec / No. Nota</span>
                  <span className="fw-semibold text-secondary font-monospace" style={{ fontSize: '0.78rem' }}>{actionModal.item?.no_medrec || '-'} / {actionModal.item?.no_nota || '-'}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                  <span className="text-muted fw-semibold" style={{ fontSize: '0.76rem' }}>Status Klaim (E-Klaim / BPJS)</span>
                  <Badge bg="success" className="px-2 py-1 fw-bold d-inline-flex align-items-center gap-1" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-check-circle-fill"></i>
                    <span>{actionModal.result.status_klaim || 'Klaim Terproses / Final'}</span>
                  </Badge>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="text-muted fw-semibold" style={{ fontSize: '0.76rem' }}>Status DC Kemenkes</span>
                  <Badge 
                    bg={actionModal.result.is_dc_terkirim || actionModal.result.status_dc?.toLowerCase().includes('terkirim') ? 'primary' : 'warning'} 
                    className="px-2 py-1 fw-bold d-inline-flex align-items-center gap-1" 
                    style={{ fontSize: '0.75rem' }}
                  >
                    <i className={`bi ${actionModal.result.is_dc_terkirim || actionModal.result.status_dc?.toLowerCase().includes('terkirim') ? 'bi-cloud-check-fill' : 'bi-cloud-slash'}`}></i>
                    <span>{actionModal.result.status_dc || 'Belum Terkirim ke Data Center Kemenkes'}</span>
                  </Badge>
                </div>
                {actionModal.result.tgl_kirim_dc && (
                  <div className="text-end text-muted mt-2 pt-2 border-top" style={{ fontSize: '0.7rem' }}>
                    <i className="bi bi-clock-history me-1"></i>Waktu Pengiriman DC: <span className="fw-semibold text-dark">{actionModal.result.tgl_kirim_dc}</span>
                  </div>
                )}
              </div>

              <div className="d-flex flex-wrap justify-content-end gap-2 pt-2 border-top">
                <Button
                  variant={actionModal.result?.klaim_final ? "primary" : "secondary"}
                  className="fw-bold text-white shadow-sm d-inline-flex align-items-center gap-1 px-3"
                  style={{ 
                    background: actionModal.result?.klaim_final ? '#2563eb' : '#64748b', 
                    borderColor: actionModal.result?.klaim_final ? '#1d4ed8' : '#475569', 
                    fontSize: '0.78rem', 
                    borderRadius: '7px',
                    cursor: actionModal.result?.klaim_final && !isSendingOnline ? 'pointer' : 'not-allowed',
                    opacity: actionModal.result?.klaim_final && !isSendingOnline ? 1 : 0.65
                  }}
                  onClick={() => handleSendClaimOnline(actionModal.item)}
                  disabled={!actionModal.result?.klaim_final || isSendingOnline}
                  title={actionModal.result?.klaim_final ? "Kirim Klaim ke Data Center Kemenkes RI (Poin 22)" : "Klaim belum final. Silakan lakukan Finalisasi Klaim terlebih dahulu."}
                >
                  {isSendingOnline ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-cloud-arrow-up-fill me-1"></i>}
                  <span>Kirim Klaim Online</span>
                </Button>

                <Button variant="secondary" onClick={() => setActionModal({ ...actionModal, show: false })} className="px-3 fw-semibold shadow-sm" style={{ fontSize: '0.78rem', borderRadius: '7px' }}>
                  Tutup
                </Button>
              </div>
            </div>
          ) : (
            <div className="text-center">
              <div className="mb-3">
                <i className={`bi ${actionModal.result.success ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} fs-1`}></i>
              </div>
              <h5 className={`fw-bold text-${actionModal.result.success ? 'success' : 'danger'} mb-3`}>
                {actionModal.result.success ? 'Proses Berhasil' : 'Proses Gagal'}
              </h5>
              <div className={`alert alert-${actionModal.result.success ? 'success' : 'danger'} p-3 mb-4 text-start shadow-sm`} style={{ fontSize: '0.82rem', whiteSpace: 'pre-wrap', wordBreak: 'break-word', borderRadius: '8px' }}>
                {actionModal.result.message}
              </div>
              <Button variant="secondary" onClick={() => setActionModal({ ...actionModal, show: false })} className="px-4 fw-semibold shadow-sm">
                Tutup
              </Button>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL KONFIRMASI NEW CLAIM ══ */}
      <Modal show={showNewClaimConfirm} onHide={() => { setShowNewClaimConfirm(false); setNewClaimResult(null); }} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-file-earmark-plus-fill fs-5 text-warning"></i>
            <span>Konfirmasi New Claim E-Klaim</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 text-center bg-light">
          {!newClaimResult ? (
            <>
              <div className="mb-3">
                <i className="bi bi-cloud-arrow-up fs-1 text-primary"></i>
              </div>
              <h5 className="mb-2 fw-bold text-dark">Daftarkan ke E-Klaim?</h5>
              <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
                Anda akan mendaftarkan pasien <strong>{newClaimTarget?.nama}</strong> dengan No. SEP <strong>{newClaimTarget?.no_sep}</strong> ke sistem E-Klaim (New Claim).
              </p>
              <div className="mb-4 text-start bg-white p-3 border rounded shadow-sm">
                <Form.Label className="fw-bold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                  <i className="bi bi-lungs-fill text-danger me-1"></i> Nomor Register SITB (Sistem Informasi Tuberkulosis)
                </Form.Label>
                <InputGroup className="shadow-sm rounded">
                  <Form.Control
                    type="text"
                    placeholder="Isi jika pasien terdiagnosa TB (A15-A19)"
                    value={inputSitb}
                    onChange={e => setInputSitb(e.target.value)}
                    style={{ fontSize: '0.85rem' }}
                  />
                  <Button 
                    variant="primary" 
                    onClick={() => handleValidateSitb(newClaimTarget?.no_sep)} 
                    disabled={isValidatingSitb}
                    className="fw-semibold px-3 text-white"
                    style={{ background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)', border: 'none', zIndex: 0 }}
                  >
                    {isValidatingSitb ? (
                      <><Spinner size="sm" animation="border" className="me-1" /> Cek...</>
                    ) : (
                      <><i className="bi bi-shield-check me-1"></i> Validasi SITB</>
                    )}
                  </Button>
                </InputGroup>
                {sitbValidationResult && (
                  <div className={`alert alert-${sitbValidationResult.type} mt-2 mb-0 py-1 px-2 d-flex align-items-center gap-1`} style={{ fontSize: '0.7rem' }}>
                    <i className={`bi ${sitbValidationResult.type === 'success' ? 'bi-check-circle-fill' : 'bi-x-circle-fill'}`}></i>
                    <span>{sitbValidationResult.text}</span>
                  </div>
                )}
                <Form.Text className="text-muted" style={{ fontSize: '0.7rem' }}>
                  * Wajib diisi khusus untuk diagnosa TB agar tidak ditolak E-Klaim saat finalisasi.
                </Form.Text>
              </div>
              <div className="d-flex justify-content-center gap-2">
                <Button variant="secondary" onClick={() => setShowNewClaimConfirm(false)} className="px-4 fw-semibold" disabled={isProcessingNewClaim}>
                  Batal
                </Button>
                <Button variant="primary" onClick={handleProcessNewClaim} className="px-4 fw-semibold" disabled={isProcessingNewClaim}>
                  {isProcessingNewClaim ? <Spinner size="sm" animation="border" className="me-2" /> : null}
                  Ya, Daftarkan
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="mb-3">
                <i className={`bi ${newClaimResult.type === 'success' ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'} fs-1`}></i>
              </div>
              <h5 className={`mb-2 fw-bold text-${newClaimResult.type === 'success' ? 'success' : 'danger'}`}>
                {newClaimResult.type === 'success' ? 'Berhasil' : 'Gagal'}
              </h5>
              <p className="text-muted mb-4" style={{ fontSize: '0.85rem' }}>
                {newClaimResult.text}
              </p>
              <Button variant="secondary" onClick={() => { setShowNewClaimConfirm(false); setNewClaimResult(null); }} className="px-4 fw-semibold">
                Tutup
              </Button>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL PERINGATAN NOMOR SEP KOSONG (CONFIRMATION ALERT) ══ */}
      <Modal show={showSepWarningModal} onHide={() => setShowSepWarningModal(false)} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.92rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-exclamation-triangle-fill fs-5 text-warning"></i>
            <span>Peringatan Nomor SEP Pasien Belum Terisi</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {warningPatientTarget && (
            <div>
              <div className="alert alert-warning border-0 shadow-sm p-3 mb-3" style={{ background: '#fffbeb', borderLeft: '4px solid #f59e0b', borderRadius: '10px' }}>
                <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-person-exclamation me-1 text-warning"></i> Pasien: <strong>{warningPatientTarget.nama}</strong>
                </div>
                <div className="text-muted mb-2" style={{ fontSize: '0.76rem' }}>
                  No. Medrec: <strong className="font-monospace text-dark">{warningPatientTarget.no_medrec}</strong> | No. Daftar: <span className="font-monospace">{warningPatientTarget.no_daftar}</span>
                </div>
                <div className="text-dark border-top pt-2" style={{ fontSize: '0.78rem' }}>
                  Nomor SEP untuk pasien ini masih belum terisi (<strong>'-'</strong>). Untuk memproses pengklaiman BPJS Kesehatan di engine Grouper E-Claim, Nomor SEP pasien wajib diisi terlebih dahulu.
                </div>
              </div>

              <p className="fw-semibold text-center text-dark mb-2" style={{ fontSize: '0.84rem' }}>
                Apakah Anda ingin melengkapi / mengisi Nomor SEP pasien ini sekarang?
              </p>

              <div className="d-flex justify-content-center gap-2 mt-3 pt-2 border-top">
                <Button
                  variant="secondary"
                  size="sm"
                  style={{ borderRadius: '6px', padding: '0.35rem 1rem', fontSize: '0.78rem' }}
                  onClick={() => setShowSepWarningModal(false)}
                >
                  Nanti Saja
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="fw-bold text-dark shadow-sm d-flex align-items-center gap-1"
                  style={{ borderRadius: '6px', padding: '0.35rem 1rem', fontSize: '0.78rem' }}
                  onClick={() => {
                    const target = warningPatientTarget;
                    setShowSepWarningModal(false);
                    handleOpenEditSep(target);
                  }}
                >
                  <i className="bi bi-pencil-square"></i>
                  <span>Ya, Isi Nomor SEP Sekarang</span>
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL INPUT DIAGNOSA & PROSEDUR (BPJS: diagnosa2 & diagnosa3) ══ */}
      <Modal show={showInputDiagnosaModal} onHide={() => { setShowInputDiagnosaModal(false); setShowIcd10Autocomplete(false); setShowIcd9Autocomplete(false); }} centered backdrop="static" size="lg">
        <Modal.Header closeButton style={{ background: inputDiagnosaType === 'diagnosa' ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)' : 'linear-gradient(135deg, #059669 0%, #047857 100%)', color: '#fff', padding: '10px 16px' }}>
          <Modal.Title style={{ fontSize: '0.92rem', fontWeight: '700', width: '100%' }} className="d-flex align-items-center gap-2">
            <i className={`bi ${inputDiagnosaType === 'diagnosa' ? 'bi-clipboard2-pulse-fill' : 'bi-activity'} fs-5`}></i>
            <span>{inputDiagnosaType === 'diagnosa' ? 'Input Diagnosa Pasien (ICD-10)' : 'Input Prosedur Tindakan (ICD-9-CM)'}</span>
            <div className="d-flex gap-1 ms-auto">
              <Badge bg="light" className="text-dark" style={{ fontSize: '0.68rem', padding: '3px 8px', fontWeight: 700 }}>
                <i className="bi bi-database me-1"></i>
                Tabel: {inputDiagnosaType === 'prosedur' ? 'diagnosa3' : 'diagnosa2'}
              </Badge>
              {isLoadingMasterIcd && (
                <Badge bg="warning" text="dark" style={{ fontSize: '0.68rem', padding: '3px 8px' }}>
                  <Spinner animation="border" size="sm" className="me-1" style={{ width: '10px', height: '10px' }} />
                  Memuat Master...
                </Badge>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 bg-light">
          <Form onSubmit={handleSaveInputDiagnosa}>

            {/* ── Info Pasien Banner ── */}
            {(grouperTarget || selectedDiagnosaItem) && (
              <div style={{ background: inputDiagnosaType === 'diagnosa' ? 'linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%)' : 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)', borderBottom: `2px solid ${inputDiagnosaType === 'diagnosa' ? '#38bdf8' : '#4ade80'}`, padding: '8px 16px' }}>
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2" style={{ fontSize: '0.78rem' }}>
                  <div className="d-flex align-items-center gap-2">
                    <i className={`bi bi-person-badge-fill ${inputDiagnosaType === 'diagnosa' ? 'text-primary' : 'text-success'} fs-5`}></i>
                    <div>
                      <div className="fw-bold text-dark" style={{ fontSize: '0.82rem' }}>{(grouperTarget || selectedDiagnosaItem).nama || (grouperTarget || selectedDiagnosaItem).nm_pasien}</div>
                      <div className="text-muted" style={{ fontSize: '0.72rem' }}>No. MR: <span className="font-monospace fw-semibold">{(grouperTarget || selectedDiagnosaItem).no_medrec}</span> &nbsp;|&nbsp; DPJP: {(grouperTarget || selectedDiagnosaItem).nama_dokter || (grouperTarget || selectedDiagnosaItem).nm_dokter || '-'}</div>
                    </div>
                  </div>
                  <Badge bg={inputDiagnosaType === 'diagnosa' ? 'primary' : 'success'} style={{ fontSize: '0.72rem', padding: '4px 10px' }}>
                    <i className="bi bi-card-checklist me-1"></i>
                    SEP: {(grouperTarget || selectedDiagnosaItem).no_sep || '-'}
                  </Badge>
                </div>
              </div>
            )}

            <div className="p-3">
              {/* ── Status Diagnosa (ICD-10) / Dokter DPJP, Lokasi / Unit (Di atas Pencarian Kode Diagnosa) ── */}
              <Row className="g-2 mb-3">
                {inputDiagnosaType === 'diagnosa' && (
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                        <i className="bi bi-tag-fill text-warning"></i> Status Diagnosa
                      </Form.Label>
                      <Form.Select
                        size="sm"
                        value={formInputDiagnosa.ket}
                        onChange={e => {
                          const val = e.target.value;
                          if (val === 'Utama' && formInputDiagnosa.kd_icd) {
                            const curCode = formInputDiagnosa.kd_icd.trim().toLowerCase();
                            const cleanCur = curCode.replace(/\./g, '');
                            const mItem = (masterIcd10 || []).find(x => {
                              const code = String(x.icd || x.kode || x.kd_icd || '').trim().toLowerCase();
                              return code === curCode || code.replace(/\./g, '') === cleanCur;
                            });
                            if (mItem && String(mItem.accpdx || mItem.acc_pdx || '').trim().toUpperCase() === 'N') {
                              notify('warning', 'Validasi Primary Diagnosis', 'Diagnosa tidak bisa diinput sebagai primary karena accpdx = N');
                              setIcdCheckMsg({ type: 'danger', text: 'Diagnosa tidak bisa diinput sebagai primary karena accpdx = N (Diagnosa Utama tidak diizinkan, silakan pilih status Sekunder)' });
                              return;
                            }
                          }
                          setFormInputDiagnosa({ ...formInputDiagnosa, ket: val, utama: val === 'Utama' ? 1 : 0 });
                          if (val !== 'Utama' && icdCheckMsg?.text?.includes('accpdx = N')) {
                            setIcdCheckMsg({ type: 'info', text: 'Diagnosa dengan accpdx = N diizinkan diinput sebagai Diagnosa Sekunder / Tambahan' });
                          }
                        }}
                        style={{ fontSize: '0.78rem', fontWeight: 600, borderColor: formInputDiagnosa.ket === 'Utama' ? '#f59e0b' : '#d1d5db' }}
                      >
                        <option value="Utama">🟡 Diagnosa Utama (Primer)</option>
                        <option value="Sekunder">🔵 Diagnosa Sekunder (Komorbiditas)</option>
                        <option value="Tambahan">⚪ Diagnosa Tambahan</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}

                <Col md={inputDiagnosaType === 'diagnosa' ? 4 : 6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                      <i className="bi bi-person-badge text-secondary"></i> Dokter DPJP
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      value={formInputDiagnosa.nm_dokter}
                      onChange={e => setFormInputDiagnosa({ ...formInputDiagnosa, nm_dokter: e.target.value })}
                      placeholder="Nama Dokter DPJP"
                      style={{ fontSize: '0.78rem' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={inputDiagnosaType === 'diagnosa' ? 4 : 6}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                      <i className="bi bi-hospital text-info"></i> Lokasi / Unit
                    </Form.Label>
                    <Form.Select
                      size="sm"
                      value={formInputDiagnosa.lokasi}
                      onChange={e => setFormInputDiagnosa({ ...formInputDiagnosa, lokasi: e.target.value })}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value="Rawat Inap">🏥 Rawat Inap</option>
                      <option value="Rawat Jalan">🏃 Rawat Jalan</option>
                      <option value="IGD">🚑 IGD / Gawat Darurat</option>
                      <option value="Kamar Operasi">🔬 Kamar Operasi (OK)</option>
                      <option value="ICU">❤️‍🩹 ICU / HCU</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* ── Tanggal, Jam, dan Petugas Coder (Di bawah Status Diagnosa, di atas Pencarian ICD) ── */}
              <Row className="g-2 mb-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                      <i className="bi bi-calendar3 text-secondary"></i> Tanggal
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      value={formInputDiagnosa.tanggal}
                      onChange={e => setFormInputDiagnosa({ ...formInputDiagnosa, tanggal: e.target.value })}
                      placeholder="DD/MM/YYYY"
                      style={{ fontSize: '0.78rem', fontFamily: 'monospace' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                      <i className="bi bi-clock text-secondary"></i> Jam
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      value={formInputDiagnosa.jam}
                      onChange={e => setFormInputDiagnosa({ ...formInputDiagnosa, jam: e.target.value })}
                      placeholder="HH:mm"
                      style={{ fontSize: '0.78rem', fontFamily: 'monospace' }}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center gap-1" style={{ fontSize: '0.73rem' }}>
                      <i className="bi bi-person-check-fill text-success"></i> Petugas Coder
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      value={formInputDiagnosa.petugas || (localStorage.getItem('nama_user') || localStorage.getItem('user') || localStorage.getItem('username') || sessionStorage.getItem('nama_user') || sessionStorage.getItem('user') || sessionStorage.getItem('username') || 'Administrator')}
                      readOnly
                      title="Petugas Coder otomatis diisi dari session user login"
                      style={{ background: '#f8fafc', fontSize: '0.78rem', fontWeight: 600, color: '#0f172a' }}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* ── Panel Pencarian ICD ── */}
              <div className="mb-3 p-3 rounded-3 border shadow-sm" style={{ background: '#ffffff', borderColor: inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7' }}>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div style={{
                    width: '28px', height: '28px', borderRadius: '8px',
                    background: inputDiagnosaType === 'diagnosa' ? 'linear-gradient(135deg, #0284c7, #0369a1)' : 'linear-gradient(135deg, #059669, #047857)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                  }}>
                    <i className={`bi ${inputDiagnosaType === 'diagnosa' ? 'bi-journal-medical' : 'bi-list-check'} text-white`} style={{ fontSize: '0.8rem' }}></i>
                  </div>
                  <div>
                    <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>
                      {inputDiagnosaType === 'diagnosa' ? 'Cari Kode Diagnosa ICD-10 (Tabel diagnosa2)' : 'Cari Kode Prosedur ICD-9-CM (Tabel diagnosa3)'}
                    </div>
                    <div className="text-muted" style={{ fontSize: '0.67rem' }}>
                      {inputDiagnosaType === 'diagnosa'
                        ? `Ketik kode atau nama diagnosa · ${masterIcd10.length ? masterIcd10.length.toLocaleString('id-ID') + ' data tersedia' : 'Klik field untuk memuat master'}`
                        : `Ketik kode atau nama prosedur · ${masterIcd9.length ? masterIcd9.length.toLocaleString('id-ID') + ' data tersedia' : 'Klik field untuk memuat master'}`}
                    </div>
                  </div>
                  {(inputDiagnosaType === 'diagnosa' ? masterIcd10.length : masterIcd9.length) > 0 && (
                    <Badge bg={inputDiagnosaType === 'diagnosa' ? 'primary' : 'success'} className="ms-auto" style={{ fontSize: '0.67rem' }}>
                      {inputDiagnosaType === 'diagnosa' ? masterIcd10.length.toLocaleString('id-ID') : masterIcd9.length.toLocaleString('id-ID')} item
                    </Badge>
                  )}
                </div>

                {/* Search input utama */}
                <div style={{ position: 'relative' }}>
                  <InputGroup>
                    <InputGroup.Text style={{ background: inputDiagnosaType === 'diagnosa' ? '#eff6ff' : '#f0fdf4', borderColor: inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7', borderRight: 'none' }}>
                      {isCheckingIcd
                        ? <Spinner animation="border" size="sm" variant={inputDiagnosaType === 'diagnosa' ? 'primary' : 'success'} />
                        : <i className={`bi bi-search ${inputDiagnosaType === 'diagnosa' ? 'text-primary' : 'text-success'}`}></i>
                      }
                    </InputGroup.Text>
                    <Form.Control
                      size="sm"
                      value={formInputDiagnosa.kd_icd}
                      onClick={() => {
                        if (inputDiagnosaType === 'diagnosa') {
                          setShowIcd10Autocomplete(true);
                          if (masterIcd10.length === 0 && !isLoadingMasterIcd) handleOpenMasterIcdModal('');
                        } else {
                          setShowIcd9Autocomplete(true);
                          if (masterIcd9.length === 0 && !isLoadingMasterIcd) handleOpenMasterIcdModal('');
                        }
                      }}
                      onFocus={() => {
                        if (inputDiagnosaType === 'diagnosa') {
                          setShowIcd10Autocomplete(true);
                          if (masterIcd10.length === 0 && !isLoadingMasterIcd) handleOpenMasterIcdModal('');
                        } else {
                          setShowIcd9Autocomplete(true);
                          if (masterIcd9.length === 0 && !isLoadingMasterIcd) handleOpenMasterIcdModal('');
                        }
                      }}
                      onChange={e => {
                        const val = e.target.value;
                        let mult = formInputDiagnosa.multiplicity || 1;
                        if (inputDiagnosaType === 'prosedur' && val.includes('+')) {
                          const parsed = parseInt(val.split('+')[1]);
                          if (!isNaN(parsed) && parsed > 0) {
                            mult = parsed;
                          }
                        }
                        setFormInputDiagnosa(prev => ({ ...prev, kd_icd: val, nm_icd: '', multiplicity: mult }));
                        setIcdCheckMsg(null);
                        if (inputDiagnosaType === 'diagnosa') setShowIcd10Autocomplete(true);
                        else setShowIcd9Autocomplete(true);
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          setShowIcd10Autocomplete(false);
                          setShowIcd9Autocomplete(false);
                          handleCheckIcd(formInputDiagnosa.kd_icd);
                        } else if (e.key === 'Escape') {
                          setShowIcd10Autocomplete(false);
                          setShowIcd9Autocomplete(false);
                        }
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          setShowIcd10Autocomplete(false);
                          setShowIcd9Autocomplete(false);
                        }, 250);
                        if (formInputDiagnosa.kd_icd && !formInputDiagnosa.nm_icd) {
                          handleCheckIcd(formInputDiagnosa.kd_icd);
                        }
                      }}
                      placeholder={inputDiagnosaType === 'diagnosa'
                        ? "🔍  Ketik kode ICD-10 atau nama diagnosa..."
                        : "🔍  Ketik kode ICD-9-CM atau nama prosedur..."}
                      required
                      style={{
                        fontWeight: formInputDiagnosa.kd_icd ? 700 : 400,
                        fontFamily: 'monospace',
                        color: inputDiagnosaType === 'diagnosa' ? '#0369a1' : '#047857',
                        fontSize: '0.85rem',
                        borderColor: inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7',
                        borderLeft: 'none',
                        borderRight: 'none',
                        boxShadow: 'none'
                      }}
                    />
                    {formInputDiagnosa.kd_icd && (
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => {
                          setFormInputDiagnosa(prev => ({ ...prev, kd_icd: '', nm_icd: '' }));
                          setIcdCheckMsg(null);
                        }}
                        title="Hapus / Reset kode"
                        style={{ borderColor: '#d1d5db', borderLeft: 'none', borderRight: 'none' }}
                      >
                        <i className="bi bi-x-lg" style={{ fontSize: '0.75rem' }}></i>
                      </Button>
                    )}
                    <Button
                      variant={inputDiagnosaType === 'diagnosa' ? 'primary' : 'success'}
                      size="sm"
                      disabled={isCheckingIcd}
                      onClick={() => {
                        setShowIcd10Autocomplete(false);
                        setShowIcd9Autocomplete(false);
                        handleCheckIcd(formInputDiagnosa.kd_icd);
                      }}
                      title={inputDiagnosaType === 'prosedur' ? "Verifikasi Kode ICD-9 IM (tabel _idrg)" : "Verifikasi Kode ICD-10"}
                      style={{ fontSize: '0.75rem', fontWeight: 700, borderColor: inputDiagnosaType === 'diagnosa' ? '#93c5fd' : '#6ee7b7' }}
                    >
                      {isCheckingIcd ? <Spinner animation="border" size="sm" /> : <><i className="bi bi-patch-check me-1"></i>Verifikasi</>}
                    </Button>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => {
                        setShowIcd10Autocomplete(false);
                        setShowIcd9Autocomplete(false);
                        handleOpenMasterIcdModal(formInputDiagnosa.kd_icd);
                      }}
                      title={inputDiagnosaType === 'prosedur' ? "Buka Tabel Lengkap Master ICD-9 IM" : "Buka Tabel Lengkap Master ICD-10"}
                      style={{ fontSize: '0.75rem', borderColor: '#d1d5db' }}
                    >
                      <i className="bi bi-table me-1"></i>
                      <span style={{ fontSize: '0.7rem' }}>Tabel</span>
                    </Button>
                  </InputGroup>

                  {/* Autocomplete Popup — ICD-10 (Diagnosa) */}
                  {inputDiagnosaType === 'diagnosa' && showIcd10Autocomplete && (
                    <div style={{
                      position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1060,
                      maxHeight: '300px', overflowY: 'auto', background: '#ffffff',
                      border: '2px solid #3b82f6', borderRadius: '0 0 10px 10px',
                      boxShadow: '0 12px 28px rgba(59, 130, 246, 0.2)', marginTop: '-1px'
                    }}>
                      <div className="px-3 py-2 d-flex justify-content-between align-items-center sticky-top" style={{ background: '#eff6ff', borderBottom: '1px solid #bfdbfe', fontSize: '0.7rem' }}>
                        <span className="text-primary fw-bold d-flex align-items-center gap-1">
                          <i className="bi bi-journal-medical"></i>
                          Master ICD-10
                        </span>
                        <span className="badge bg-primary">
                          {isLoadingMasterIcd ? 'Memuat...' : (formInputDiagnosa.kd_icd ? `${filteredIcd10Suggestions.length} hasil` : `${filteredIcd10Suggestions.length} dari ${masterIcd10.length.toLocaleString('id-ID')}`)}
                        </span>
                      </div>
                      {isLoadingMasterIcd ? (
                        <div className="p-4 text-center text-muted" style={{ fontSize: '0.78rem' }}>
                          <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                          Memuat data ICD-10 dari server...
                        </div>
                      ) : filteredIcd10Suggestions.length > 0 ? (
                        filteredIcd10Suggestions.map((item, idx) => {
                          const code = item.icd || item.kode || item.kd_icd || '';
                          const desc = item.deskripsi || item.nm_icd || item.penyakit || '';
                          const isIm = item.im === 1 || item.im === '1';
                          return (
                            <div
                              key={`bpjs-icd10-${code}-${idx}`}
                              onMouseDown={() => { handleSelectIcd10FromDropdown(item); setShowIcd10Autocomplete(false); }}
                              style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', transition: 'background 0.1s' }}
                              className="d-flex align-items-center gap-2"
                              onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                              onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
                            >
                              <span className="badge bg-primary font-monospace" style={{ fontSize: '0.75rem', minWidth: '60px', textAlign: 'center' }}>{code}</span>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="fw-semibold text-dark text-truncate" style={{ fontSize: '0.78rem' }}>{desc}</div>
                                <div className="d-flex gap-1 mt-1">
                                  {isIm && <span className="badge bg-success" style={{ fontSize: '0.6rem' }}>IM</span>}
                                  {(item.validcode === 0 || item.validcode === '0' || item.validcode === false) && (
                                    <span className="badge bg-warning text-dark" style={{ fontSize: '0.6rem' }}>Header</span>
                                  )}
                                  {item.dtd && <span className="badge bg-secondary" style={{ fontSize: '0.6rem' }}>DTD: {item.dtd}</span>}
                                  {item.keterangan && <span className="badge bg-info text-dark" style={{ fontSize: '0.6rem' }}>{item.keterangan}</span>}
                                </div>
                              </div>
                              <i className="bi bi-arrow-return-left text-primary" style={{ fontSize: '0.8rem', flexShrink: 0 }}></i>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 text-center" style={{ fontSize: '0.78rem' }}>
                          <i className="bi bi-search text-muted fs-4 d-block mb-2"></i>
                          <div className="text-muted">Tidak ada hasil untuk <strong>"{formInputDiagnosa.kd_icd}"</strong></div>
                          <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>Coba ketik kode atau sebagian nama diagnosa</div>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Autocomplete Popup — ICD-9-CM (Prosedur) */}
                  {inputDiagnosaType === 'prosedur' && showIcd9Autocomplete && (
                    <div style={{
                      position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1060,
                      maxHeight: '300px', overflowY: 'auto', background: '#ffffff',
                      border: '2px solid #10b981', borderRadius: '0 0 10px 10px',
                      boxShadow: '0 12px 28px rgba(16, 185, 129, 0.2)', marginTop: '-1px'
                    }}>
                      <div className="px-3 py-2 d-flex justify-content-between align-items-center sticky-top" style={{ background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', fontSize: '0.7rem' }}>
                        <span className="text-success fw-bold d-flex align-items-center gap-1">
                          <i className="bi bi-list-check"></i>
                          Master ICD-9-CM IM
                        </span>
                        <span className="badge bg-success">
                          {isLoadingMasterIcd ? 'Memuat...' : (filteredIcd9Suggestions.length > 0 ? `${filteredIcd9Suggestions.length} hasil` : `${masterIcd9.length.toLocaleString('id-ID')} total`)}
                        </span>
                      </div>
                      {isLoadingMasterIcd ? (
                        <div className="p-4 text-center text-muted" style={{ fontSize: '0.78rem' }}>
                          <Spinner animation="border" size="sm" variant="success" className="me-2" />
                          Memuat data ICD-9-CM dari server...
                        </div>
                      ) : filteredIcd9Suggestions.length > 0 ? (
                        filteredIcd9Suggestions.map((item, idx) => {
                          const code = item.kode || item.icd || item.kd_icd || '';
                          const desc = item.deskripsi || item.nm_icd || '';
                          const isIm = item.im === 1 || item.im === '1';
                          const isAccpdxNo = String(item.accpdx || '').trim().toUpperCase() === 'N';
                          return (
                            <div
                              key={`bpjs-icd9-${code}-${idx}`}
                              onMouseDown={() => { handleSelectIcd9FromDropdown(item); setShowIcd9Autocomplete(false); }}
                              style={{ padding: '8px 12px', cursor: isAccpdxNo ? 'not-allowed' : 'pointer', borderBottom: '1px solid #f1f5f9', transition: 'background 0.1s', opacity: isAccpdxNo ? 0.75 : 1 }}
                              className="d-flex align-items-center gap-2"
                              onMouseEnter={e => e.currentTarget.style.background = isAccpdxNo ? '#fee2e2' : '#f0fdf4'}
                              onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
                            >
                              <span className={`badge ${isAccpdxNo ? 'bg-danger' : 'bg-success'} font-monospace`} style={{ fontSize: '0.75rem', minWidth: '70px', textAlign: 'center' }}>{code}</span>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div className="fw-semibold text-dark text-truncate" style={{ fontSize: '0.78rem' }}>{desc}</div>
                                <div className="d-flex gap-1 mt-1">
                                  {isIm && <span className="badge bg-warning text-dark" style={{ fontSize: '0.6rem' }}>IM — Indonesian Modification</span>}
                                  {isAccpdxNo && <span className="badge bg-danger" style={{ fontSize: '0.6rem' }}>accpdx: N (Tidak bisa dipilih)</span>}
                                </div>
                              </div>
                              <i className={`bi ${isAccpdxNo ? 'bi-slash-circle text-danger' : 'bi-arrow-return-left text-success'}`} style={{ fontSize: '0.8rem', flexShrink: 0 }}></i>
                            </div>
                          );
                        })
                      ) : masterIcd9.length === 0 ? (
                        <div className="p-4 text-center" style={{ fontSize: '0.78rem' }}>
                          <i className="bi bi-cloud-download text-muted fs-4 d-block mb-2"></i>
                          <div className="text-muted">Klik di atas untuk memuat data master ICD-9-CM</div>
                        </div>
                      ) : (
                        <div className="p-4 text-center" style={{ fontSize: '0.78rem' }}>
                          <i className="bi bi-search text-muted fs-4 d-block mb-2"></i>
                          <div className="text-muted">Tidak ada hasil untuk <strong>"{formInputDiagnosa.kd_icd}"</strong></div>
                          <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>Coba ketik kode seperti <code>87.41</code> atau nama prosedur</div>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Feedback validasi kode */}
                {icdCheckMsg && !/header code/i.test(icdCheckMsg.text || '') && (
                  <div className={`d-flex align-items-start gap-2 mt-2 p-2 rounded-2 ${icdCheckMsg.type === 'success' ? 'bg-success bg-opacity-10 border border-success border-opacity-25' : 'bg-danger bg-opacity-10 border border-danger border-opacity-25'}`} style={{ fontSize: '0.75rem' }}>
                    <i className={`bi ${icdCheckMsg.type === 'success' ? 'bi-check-circle-fill text-success' : 'bi-exclamation-triangle-fill text-danger'} mt-1 flex-shrink-0`}></i>
                    <span className={`fw-semibold ${icdCheckMsg.type === 'success' ? 'text-success' : 'text-danger'}`}>{icdCheckMsg.text}</span>
                  </div>
                )}

                {/* Preview kode terpilih */}
                {formInputDiagnosa.kd_icd && formInputDiagnosa.nm_icd && (
                  <div className={`d-flex align-items-center gap-2 mt-2 p-2 rounded-2 ${inputDiagnosaType === 'diagnosa' ? 'bg-primary bg-opacity-10 border border-primary border-opacity-25' : 'bg-success bg-opacity-10 border border-success border-opacity-25'}`}>
                    <i className={`bi bi-bookmark-check-fill ${inputDiagnosaType === 'diagnosa' ? 'text-primary' : 'text-success'} flex-shrink-0`}></i>
                    <div style={{ fontSize: '0.75rem' }}>
                      <span className={`badge ${inputDiagnosaType === 'diagnosa' ? 'bg-primary' : 'bg-success'} font-monospace me-2`}>{formInputDiagnosa.kd_icd}</span>
                      <span className="fw-semibold text-dark">{formInputDiagnosa.nm_icd}</span>
                    </div>
                  </div>
                )}
              </div>

              {/* ── Detail Deskripsi Prosedur / Diagnosa ── */}
              <div className="mb-2">
                <Form.Label className="fw-bold text-dark mb-1 d-flex align-items-center justify-content-between" style={{ fontSize: '0.75rem' }}>
                  <span className={inputDiagnosaType === 'prosedur' ? "text-success" : "text-primary"}>
                    <i className={`bi ${inputDiagnosaType === 'prosedur' ? 'bi-file-medical' : 'bi-clipboard2-pulse'} me-1`}></i>
                    {inputDiagnosaType === 'prosedur' ? 'Deskripsi Prosedur (ICD-9-CM)' : 'Nama Diagnosa (ICD-10)'}
                  </span>
                  {formInputDiagnosa.kd_icd && (
                    <span className="badge bg-light text-secondary border font-monospace" style={{ fontSize: '0.68rem' }}>
                      Kode: {formInputDiagnosa.kd_icd}
                    </span>
                  )}
                </Form.Label>
                <Form.Control
                  size="sm"
                  value={formInputDiagnosa.nm_icd}
                  onChange={e => setFormInputDiagnosa({ ...formInputDiagnosa, nm_icd: e.target.value })}
                  placeholder={inputDiagnosaType === 'prosedur' ? "Deskripsi prosedur ICD-9-CM (terisi otomatis saat verifikasi/pilih dari daftar)" : "Nama/deskripsi diagnosa ICD-10 (terisi otomatis saat verifikasi/pilih dari daftar)"}
                  required
                  style={{ fontWeight: 600, fontSize: '0.82rem' }}
                />
              </div>

              {/* ── Multiplicity (Qty) Prosedur (Posisi Di Bawah Deskripsi) ── */}
              {inputDiagnosaType === 'prosedur' && (
                <div className="mb-3 p-2 rounded-3 border" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
                  <Row className="align-items-center g-2">
                    <Col md={5}>
                      <Form.Label className="fw-bold text-dark mb-0 d-flex align-items-center justify-content-between" style={{ fontSize: '0.74rem' }}>
                        <span className="d-flex align-items-center gap-1 text-success">
                          <i className="bi bi-x-octagon-fill"></i> Multiplicity (Qty Tindakan)
                        </span>
                        <span className="badge bg-success text-white" style={{ fontSize: '0.68rem', padding: '2px 8px' }}>
                          x{formInputDiagnosa.multiplicity || 1}
                        </span>
                      </Form.Label>
                      <div className="text-muted" style={{ fontSize: '0.67rem' }}>
                        Jumlah repetisi prosedur dalam 1 sesi (standar Kemenkes iDRG)
                      </div>
                    </Col>
                    <Col md={7}>
                      <div className="d-flex align-items-center gap-2">
                        <InputGroup size="sm" style={{ width: '120px' }}>
                          <Button
                            variant="outline-secondary"
                            style={{ fontSize: '0.75rem', padding: '0 8px' }}
                            onClick={() => handleMultiplicityChange(Math.max(1, (Number(formInputDiagnosa.multiplicity) || 1) - 1))}
                            title="Kurangi multiplicity"
                          >
                            <i className="bi bi-dash-lg"></i>
                          </Button>
                          <Form.Control
                            type="number"
                            min={1}
                            max={99}
                            value={formInputDiagnosa.multiplicity || 1}
                            onChange={e => handleMultiplicityChange(e.target.value)}
                            className="text-center font-monospace fw-bold"
                            style={{ fontSize: '0.82rem', borderColor: '#10b981' }}
                          />
                          <Button
                            variant="outline-secondary"
                            style={{ fontSize: '0.75rem', padding: '0 8px' }}
                            onClick={() => handleMultiplicityChange((Number(formInputDiagnosa.multiplicity) || 1) + 1)}
                            title="Tambah multiplicity"
                          >
                            <i className="bi bi-plus-lg"></i>
                          </Button>
                        </InputGroup>
                        <div className="d-flex gap-1 flex-grow-1">
                          {[1, 2, 3, 4, 5].map(n => (
                            <Button
                              key={n}
                              variant={Number(formInputDiagnosa.multiplicity || 1) === n ? "success" : "outline-secondary"}
                              size="sm"
                              className="py-1 px-1 font-monospace"
                              style={{ fontSize: '0.68rem', flex: 1 }}
                              onClick={() => handleMultiplicityChange(n)}
                            >
                              x{n}
                            </Button>
                          ))}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}

              {/* ── Footer Tombol ── */}
              <div className="d-flex justify-content-between align-items-center border-top pt-3">
                <div style={{ fontSize: '0.72rem', color: '#64748b' }}>
                  <i className="bi bi-database-check me-1 text-success"></i>
                  Data tersimpan ke tabel <strong>{inputDiagnosaType === 'prosedur' ? 'diagnosa3' : 'diagnosa2'}</strong>
                </div>
                <div className="d-flex gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={() => setShowInputDiagnosaModal(false)} disabled={isSavingDiagnosa}
                    style={{ fontSize: '0.78rem' }}>
                    <i className="bi bi-x-circle me-1"></i>Batal
                  </Button>
                  <Button
                    variant={inputDiagnosaType === 'prosedur' ? 'success' : 'primary'}
                    size="sm"
                    type="submit"
                    disabled={isSavingDiagnosa || !formInputDiagnosa.kd_icd}
                    className="fw-bold d-flex align-items-center gap-2 shadow-sm px-3"
                    style={{
                      background: inputDiagnosaType === 'prosedur' ? 'linear-gradient(135deg, #059669 0%, #047857 100%)' : 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)',
                      border: 'none', fontSize: '0.82rem'
                    }}
                  >
                    {isSavingDiagnosa
                      ? <><Spinner animation="border" size="sm" /><span>Menyimpan...</span></>
                      : <><i className="bi bi-check-circle-fill"></i><span>{inputDiagnosaType === 'prosedur' ? 'Simpan ke diagnosa3' : 'Simpan ke diagnosa2'}</span></>
                    }
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ══ MODAL TABEL MASTER ICD-10 & ICD-9 IM ══ */}
      <Modal show={showMasterIcdModal} onHide={() => setShowMasterIcdModal(false)} centered backdrop="static" size="xl">
        <Modal.Header closeButton style={{ background: inputDiagnosaType === 'prosedur' ? 'linear-gradient(135deg, #065f46 0%, #047857 100%)' : 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.92rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className={`bi ${inputDiagnosaType === 'prosedur' ? 'bi-scissors' : 'bi-journal-medical'} fs-5`}></i>
            <span>{inputDiagnosaType === 'prosedur' ? 'Master Data Prosedur ICD-9 IM (/show_icdixim)' : 'Master Data Diagnosa ICD-10 (/show_icdxim)'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
            <InputGroup size="sm" style={{ maxWidth: '420px' }}>
              <InputGroup.Text style={{ background: '#fff' }}>
                <i className="bi bi-search text-muted"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder={inputDiagnosaType === 'prosedur' ? "Filter kode ICD-9, deskripsi prosedur, IM..." : "Filter kode ICD, deskripsi diagnosa..."}
                value={masterIcdModalSearch}
                onChange={e => {
                  setMasterIcdModalSearch(e.target.value);
                  setMasterIcdCurrentPage(1);
                }}
                autoFocus
              />
              {masterIcdModalSearch && (
                <Button variant="outline-secondary" onClick={() => setMasterIcdModalSearch('')}>
                  <i className="bi bi-x"></i>
                </Button>
              )}
            </InputGroup>
            <div className="text-muted" style={{ fontSize: '0.75rem' }}>
              Total Data: <strong>{inputDiagnosaType === 'prosedur' ? masterIcd9.length : masterIcd10.length}</strong> master item
            </div>
          </div>

          {isLoadingMasterIcd ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" size="sm" className="me-2" />
              <span>Memuat data master {inputDiagnosaType === 'prosedur' ? 'prosedur (/show_icdixim)...' : 'ICD-10 (/show_icdxim)...'}</span>
            </div>
          ) : (
            (() => {
              const q = masterIcdModalSearch.toLowerCase().trim();
              const sourceList = inputDiagnosaType === 'prosedur' ? masterIcd9 : masterIcd10;
              const filtered = sourceList.filter(item => {
                if (!q) return true;
                const icd = (item.icd || item.kode || item.kd_icd || '').toLowerCase();
                const nm = (item.deskripsi || item.nm_icd || item.penyakit || '').toLowerCase();
                const dtd = (item.dtd || '').toLowerCase();
                const pyk = (item.penyakit || '').toLowerCase();
                const ket = (item.keterangan || '').toLowerCase();
                const im = String(item.im || '');
                return icd.includes(q) || nm.includes(q) || dtd.includes(q) || pyk.includes(q) || ket.includes(q) || (q === 'im' && (im === '1'));
              });

              const totalRows = filtered.length;
              const totalPages = Math.ceil(totalRows / masterIcdItemsPerPage) || 1;
              const startIdx = (masterIcdCurrentPage - 1) * masterIcdItemsPerPage;
              const pageRows = filtered.slice(startIdx, startIdx + masterIcdItemsPerPage);

              return (
                <div>
                  <div className="table-responsive" style={{ maxHeight: '420px', overflowY: 'auto' }}>
                    <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                      <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 1 }}>
                        <tr>
                          <th className="text-center" style={{ width: '45px' }}>No</th>
                          <th className="text-center" style={{ width: '120px' }}>{inputDiagnosaType === 'prosedur' ? 'Kode ICD-9' : 'Kode ICD-10'}</th>
                          <th>{inputDiagnosaType === 'prosedur' ? 'Deskripsi Prosedur (ICD-9-CM)' : 'Deskripsi Diagnosa (ICD-10)'}</th>
                          {inputDiagnosaType === 'diagnosa' && <th className="text-center" style={{ width: '85px' }}>Validitas</th>}
                          <th className="text-center" style={{ width: '90px' }}>Status IM</th>
                          <th className="text-center" style={{ width: '95px' }}>accpdx</th>
                          <th className="text-center" style={{ width: '90px' }}>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pageRows.length > 0 ? (
                          pageRows.map((row, idx) => (
                            <tr key={idx} style={{ cursor: 'pointer' }} onDoubleClick={() => handleSelectMasterIcdRow(row)}>
                              <td className="text-center text-muted">{startIdx + idx + 1}</td>
                              <td className="text-center">
                                <Badge bg={inputDiagnosaType === 'prosedur' ? 'success' : 'primary'} className="font-monospace">
                                  {row.icd || row.kode || row.kd_icd}
                                </Badge>
                              </td>
                              <td className="fw-semibold text-dark">{row.deskripsi || row.nm_icd || row.penyakit}</td>
                              {inputDiagnosaType === 'diagnosa' && (
                                <td className="text-center">
                                  {(row.validcode === 0 || row.validcode === '0' || row.validcode === false) ? (
                                    <Badge bg="warning" text="dark" style={{ fontSize: '0.68rem' }} title="Header Code">Header</Badge>
                                  ) : (
                                    <Badge bg="success" style={{ fontSize: '0.68rem' }}>Valid</Badge>
                                  )}
                                </td>
                              )}
                              <td className="text-center">
                                {(row.im === 1 || row.im === '1') ? <Badge bg="warning" text="dark">IM</Badge> : <span className="text-muted">—</span>}
                              </td>
                              <td className="text-center">
                                {row.accpdx === 'Y' || row.accpdx === '1' ? (
                                  <Badge bg="primary" style={{ fontSize: '0.68rem' }}>Ya (PDx)</Badge>
                                ) : String(row.accpdx || '').trim().toUpperCase() === 'N' ? (
                                  <Badge bg="danger" style={{ fontSize: '0.68rem' }} title={inputDiagnosaType === 'prosedur' ? 'accpdx = N (Tidak bisa dipilih)' : 'accpdx = N (Hanya untuk sekunder)'}>
                                    N {inputDiagnosaType === 'prosedur' ? '(Tidak Bisa)' : ''}
                                  </Badge>
                                ) : (
                                  <span className="text-muted" style={{ fontSize: '0.68rem' }}>{row.accpdx || '—'}</span>
                                )}
                              </td>
                              <td className="text-center">
                                <Button
                                  variant={inputDiagnosaType === 'prosedur'
                                    ? (String(row.accpdx || '').trim().toUpperCase() === 'N' ? 'outline-danger' : 'outline-success')
                                    : 'outline-primary'
                                  }
                                  size="sm"
                                  style={{ fontSize: '0.7rem', padding: '2px 8px' }}
                                  onClick={() => handleSelectMasterIcdRow(row)}
                                >
                                  {inputDiagnosaType === 'prosedur' && String(row.accpdx || '').trim().toUpperCase() === 'N' ? (
                                    <><i className="bi bi-x-circle me-1"></i>Tidak Bisa</>
                                  ) : (
                                    'Pilih'
                                  )}
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={inputDiagnosaType === 'diagnosa' ? 7 : 6} className="text-center py-4 text-muted">
                              Tidak ada data yang cocok dengan pencarian "{masterIcdModalSearch}".
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                      <div className="text-muted" style={{ fontSize: '0.72rem' }}>
                        Menampilkan {startIdx + 1} - {Math.min(startIdx + masterIcdItemsPerPage, totalRows)} dari {totalRows} data
                      </div>
                      <Pagination size="sm" className="mb-0">
                        <Pagination.Prev disabled={masterIcdCurrentPage === 1} onClick={() => setMasterIcdCurrentPage(p => Math.max(1, p - 1))} />
                        <Pagination.Item active>{masterIcdCurrentPage} / {totalPages}</Pagination.Item>
                        <Pagination.Next disabled={masterIcdCurrentPage === totalPages} onClick={() => setMasterIcdCurrentPage(p => Math.min(totalPages, p + 1))} />
                      </Pagination>
                    </div>
                  )}
                </div>
              );
            })()
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL KONFIRMASI HAPUS DIAGNOSA / PROSEDUR ══ */}
      <Modal show={deleteConfirmModal.show} onHide={() => !deleteConfirmModal.isDeleting && setDeleteConfirmModal(prev => ({ ...prev, show: false }))} centered backdrop="static" size="sm">
        <Modal.Header closeButton={!deleteConfirmModal.isDeleting} style={{ background: '#dc2626', color: '#fff', padding: '10px 14px' }}>
          <Modal.Title style={{ fontSize: '0.88rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-trash-fill"></i>
            <span>Hapus {deleteConfirmModal.type === 'prosedur' ? 'Prosedur' : 'Diagnosa'} Pasien</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <div className="text-center mb-3">
            <i className="bi bi-exclamation-triangle-fill text-danger fs-1 d-block mb-2"></i>
            <div className="fw-bold text-dark" style={{ fontSize: '0.88rem' }}>
              Apakah Anda yakin ingin menghapus {deleteConfirmModal.type === 'prosedur' ? 'prosedur' : 'diagnosa'} ini?
            </div>
            {deleteConfirmModal.item && (
              <div className="mt-2 p-2 rounded bg-white border text-start" style={{ fontSize: '0.78rem' }}>
                <div><strong>Kode:</strong> <span className="badge bg-danger font-monospace">{deleteConfirmModal.item.kd_icd}</span></div>
                <div className="text-truncate mt-1"><strong>Deskripsi:</strong> {deleteConfirmModal.item.nama_icd || deleteConfirmModal.item.nm_icd}</div>
                <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>
                  Target tabel: <strong>{deleteConfirmModal.type === 'prosedur' ? 'diagnosa3' : 'diagnosa2'}</strong>
                </div>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end gap-2 pt-2 border-top">
            <Button
              variant="secondary"
              size="sm"
              disabled={deleteConfirmModal.isDeleting}
              onClick={() => setDeleteConfirmModal(prev => ({ ...prev, show: false }))}
              style={{ fontSize: '0.78rem' }}
            >
              Batal
            </Button>
            <Button
              variant="danger"
              size="sm"
              disabled={deleteConfirmModal.isDeleting}
              onClick={handleExecuteDeleteDiagnosa}
              className="fw-bold d-flex align-items-center gap-1"
              style={{ fontSize: '0.78rem' }}
            >
              {deleteConfirmModal.isDeleting ? <Spinner animation="border" size="sm" /> : <i className="bi bi-trash-fill"></i>}
              <span>{deleteConfirmModal.isDeleting ? 'Menghapus...' : 'Ya, Hapus'}</span>
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/* ══ GLOBAL FLOATING TOAST NOTIFICATION ══ */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 99999, position: 'fixed' }}>
        <Toast
          show={toastNotif.show}
          onClose={() => setToastNotif(prev => ({ ...prev, show: false }))}
          delay={4500}
          autohide
          style={{
            minWidth: '320px',
            maxWidth: '420px',
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            border: 'none',
            overflow: 'hidden'
          }}
        >
          <Toast.Header
            style={{
              background: toastNotif.type === 'success' ? '#10b981'
                : toastNotif.type === 'warning' ? '#f59e0b'
                : toastNotif.type === 'danger' ? '#ef4444'
                : '#0284c7',
              color: '#fff',
              borderBottom: 'none',
              padding: '8px 12px'
            }}
          >
            <i className={`bi ${
              toastNotif.type === 'success' ? 'bi-check-circle-fill'
              : toastNotif.type === 'warning' ? 'bi-exclamation-triangle-fill'
              : toastNotif.type === 'danger' ? 'bi-x-circle-fill'
              : 'bi-info-circle-fill'
            } me-2 fs-6`}></i>
            <strong className="me-auto" style={{ fontSize: '0.85rem' }}>{toastNotif.title || 'Pemberitahuan'}</strong>
            <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.7rem' }}>Baru saja</small>
          </Toast.Header>
          <Toast.Body style={{ fontSize: '0.78rem', background: '#fff', color: '#1e293b', padding: '10px 12px' }}>
            {toastNotif.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>

    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex', flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem', flexShrink: 0,
  },
  mainContent: {
    flex: 1, padding: '0.4rem', overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px', border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff', overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem', color: '#ffffff', fontWeight: 600, fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
};

export default DataClaimBpjs;
